export const agendaSessions = [
    {
        "id": "UGxhbm5pbmdfMjY1MzQ3MQ==",
        "titleTranslations": [
            {
                "value": "Registration",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-11 13:00:00",
        "endsAt": "2025-05-11 15:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4Mzk5Ng==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "Registration",
                "translations": [
                    {
                        "value": "Registration"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjM0Ng==",
        "titleTranslations": [
            {
                "value": "Welcome to NextGen Investment Forum",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-11 15:00:00",
        "endsAt": "2025-05-11 15:10:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=AcQRgPNGeDQ\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzMxNDMyMjY0LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman & CEO",
                "lastName": "Worsley",
                "photoUrl": "https://static.swapcard.com/public/images/65ef700e7da4493ea8d79d2e53ba7532.jpeg",
                "organization": "The Bench",
                "biography": "Jonathan Worsley began his career at Forte and Holiday Inns before moving into hotel advisory roles at PKF and CBRE. In 1997, he co-founded IHIF Berlin, followed by The Bench, which started as a daily benchmarking company for the hotel industry and in 2008 merging with STR to create STR Global.  \n\nThe Bench evolved into a leading organiser of premier hospitality investment conferences and Jonathan continued bringing the hospitality investment community together in various parts of the world through AHIC - now Future Hospitality Summit (FHS), FHS Saudi, FHS Africa and SAHIC in Latin America. Later, he expanded into aviation and F&B with AviaDev and GRIF. \n\nIn 2020, Jonathan led The Bench’s pivot to virtual events, launching Hospitality Tomorrow and FHS for the G20 Saudi Secretariat. He continues to drive industry innovation through initiatives like the Startup Den and Lead the Change while serving on the boards of Fresh on Table, Envi Lodges, and other startups shaping the future of hospitality. \n\nHe is also a trustee of the World Sustainable Hospitality Alliance, Future Talent – a musical charity, a member of Women in Hospitality (WiH) and recently completed a board term with the Ras Al Khaimah Tourism Development Authority.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjU5MTE4NA==",
        "titleTranslations": [
            {
                "value": "Vision for Global Tourism: A Conversation with Harry Theoharis, Candidate for UN Tourism Secretary-General",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-11 15:10:00",
        "endsAt": "2025-05-11 15:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=t6qm5SxrMQo\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Aradhana",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MTA1Mjk2LFVzZXJfMTAwMzI1ODMp",
                "jobTitle": "CEO & Regenerative Tourism Expert",
                "lastName": "Khowala",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/1db9674ed24c4de5807e41f7e15ac1f1.jpeg",
                "organization": "Aptamind Partners",
                "biography": "Aradhana Khowala is globally identified as an authority on the travel, tourism, and hospitality industries and has over two decades of experience across 75 countries in 5 continents. She is currently CEO & Founder of Aptamind Partners a Private Client Advisory that is a trusted advisor to ambitious leaders in Governments, Family Offices, Private UHNW Attendeess, and International Organisations. Previously she was the MD of the Tourism Sector at NEOM - the US$ 500 Billion land of the future purpose built for a sustainable and a new way of living.\n\nAn experienced Board Member she has an active portfolio of Board roles and currently serves as the Chair of the Advisory Board of the Red Sea Project in Saudi Arabia which is a signature “Giga” project of Saudi Arabia Vision 2030, which, through breakthrough models for international tourism, sets new standards for sustainable development and environmental stewardship.\n\nAradhana also serves as a Board Member and Steering Committee member of World Tourism Forum Lucerne a highly focused, top level, strategic body that brings together selected leaders around the world to reflect on the big challenges facing the industry. She is also a Board Member of Elaf Group, the leisure arm of a sustainable and publicly listed holding company - SEDCO. In the past, she has worked for Jones Lang LaSalle, covering the UK, Benelux, and Scandinavian markets, a Strategy Consulting practice in Europe and Asia as well as in Hospitality Operations in India.\n\nAradhana has won multiple awards including the 21st Century Icon Awards in 2017 in association with CNBC and the London School of Economics as an Inspirational Game Changer in Tourism. In 2014, she was featured as one of the 50 most Influential Next Generation leaders who will likely define the future of the Tourism sector by Swiss Economic magazine Bilan (Forbes equivalent), and in 2021 she was featured as an inspirational woman rethinking a sustainable future of tourism by City Nation Place.\n\nA keen industry practitioner, she is a regular speaker and moderator well known for her international advocacy on sustainable tourism, climate change, women and diversity and has participated in global policy discussions in United Nations bodies, WEF as well as the G20 apart from some of the foremost Family Office conferences as well as Tourism and Leadership Summits around the world. She read at Cornell University in the US, is a certified NLP Coach, has an MBA from Ecole Hôtelière de Lausanne in Switzerland, and an International Director Certification from INSEAD in France.\n\nA passionate advocate of the transformative power of tourism and the prospect it presents for combining conservation with community, culture, and commerce, she spends a lot of her time engaging Presidents, Prime Ministers, and Tourism Ministers lobbying for travel and tourism as a force for good. She also guest lectures on tourism, authentic leadership, and entrepreneurship at different Universities globally.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5MjI0NQ==",
                                    "title": "Data Talks: The Future of Wellness - New Data on Wellness Travel",
                                    "beginsAt": "2024-04-29 13:50:00",
                                    "endsAt": "2024-04-29 14:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Mw==",
                                    "title": "TenX Leadership Talks: The Longevity Revolution and what the 100-year Life means for You and the Future of Hospitality",
                                    "beginsAt": "2024-04-30 14:00:00",
                                    "endsAt": "2024-04-30 14:25:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Harry",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MTA1MzA1LFVzZXJfMjM3NTE0MTgp",
                "jobTitle": "Member of Parliament, Hellenic Parliament",
                "lastName": "Theoharis",
                "photoUrl": "https://static.swapcard.com/public/images/30a65492fbff4edcb104c974fa9a4643.jpeg",
                "organization": "Candidate for UN Tourism Secretary-General",
                "biography": "Mr. Theoharis holds an MEng (Hon) in Software Engineering from Imperial College, London.\nFrom 2019 to 202, he served as Minister of Tourism, where he focused on rejuvenating Greece’s tourism sector, particularly in the wake of the COVID-19 pandemic.\nOn June 2023, Mr. Theoharis was appointed  as Deputy Minister of Finance until June 2024. \nIn the fall of 2024, Harry Theoharis took on a new challenge: running for Secretary-General of the UN Tourism, with the endorsement of Prime Minister Kyriakos Mitsotakis. His vision is to lead a global effort for a more dynamic, modern, digital, and effective organization.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjM4NA==",
        "titleTranslations": [
            {
                "value": "Rethinking Hospitality Schools: Education, Experience & Environment",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-11 15:30:00",
        "endsAt": "2025-05-11 16:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=zctm6b3coyw\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzYxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "nextgen-talent-and-hospitality-education",
                "translations": [
                    {
                        "value": "NextGen Talent & Hospitality Education"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Dr․Fabien",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NzI2NjkyLFVzZXJfMjM1MzAyMzEp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Fresnel",
                "photoUrl": "https://static.swapcard.com/public/images/d3fc4fead393401eb9b123f9d14e190e.jpeg",
                "organization": "The Riyadh School of Tourism and Hospitality",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Arjun",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NjM5NDU3LFVzZXJfODc5NTA1OCk=",
                "jobTitle": "Founding Director",
                "lastName": "Singh",
                "photoUrl": "https://static.swapcard.com/public/images/1fb7dff7af2d430e9959241d9694222f.jpeg",
                "organization": "Hospitality and Tourism Management  Robert C. Vackar College of Business & Entrepreneurship",
                "biography": "A.J. Singh is the Founding Director of Hospitality and Tourism Management at UTRGV. With over 20 years in Hospitality Higher Education he has over 150 publications to his credit and co-authored four textbooks, on International Hotel Management (2008) and Hospitality Asset Management (2009, 2015), and Best Practices in Sustainable Hotel Development and Operations was published in March, 2011. Dr. Singh was jointly responsible for the establishment of The Hospitality Business Real Estate Investment Management Minor in The School of Hospitality Business at Michigan State University. He has taught Hospitality Business Real Estate, International Lodging Development and Management and Financial Management courses at Michigan State University. He is an active member of HAMA (Hospitality Asset Managers Association) CHRIE (Council of Hotel, Restaurant and Institutional Education) and AHFME (Association of Hospitality Financial Management Educators) ISHC (International Society of Hospitality Consultants) and ULI (Urban Land Institute). Dr. Singh works closely with the Center for International Business Education and Research (CIBER) at Michigan State University. Dr. Singh's has over 15 years of hospitality business experience in various management positions in the USA and India. He has worked for Oberoi Hotels, Stouffer Hotels, Hyatt Hotels and Laventhol & Horwath. He has consulted with various Hospitality organizations for the past 15 years and helped establish the Hospitality Program at the Singapore Institute of Technology in 2014.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Glenn",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5NDk3LFVzZXJfMTU3NTczMjQp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Mandziuk",
                "photoUrl": "https://static.swapcard.com/public/images/b19e8296c97244568fcf237831af441c.jpeg",
                "organization": "World Sustainable Hospitality Alliance",
                "biography": "Glenn Mandziuk is the Chief Executive Officer of the World Sustainable Hospitality Alliance – the leading global network in responsible hospitality. He is an internationally recognised CEO with over 25 years of leadership experience in advancing sustainable practices in tourism, hospitality and economic development, and establishing strategies and programmes that inspire responsible growth. \nWithin his role as CEO of the Alliance, Glenn has led the development of the organisation’s updated Pathway to Net Positive Hospitality, which enables all hotels to work towards having a net positive impact, no matter their starting point. Together with the Alliance’s Head of Business Development, Glenn has substantially expanded the organisation’s network for responsible hospitality, which now represents over 50,000 hotels, equating to 7 million rooms, along with a wide network of over 30 expert partners. What’s more, Glenn has been the pioneer behind multiple high-level Sustainable Hospitality Alliance Summits, which bring together CEO and C-suite leaders from across the Alliance’s membership. Alongside his leadership of the Alliance, Glenn has been chosen to be Co-chair of the Sustainable Markets Initiative Hospitality and Tourism Task Force, alongside Considerate Group Co-founding Partner, Xenia zu Hohenlohe. The Task Force focuses on creating new business models, reducing emissions, and investing in people to support a sustainable hospitality and tourism sector and communities. He has also been appointed as member of the Institute of Tourism and Hospitality Professional (ITHP) Advisory Council, and the International CHRIE Industry Advisory Council (IAC), the first of its kind in the organisation’s 75-year history.\nPrior to becoming CEO of the Sustainable Hospitality Alliance, Glenn was President and Chief Executive Officer of Canada’s Thompson Okanagan Tourism Region (TOTA) with its 4,000 industry stakeholders. Glenn’s leadership resulted in the organisation being recognised as a global champion of excellence and innovation in sustainable destination management and responsible industry development practices. The team received recognition from the United Nations World Tourism Organisation (UNWTO), World Travel and Tourism Council (WTTC), World Travel Awards, and Responsible Tourism Institute’s Biosphere Gold Certification – a first in the Americas. In addition, the UNWTO awarded TOTA Quest Certification for excellence in leadership, execution and governance capacities – only the third such recognition for a destination management organisation bestowed in the world.\nGlenn has 10 years’ experience in the hospitality industry in family-owned and operated hotels and resorts and holds a Master of Environmental Design degree majoring in sustainable tourism planning. He is also a director on the Board of the Global Sustainable Tourism Council and the Responsible Tourism Institute.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2MA==",
                                    "title": "Sustainable Horizons: Catalyzing Change Through Green Investments",
                                    "beginsAt": "2024-04-30 12:25:00",
                                    "endsAt": "2024-04-30 12:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg4MjUwMg==",
                                    "title": "Data Talks: Why ESG data and benchmarking is key to continuing the Hospitality sector's global growth.",
                                    "beginsAt": "2024-04-29 14:35:00",
                                    "endsAt": "2024-04-29 14:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Muin",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3MjI0MDc0LFVzZXJfMjA3ODc2NzAp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Serhan",
                "photoUrl": "https://static.swapcard.com/public/images/2ca186381f1a453c84f2b9e39d502d5b.jpeg",
                "organization": "Amsa Hospitality",
                "biography": "Driving Amsa Hospitality’s business growth as Chief Executive Officer, Muin leverages his 24 years of global experience with leading hotel chains to guide the team toward long-term success. His career as an award-winning hotelier has showcased his ability to build and operate successful mega properties, even in upscale locations. A prolific public speaker, Muin’s achievements have earned him numerous accolades within the hospitality industry both in the Kingdom and abroad.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "NextGen Talent & Hospitality Education"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjM4MQ==",
        "titleTranslations": [
            {
                "value": "UN Tourism Presents: Tourism Education Guidelines",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-11 16:00:00",
        "endsAt": "2025-05-11 16:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=sbxD3GDtr3c\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzYxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "nextgen-talent-and-hospitality-education",
                "translations": [
                    {
                        "value": "NextGen Talent & Hospitality Education"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Luis Nicolas",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5OTgwLFVzZXJfMTE4OTk5NTQp",
                "jobTitle": "Regional Manager Innovation Education and Investment",
                "lastName": "Barrios",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/3e48bf508a3f4f5a855d9b179a19b4ec.jpeg",
                "organization": "UN Tourism",
                "biography": "Luis Nicolás Barrios Medina-Montoya, Innovation Education and Investments Regional Manager for the UNWTO Regional Office in Riyadh. \n\nMaster in Project Management from Esden Business School. PMI-certified PMP. Master in Marketing and Commercial Management from IE Business School. Master in Audio-visual Production from IEEA. Degree in Audio-visual Communication from the University of Malaga. \n\nExpert in technology and innovation applied to the tourism sector. From February 2003 until June 2020, he developed his professional career in Tourism in SEGITTUR, a state-owned company integrated into the Spanish Ministry of Industry Trade and Tourism and attached to the State Secretariat for Tourism, responsible for promoting innovation (R&D) in the Spanish tourism sector, both in the public sector.      \n\nSince 2012 he was involved, in different capacities, in the development and management of the Smart Tourist Destinations program. From 2019 to 2022 he was responsible for the direction and coordination of all the Smart Tourism Destination Projects in Latin America, coordinating projects in Tequila, Medellín and Bogotá.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5MA==",
                                    "title": "Shaping the Kingdom's Destiny: Cultivating Excellence in Hospitality to Shaping Policies and Initiatives that Contribute to Making Hospitality a Great Industry to Work in",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "NextGen Talent & Hospitality Education"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjY3MTA4Mw==",
        "titleTranslations": [
            {
                "value": "Announcements & Signings",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-11 16:00:00",
        "endsAt": "2025-05-11 17:00:00",
        "descriptionTranslations": [
            {
                "value": "<br />",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNTg4MzM4MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "centre-stage",
                "translations": [
                    {
                        "value": "Centre Stage"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [],
        "priority": 10
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQ4Mw==",
        "titleTranslations": [
            {
                "value": "How Can We Rebrand Hospitality Careers to Attract Saudi Youth?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-11 16:15:00",
        "endsAt": "2025-05-11 16:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=n_zb3ttxSNs\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzYxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "nextgen-talent-and-hospitality-education",
                "translations": [
                    {
                        "value": "NextGen Talent & Hospitality Education"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Dr. Abeer",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NTg1MDM1LFVzZXJfMjM0NTI1MzYp",
                "jobTitle": "Skills Development and Talent Optimization Expert",
                "lastName": "Alamri",
                "photoUrl": "https://static.swapcard.com/public/images/a96df3d5f0c84807a351df07dfc4e15c.jpeg",
                "organization": "",
                "biography": "Dr. Alamri is an expert psychometrician and certified evaluator with extensive experience in building capabilities and enhancing human capital quality across both government and private sectors. She has achieved impactful outcomes through her professional expertise in constructing scales and measuring knowledge, attitudes, and public opinion. Dr. Alamri has significant experience in developing indicators, as well as quality and performance standards. She has also contributed to the establishment of evidence-based decision support systems. Driven by a passion for understanding human behavior through data analytics, Dr. Alamri aims to improve the quality of education, work, and life for individuals.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Lameese",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NzI2NjY0LFVzZXJfMjM1MzAyMTAp",
                "jobTitle": "Senior Education Specialist",
                "lastName": "Damiri",
                "photoUrl": "https://static.swapcard.com/public/images/6f7ac5e6899849429e30e768190d52aa.jpeg",
                "organization": "UNTourism",
                "biography": "Lameese Damiri is an education professional with international experience, dedicated to advancing in the field of education. With advanced degrees and doctoral studies, she brings extensive academic expertise to her work. In her role as a Senior Education Specialist at United Nations Tourism, she develops initiatives that bridge education and industry, equipping the future workforce with essential skills. Her commitment to excellence in education delivery, research, and capacity building drives lasting change in the tourism industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Ibrahim",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4NTMzMDczLFVzZXJfMjM5ODEzMjUp",
                "jobTitle": "Global Tourism Lead and Senior Economic Growth Advisor",
                "lastName": "Osta",
                "photoUrl": "https://static.swapcard.com/public/images/303983429b0e479694156475cf332e22.jpeg",
                "organization": "Chemonics International",
                "biography": "Ibrahim Osta is a recognized leader in international tourism, renowned for strategically transforming emerging markets into globally recognized destinations. With over 25 years of experience, he has managed projects exceeding $350 million, generating over $6 billion in GDP growth and hundreds of millions in tourism revenue. He is a Global Travel Hall of Fame inductee alongside industry leaders such as Sir Richard Branson and Jerry Inzerillo.\n\nHe advises governments on tourism policy reforms to build resilience, attract investment, and promote culturally and environmentally sustainable tourism in MENA, the Caucasus, Eastern Europe, the Western Balkans, and Caribbean. At the 7,000+ employee Chemonics International, he specializes in emerging destinations, including challenging environments such as Ukraine. He led large-scale human capital development initiatives, vocational training reforms, and improvements in university hospitality education. He designed multi-million-dollar transformative tourism projects, including cultural heritage tourism in Jordan; adventure and nature tourism in Bosnia & Herzegovina; rural tourism in Moldova, Georgia, and Lebanon; and marine and adventure tourism in Egypt and Timor-Leste. Ibrahim designed tourism-driven economic initiatives in Uzbekistan, Nepal, Tunisia, UAE, Lebanon, and US Virgin Islands.\n\nHe launched INJAZ, a youth entrepreneurship organization, laying foundations for its expansion, now reaching over 7 million Arab youth in 12 countries; was advisor to Jordan’s ministers of Tourism & Antiquities and Water & Irrigation; led inscription of Wadi Rum into UNESCO; Bosnia & Herzegovina to European Cultural Routes; and launched Most Beautiful Villages network.  \n\nA Professor at George Washington University’s School of Business, he received Jordan’s King Abdullah II Award for Advancing Entrepreneurship; UNESCO Petra World Heritage Site Master Plan Award; and served on the governing body of the UN Foundation World Heritage Alliance.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Layla",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4Njk3OTQwLFVzZXJfMjQwNzIzOTgp",
                "jobTitle": "Education Senior Manager",
                "lastName": "Alamri",
                "photoUrl": "https://static.swapcard.com/public/images/62dcb9c47b304c07b3a86777001b0d5d.jpeg",
                "organization": "Red Sea Global",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Paul",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MjAxNzE3LFVzZXJfNzgzNTY3KQ==",
                "jobTitle": "Director of Operations and Culture",
                "lastName": "Keen",
                "photoUrl": "https://static.swapcard.com/public/images/da1c333c4d7a4bcd88d24e83716607d3.jpeg",
                "organization": "QUO",
                "biography": "Paul places relationships at the heart of our dynamic project management processes, fostering strong connections and enabling teams to tackle complex brand challenges. With a recent Master’s in Innovation, Paul brings a fresh perspective to branding hospitality, pushing beyond boundaries while maintaining a strong focus on people and culture. His leadership drives a collaborative environment where creativity thrives, delivering results that are both innovative and human. By integrating strategic vision with a commitment to relationships, Paul is committed to creating a future for hospitality centred on social connection.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "NextGen Talent & Hospitality Education"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjUxMDkyMg==",
        "titleTranslations": [
            {
                "value": "The Guest Experience Reimagined: A Saudi Hospitality Design Challenge",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-11 16:45:00",
        "endsAt": "2025-05-11 17:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4NDAwOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "Workshop",
                "translations": [
                    {
                        "value": "Workshop"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMjU3Nzc5NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "yanbu-workshop-room",
                "translations": [
                    {
                        "value": "Yanbu Breakout Room"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzYxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "nextgen-talent-and-hospitality-education",
                "translations": [
                    {
                        "value": "NextGen Talent & Hospitality Education"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Joe",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3OTkwMjMwLFVzZXJfODI0ODc4NCk=",
                "jobTitle": "Founder & Managing Director",
                "lastName": "Tabet",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/92f3ad3bab5d49eebb2b626ffb308ba2.jpeg",
                "organization": "JT+Partners",
                "biography": "Joe Tabet is an award-winning architect and visionary business leader with over two decades of global experience in architecture and the construction industry. As the Founder and Managing Director of JT+Partners, Joe has built a reputation for delivering bold, sustainable, and culturally inspired design solutions that redefine urban living and hospitality experiences.\n\nIn 2015, Joe launched JT+Partners. Under his strategic leadership, the firm rapidly evolved into a globally recognized multidisciplinary consultancy, with projects spanning the Middle East, Africa, Europe, and beyond. Today, the firm boasts a diverse team of over 125 professionals across offices in Dubai, Abu Dhabi, and Beirut.\n\nJoe’s leadership style is rooted in innovation and adaptability. He champions progressive design thinking, cutting-edge technologies like digital twins, modular construction, 3D printing, and embraces the Internet of Things to future-proof his work. His ability to translate cultural narratives into timeless, cost-efficient design solutions has earned him industry acclaim and a loyal international clientele.\n\nJT+Partners' portfolio includes a wide spectrum of landmark projects—ranging from hotels, resorts, residential towers, and masterplans to hospitals and leisure destinations in UAE, KSA, Egypt, Seychelles, Greece, and beyond. The firm has received multiple honors from Cityscape, Arabian Property Awards, MEA Awards, and more.\n\nA strong advocate of corporate social responsibility, Joe fosters an inclusive, people-first company culture and supports initiatives around wellness, sustainability, and education. He is also a regular speaker at universities, design panels, and global forums—sharing his knowledge to inspire the next generation of architects.\n\nJoe Tabet’s visionary approach, global perspective, and commitment to excellence have positioned him as one of the region’s most influential architectural voices—shaping environments that go far beyond design.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1NjIzMA==",
                                    "title": "TenX Leadership Talks: To the Metaverse with Hospitality",
                                    "beginsAt": "2024-04-30 15:20:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Marloes",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDM2ODQ3LFVzZXJfMTEyODE0MDUp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Knippenberg",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/aadc31d5ddd34fcabc0aca59a0182e30.jpeg",
                "organization": "Kerten Hospitality",
                "biography": "Marloes is a distinguished hospitality leader who has been instrumental in redefining industry benchmarks. She seamlessly integrated ESG (Environmental, Social, and Governance) into the heart of business operations, processes, and value propositions. This integration has proven transformative, elevating a singular national brand to a global lifestyle group with a portfolio spanning over 45 diversified projects.\n\nMarloes' commitment to excellence is underscored by her strategic vision. She actively pursues the expansion of the brand's lifestyle portfolio, targeting regions identified for synergistic collaborations and mutual stakeholder objectives. Her foundational expertise is anchored in her tenure at Hilton, where she was entrusted with high-impact operational and commercial management portfolios.\n\nBeyond mere strategy and execution, Marloes is deeply committed to human capital development within the industry. She consistently champions the nurturing of emerging talents, propelling industry-wide transformation, and driving organizational alignment towards sustainability-centric objectives. This approach prioritizes not just bottom-line growth but also the holistic development of individuals, communities, and guest experiences.\n\nMarloes' advocacy for a progressive hospitality sector extends beyond traditional corporate parameters. As a notable ambassador for the Global Hospitality Student Challenge, spearheaded by Hotelschool the Hague, she is at the forefront of bridging the gap between the seasoned investment community and the visionary leaders of tomorrow. This initiative stands as a testament to her commitment to fostering innovation and collaboration, cementing her role in the ongoing evolution of the hospitality industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxMw==",
                                    "title": "Case Study - Private and Public Sector Collaborate to Accelerate Lifestyle Developments and Promote New Destinations #Vision2030",
                                    "beginsAt": "2024-04-29 17:20:00",
                                    "endsAt": "2024-04-29 18:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg0MjgwNQ==",
                                    "title": "Yanbu Unveiled: Turning Saudi Towns into Exciting Destinations",
                                    "beginsAt": "2024-04-30 11:55:00",
                                    "endsAt": "2024-04-30 12:25:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ebrahim",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDM2ODU1LFVzZXJfMjQyNTg2NTcp",
                "jobTitle": "Projects Director",
                "lastName": "Al Qassab",
                "photoUrl": "https://static.swapcard.com/public/images/d955479934204a2f8256e0534ec058d8.jpeg",
                "organization": "Baraka for Real Estate Development & Investment",
                "biography": "A Visionary Leader in Real Estate & Cultural Innovation\nCurrently serving as Projects Director at Baraka Real Estate Investment & Development, Ebrahim Al Qassab is at the forefront of shaping Jeddah’s future skyline. Since joining in 2022, he has led the development of six landmark projects across hospitality, commercial, lifestyle, residential, entertainment, and cultural sectors. Overseeing a prime land portfolio valued at SAR 890 million, Ebrahim is actively contributing to Baraka’s strategic expansion into Riyadh, spearheading developments rooted in conscious, community-centered living. \nAn Entrepreneurial Force in the Gulf’s Creative Landscape\nIn 2006, Ebrahim launched OTB Creative Concepts—a boutique agency specializing in \ncommunications, PR, events, and interior design. Driven by a passion for mega events, he collaborated with Kuwait’s Amiri Court on some of the country’s most iconic national celebrations, including the grand opening of Sheikh Jaber Al-Ahmad Stadium, the 50th Constitution Anniversary Fireworks, the GCC Summit, and the inauguration of Sheikh Abdullah Al Salem Museum. \nIn 2010, Ebrahim extended his creative footprint by founding The Hub Gallery and Hubs Café—a unique destination blending art, fashion, and food within a restored heritage home in Kuwait. This concept became a cultural haven for both locals and international visitors. Simultaneously, he expanded into Doha by establishing State Media, a creative and branding firm serving the region’s evolving communication needs. \nA Strategic Marketer with Regional Impact\nEbrahim’s career began in the marketing division of Gulf International Bank, where he managed major offshore accounts across the MENA region. In 2002, he joined Marriott International as Regional Executive Manager, leading alliance accounts in Doha and Kuwait. His success in Kuwait included securing strategic contracts in the oil and gas sector, solidifying the group’s market presence in the Gulf",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Dr. Fahad",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDg3Mjc1LFVzZXJfMjQyOTAyNjQp",
                "jobTitle": "Senior Advisor at the Architecture & Design Commission",
                "lastName": "Al Otaibi",
                "photoUrl": "https://static.swapcard.com/public/images/fd1e2b7517d74ea8ace8d78ff40b9a9c.jpeg",
                "organization": "Ministry of Culture",
                "biography": "FAHAD ALOTAIBI, Ph.D. architect, educator, and senior advisor at the Architecture & Design Commission Ministry of Culture. Fahad studied at King Saud University (BSc Architecture and Building Science) and the University of Sheffield (MArch Architectural Studies). He has a PhD in Environmental Design/ Architecture from University of Calgary- Canada. He has been a reviewer and juror for many organizations: Reviewer of King Salman urban charter [2021] (Ministry of Culture- Saudi Arabia), 1st design competition for Saudi architects, jury member [2020] (Ministry of Housing), Abdullatif Al Fowzan Award for Mosque Architecture, technical reviewer [2019]. Council of Tall Buildings and Urban Habitat, expert peer reviewer [2018]. Official nominator Aga Khan Award for Architecture [2024]. Fahad’s research and teaching focus on the social and cultural processes that shape the forms and meanings of built environments, particularly in Gulf region.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Dr. Ahmed",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDg3MjgyLFVzZXJfMjQyOTAyNjcp",
                "jobTitle": "Chief Business Development Officer (CBDO)",
                "lastName": "Abdulwahab Khan Alhashimi",
                "photoUrl": "https://static.swapcard.com/public/images/f10d745e815d4ad1bf7cdbcbb736f9fc.jpeg",
                "organization": "Sumou Investment Global",
                "biography": "Dr. Ahmed Abdulwahab Khan Al-Hashimi is currently serving as the Chief Business \nDevelopment Officer (CBDO) at Sumou Investment Global, where he leads strategic \ndevelopment initiatives, investment platforms, and partnerships across a group of affiliated companies. He also holds the position of Director of Engineering Affairs at Sumou Real Estate, overseeing seven technical departments and aligning engineering services with the organization’s strategic goals.With over 18 years of international and local experience across academic, professional, and executive leadership roles, Dr. Al-Hashimi specializes in sustainable architecture, urbanism, public-private partnerships, governance, and real estate development. His interdisciplinary expertise spans business development, urban policy, team building, and project execution.Dr. Al-Hashimi began his international career in France in 2009 with Poly Rythmic Architecture and has since played leading roles in iconic projects across Europe and the Middle East. He has also served in academia as an Assistant Professor, Department Chair, Vice Dean, and Acting Dean at King Abdulaziz University. Notably, he was a Member of the Recruitment and Appointment Committee at the university, contributing to faculty development and academic excellence.He is the founder of Poly Manners Architecture, a creative and research-driven design house, and a key advisor to several governmental and private institutions.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "NextGen Talent & Hospitality Education"
        ],
        "priority": 5
    },
    {
        "id": "UGxhbm5pbmdfMjUxMDkzNg==",
        "titleTranslations": [
            {
                "value": "What Are the Best Models for Ongoing Professional Development in Hospitality in Saudi Arabia?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-11 16:45:00",
        "endsAt": "2025-05-11 17:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=7RG-gyYsE3k\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4NDAwOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "Workshop",
                "translations": [
                    {
                        "value": "Workshop"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzYxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "nextgen-talent-and-hospitality-education",
                "translations": [
                    {
                        "value": "NextGen Talent & Hospitality Education"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Adrian",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MDQwMDM5LFVzZXJfMTY0MjU3OTMp",
                "jobTitle": "Chief Commercial Officer",
                "lastName": "Artimov",
                "photoUrl": "https://static.swapcard.com/public/images/839a45698a0e4ad6b590ac1fdf344483.jpeg",
                "organization": "Sommet Education",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Yasser Faisal",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4Njk4MjkwLFVzZXJfMjQwNzI2MTQp",
                "jobTitle": "Founder",
                "lastName": "Al-Sharif",
                "photoUrl": "https://static.swapcard.com/public/images/1a163333261347d8a4e102ed07bf4598.jpeg",
                "organization": "Al Sadu Advisory",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Imran",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4Njk4NDQ3LFVzZXJfMTYwMzk4ODgp",
                "jobTitle": "Executive Director Hospitality Development & Dean of Centre Expertise, CoE",
                "lastName": "Changezi",
                "photoUrl": "https://static.swapcard.com/public/images/f9218e8dc3d1467883cad34709a59cf1.png",
                "organization": "Diriyah Company",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Paul Kendall",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MjAxNzcyLFVzZXJfMTUzNzc2MTIp",
                "jobTitle": "Chief Operating Officer - MEA",
                "lastName": "Stevens",
                "photoUrl": "https://static.swapcard.com/public/images/f81c1c9005f34df39acff45f0049c96a.jpeg",
                "organization": "AccorHotels Middle East & Africa FZ-LLC",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Mohammed",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NDI1NTU3LFVzZXJfMTczMjk3MDAp",
                "jobTitle": "Chief Franchised Assets Officer",
                "lastName": "Marghalani",
                "photoUrl": "https://static.swapcard.com/public/images/5149ca46de9840e2a58610ead5ef337d.jpeg",
                "organization": "Dan Company, PIF Subsidiary",
                "biography": "Mohammed Marghalani is the Chief Franchised Assets Officer at Dan Company, bringing over 20 years of experience in the hospitality industry with him. With a strong background in finance and accounting, Marghalani has consistently excelled in improving the financial performance of hotels, leading operational excellence, and enhancing risk assessment scores at renowned hotel chains in Saudi Arabia. His remarkable achievements have earned him a prominent position on the Hotelier Middle East Power 100 List for 2021, Best General Manager for The Ritz-Carlton Company globally on 2023, Finance Person of the Year title at the Middle East Hotelier Awards in 2016, and the General Manager Award for \"Financial Excellence\" at Marriott Hotels Middle East & Africa in 2013, among other prestigious accolades. Marghalani holds a bachelor’s degree in hospitality and Tourism Management from the Glion Institute of Higher Education in Bulle, Switzerland, as well as an MBA in Hospitality from EHL Hospitality Business School in Lausanne, Switzerland. In addition to his impressive academic achievements, he was also selected to participate in the esteemed Misk 2030 Leaders' Program by Esade in 2022. He is inaugural member of The Saudi Leadership Society. With his extensive expertise and dedication to excellence, Marghalani plays a pivotal role in driving the success and growth of Dan Company.\nMohammed is a board member in Almadinah Hafawah and Radisson Blue, Conference Hotel (owned by Chamber of Commerce).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "NextGen Talent & Hospitality Education"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjU5MjY2NQ==",
        "titleTranslations": [
            {
                "value": "Masterclass: How engagement, culture and leadership make or break brand & property value in the region (and beyond)?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-11 16:45:00",
        "endsAt": "2025-05-11 17:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=MYqe6-z90uE\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzYxMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "nextgen-talent-and-hospitality-education",
                "translations": [
                    {
                        "value": "NextGen Talent & Hospitality Education"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Paul",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4NDM2NjM1LFVzZXJfMTg2NzQ3NSk=",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Bridger",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/c3ee50cc462e49ac86d1a8a097a15de2.jpeg",
                "organization": "Rove Hotels",
                "biography": "A proven hospitality leader with more than 20 years of experience across the Middle East, Asia, the UK & Ireland, Paul Bridger is the Chief Operating Officer of Rove Hotels, the smart, value hospitality brand created as a joint venture between Emaar Properties PJSC and Meraas Holding.\n\nPaul heads Rove Hotels and is responsible for overseeing the initiation, planning, and achievement of strategic brand objectives, ensuring a successful and consistent rollout of this new mid-scale lifestyle offering. His role also includes providing leadership and management focus on the business operations to achieve maximum financial performance, and team and customer satisfaction. \n \nBefore joining Rove Hotels, Paul worked with one of the UK’s largest hotel, restaurant, and café operators where he held the position of General Manager for eight years, before taking on larger responsibilities as Regional Director of Operations – Southeast Asia. \n\nPaul has diverse experience in markets such as the UK, UAE, Singapore, Thailand, Indonesia, and Malaysia with a focus on hospitality leadership.\n\nPaul holds an MBA in Hospitality from Ecole hôtelière de Lausanne (EHL), Switzerland.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                                    "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 16:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Andre",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4Njk4MTY0LFVzZXJfMjEzNDE4Njcp",
                "jobTitle": "Founder & CEO",
                "lastName": "Wiringa",
                "photoUrl": "https://static.swapcard.com/public/images/da31899a1026461a9cb04b6d60b0be52.jpeg",
                "organization": "Start Reverse",
                "biography": "Andre is keynote speaker and Strategy Consultant, working with senior business leaders on Reverse Leadership, Cultural Transformation, Award-winning Customer Experience, as well as Transformational Learning.\n\nHe is the founder of Start Reverse, a boutique consultancy with projects in the region and around the globe. The Reverse philosophy has impacted many leading hotel brands and the (work) lives of hundreds of thousands of leaders and professionals in Hospitality and beyond.\n\nAndre is the heart and mind behind this disruptive approach, boosting relevance, engagement and loyalty. He is also the author of the ‘START REVERSE’ books (The Novel and The Journey).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Jan-Patrick",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4OTg1NDE0LFVzZXJfNjY1Mzc2Nik=",
                "jobTitle": "Managing Director",
                "lastName": "Krüger",
                "photoUrl": "https://static.swapcard.com/public/images/52a0e4c54d73424eba2ec8fac78f2619.jpeg",
                "organization": "Pandox AB",
                "biography": "Jan-Patrick Krüger is a seasoned executive in the hospitality and real estate sector, currently the Managing Director for Pandox AB in Germany and Austria. With decades of experience, he specializes in operational excellence, profit improvement, and asset management. His strategic insights have driven successful project and change management initiatives, significantly enhancing guest experiences and organizational performance. A graduate of Cornell University’s and Singapore’s Business School Advanced Management Program, Jan-Patrick has overseen a diverse portfolio of over 40 property and operational companies and is recognized for his exceptional ability to foster owner relations and effectively serve as an owner’s representative, ensuring alignment of interests and maximizing value. His approach combines insightful communication with a deep understanding of ownership dynamics, leading to successful partnerships and sustainable growth.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Olivier",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4OTg1NDczLFVzZXJfMTM5OTkzMTMp",
                "jobTitle": "Founder & CEO",
                "lastName": "Harnisch",
                "photoUrl": "https://static.swapcard.com/public/images/ba61936090334109a5f56e274ade06c9.jpeg",
                "organization": "Lunasole Hospitality",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Sebastien",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NDI1Njg1LFVzZXJfMTgzMDU2MDIp",
                "jobTitle": "Group Head of Hospitality",
                "lastName": "Carre",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/5d687c7d1bd34fe383f0c0a3ba7da1c4.jpeg",
                "organization": "Red Sea Global",
                "biography": "Sebastien Carre is an internationally recognized leader in the luxury hospitality and tourism industry, with over 30 years of experience spanning five continents.\n\nHe oversees Red Sea Global Hospitality, a subsidiary of Red Sea Global. As Group Head of Hospitality, Carre leads the fully integrated luxury hospitality function from its base in Jeddah, Saudi Arabia. He defines the strategy and execution for the development and operations of a diversified portfolio of assets, which includes ultra-luxury and commercial properties such as hotels, resorts, managed residential lifestyle operations, restaurants, bars, and wellness-driven concepts. He is responsible for overseeing the expansion of Red Sea Global Hospitality’s managed portfolio. In this role, he ensures that each project aligns with the company’s vision for creating world-class, sustainable luxury destinations that offer exceptional guest experiences while supporting the local economy and community.\n\n\nSebastien’s career includes more than 20 years at Four Seasons Hotels and Resorts, where he played a key role in hotel openings, rebrandings, and regional operations leadership across Abu Dhabi, Azerbaijan, Egypt, Mauritius, South Africa, Tanzania, French Polynesia, and the United States. His expertise lies in aligning business strategy with operational excellence, driving innovation centered around guest experiences, and leading diverse, high-performing teams through periods of transformation and growth.\nA graduate in international hospitality management from Vatel Hotel & Tourism Business School in France, Sebastien combines creative vision with executional precision. He is passionate about delivering exceptional guest experiences thru elevated craftmanship, while advancing sustainable and culturally relevant hospitality models that benefit local communities and inspire global travelers.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNA==",
                                    "title": "Travelling for Good: Innovations in Luxury Travel for Responsible Tourism Development",
                                    "beginsAt": "2024-04-30 14:55:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "NextGen Talent & Hospitality Education"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQ4OA==",
        "titleTranslations": [
            {
                "value": "Speed Networking",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-11 17:30:00",
        "endsAt": "2025-05-11 18:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4Mzk5OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzQ0NjQwMA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "al-omsiat-b",
                "translations": [
                    {
                        "value": "Al Omsiat B"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjM4NQ==",
        "titleTranslations": [
            {
                "value": "FHS Welcome Reception at Yauatcha | Hosted by Al Khozama",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-11 18:30:00",
        "endsAt": "2025-05-11 21:00:00",
        "descriptionTranslations": [
            {
                "value": "<br />",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4Mzk5OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjY2MjU2Mw==",
        "titleTranslations": [
            {
                "value": "Yoga at the Top of the Tower",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 07:00:00",
        "endsAt": "2025-05-12 08:00:00",
        "descriptionTranslations": [
            {
                "value": "<p>Location: Top of the Al Faisaliah Tower, The Globe</p><p>Start your day with this 60 minutes yoga flow designed for all levels. Shake off sleepy vibes, wake up your muscles, and bring movement to your body. In this class, you’ll open your hips, legs, back, and shoulders and at the end, you’ll feel physically and mentally refreshed, ready to enjoy the day ahead.</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4Mzk5OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjM4OA==",
        "titleTranslations": [
            {
                "value": "Welcome to FHS Saudi Arabia 2025",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 09:30:00",
        "endsAt": "2025-05-12 09:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=ehW-vrvT_F4\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzMxNDMyMjY0LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman & CEO",
                "lastName": "Worsley",
                "photoUrl": "https://static.swapcard.com/public/images/65ef700e7da4493ea8d79d2e53ba7532.jpeg",
                "organization": "The Bench",
                "biography": "Jonathan Worsley began his career at Forte and Holiday Inns before moving into hotel advisory roles at PKF and CBRE. In 1997, he co-founded IHIF Berlin, followed by The Bench, which started as a daily benchmarking company for the hotel industry and in 2008 merging with STR to create STR Global.  \n\nThe Bench evolved into a leading organiser of premier hospitality investment conferences and Jonathan continued bringing the hospitality investment community together in various parts of the world through AHIC - now Future Hospitality Summit (FHS), FHS Saudi, FHS Africa and SAHIC in Latin America. Later, he expanded into aviation and F&B with AviaDev and GRIF. \n\nIn 2020, Jonathan led The Bench’s pivot to virtual events, launching Hospitality Tomorrow and FHS for the G20 Saudi Secretariat. He continues to drive industry innovation through initiatives like the Startup Den and Lead the Change while serving on the boards of Fresh on Table, Envi Lodges, and other startups shaping the future of hospitality. \n\nHe is also a trustee of the World Sustainable Hospitality Alliance, Future Talent – a musical charity, a member of Women in Hospitality (WiH) and recently completed a board term with the Ras Al Khaimah Tourism Development Authority.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Jessy El",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NDk2OTEyLFVzZXJfMjM0MDI0MjQp",
                "jobTitle": "Former Journalist",
                "lastName": "Murr",
                "photoUrl": "https://static.swapcard.com/public/images/04471469685a4bc5bdda3ee7c22b0a33.jpeg",
                "organization": "BBC",
                "biography": "Jessy El Murr is a PWC certified corporate trainer and a former BBC & Forbes Middle East journalist with 18+ years of news writing, editing and presenting. She is the Founder of Motahadith, a MENA based flagship corporate training business. \n\nShe covered exclusive news stories from Washington D.C, Afghanistan, Beirut and Riyadh. She has passion for captivating storytelling, public speaking and a successful track record in digital tools. She founded Motahadith|a in 2022, a unique public speaking and media training business, helping C-level executives to increase their media impact and executive presence. Jessy is am a licensed public speaking coach by (EAHEA) and a senior media trainer working with top international consulting firms including PWC. She continues to deliver trainings to senior government officials and top brand executives in Riyadh, Jeddah, Abu Dhabi, Dubai, and Kuwait.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjU2MDQ4MA==",
        "titleTranslations": [
            {
                "value": "Opening Remarks",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 09:45:00",
        "endsAt": "2025-05-12 09:55:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=nAXQMmn990U\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "HH Prince Bandar bin Saud bin Khalid",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NDk2OTI1LFVzZXJfMjM0MDI0MzIp",
                "jobTitle": "Secretary General, King Faisal Foundation (KFF)",
                "lastName": "Al Saud",
                "photoUrl": "https://static.swapcard.com/public/images/0f3466754aec406ab2b64862743c639f.jpeg",
                "organization": "Chairman of the Board of Directors, Al Khozama Investment Company",
                "biography": "Since 1983, Prince Bandar assumed several positions at King Faisal Foundation, including Public Relations Director and Assistant Secretary General. In 1993, he was appointed the Secretary General of the Foundation and he has since been dedicated to realizing the vision of the Board of Trustees of King Faisal Foundation, turning it into one of the leading philanthropic organizations in the world. He has led and overseen some of the Foundation’s most ambitious projects and wide range of investments which have enabled the Foundation to continue its educational mission and to become a self-funded philanthropy supported by diversified investments in Saudi Arabia.\n\nHis Highness is also the Chairman of the Board of Directors of Al Khozama Investment Company, one of the leading hospitality, real estate and F&B companies in Saudi Arabia and the region. Under his leadership, Al Khozama has grown into a company that offers a broad range of bespoke hotel development and management solutions for clients in Saudi Arabia and internationally. Drawing on extensive experience with the real estate market, the company maintains a thriving realty management and real estate development business. Al Khozama’s portfolio currently includes properties such as Al Faisaliah Tower, a major tourist attraction in Riyadh, Al Faisaliah Hotel, a luxury business hotel, and Al Faisaliah Mall, an upscale shopping, dining, and entertainment center, in addition to a variety of well-known fine dining restaurants. At the 2015 World Travel Awards, Al Khozama took home 10 prestigious awards—more than any other nominee. In the 2016, the company reaped 7 more awards.\n\nFrom 1997 to 2007, Prince Bandar put into effect the vision and directions of King Faisal Foundation Board of Trustees for the successful preparation and launch of Alfaisal University which was soon able to establish its reputation as a world-class, research-led, student-oriented university. Alfaisal’s student body increased from 89 students in 2007 to over 4,300 young men and women today. Prince Bandar serves in dual capacities as Chairman of the Executive Committee and member of the Board of Trustees of Alfaisal University.\n\nHis Highness is also the Chairman of the Board of Directors of King Faisal School, one of the leading private, non-profit schools in the Kingdom of Saudi Arabia and the first Saudi school to offer the International Baccalaureate program in the country. One of the milestones is the 100% success rate of students applying for the IB Diploma in 2022. Among other achievements, the school set a model for tens of other private schools in the country and has received several accreditations.\n\nHis Highness is also the Chairman of Board of several companies, including Trends Company, the owner of the well-known global brand name LPM, and the National Company for Tourism (Syahya); a leading hospitality company in the south region. Separate and apart from KFF and Al Khozama, Prince Bandar’s principal investment is in Landmark Arabia, a retail company which owns and operates over 500 retail department stores and other types of retail outlets, catering to middle to lower income customers. He is also the Chairman of Board of Bas Global Investment Company, AoN Saudi Arabia, and Saudi Trading and Resources Co. Ltd. (STAR).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjM5MQ==",
        "titleTranslations": [
            {
                "value": "Where Vision Shapes Opportunity",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 09:55:00",
        "endsAt": "2025-05-12 10:10:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=KwqERofLCOM\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-saudi-arabia",
                "translations": [
                    {
                        "value": "Focus on Saudi Arabia"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Mahmoud",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NTAyNDEyLFVzZXJfMjQ1NDI1NTEp",
                "jobTitle": "Deputy Minister, Destination Enablement",
                "lastName": "Abdulhadi",
                "photoUrl": "https://static.swapcard.com/public/images/56724beae060457ea3b07e98cba20646.jpeg",
                "organization": "Ministry of Tourism of Saudi Arabia",
                "biography": "Mahmoud Abdulhadi is Deputy Minister for Destination Enablement at the Saudi Arabian Ministry of Tourism. Having joined in July 2020, Abdulhadi leads the Ministry’s destination development and investment attraction activities with the aim of expanding Saudi Arabia’s growing tourism sector.\n\nHe and his team are responsible for ensuring that tourism destinations develop the required infrastructure and offering, enabling and facilitating domestic and international private sector investment, supporting sector development by creating opportunities and updating regulations, as well as managing investor relations to create a sustainable investment environment for the private sector.\n\nTo execute this mandate, Abdulhadi draws on 17 years of experience at UBS, where he was latterly Chief Executive Officer and Head of Investment Banking at UBS Saudi Arabia. During his career at UBS, Abdulhadi worked on a variety of transactions in M&A and equity capital markets spanning multiple sectors including infrastructure, entertainment, telecoms, oil and gas, financial institutions, and agriculture, to name a few.\n\nAbdulhadi holds a Master’s degree in Manufacturing Engineering and Management from the University of Warwick in the United Kingdom.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "David",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NDU2Njk3LFVzZXJfNzk3OTc2KQ==",
                "jobTitle": "CEO & Founder",
                "lastName": "Keen",
                "photoUrl": "https://static.swapcard.com/public/images/513c331c9e854a5e9989fdfe873448b3.jpeg",
                "organization": "QUO Global",
                "biography": "An evangelist for the power of experiential branding, David Keen is a successful entrepreneur and leading strategist for the travel and hospitality industries. Over the last 20 years, David has published and been interviewed in dozens of publications and has been a featured speaker at numerous conferences, tradeshows and professional events.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4NA==",
                                    "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – A Strategic Exploration for Hospitality Decision-Makers",
                                    "beginsAt": "2024-04-30 16:50:00",
                                    "endsAt": "2024-04-30 17:20:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Focus on Saudi Arabia"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjU2MDQ4MQ==",
        "titleTranslations": [
            {
                "value": "The Future of Hospitality in Saudi Arabia and Beyond",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 10:10:00",
        "endsAt": "2025-05-12 10:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=UmCs_cwJ4hg\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzY3Mw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment-finance-and-real-estate",
                "translations": [
                    {
                        "value": "Investment, Finance & Real Estate "
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Sultan Bader",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3MDA1MTk1LFVzZXJfMjExMTEyMTcp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Al-Otaibi",
                "photoUrl": "https://static.swapcard.com/public/images/7b395ba5c8d146cb970582231d498e01.jpeg",
                "organization": "Taiba Investments",
                "biography": "Mr. Sultan Bader Al-Otaibi is a recognized leader in the Middle East's hospitality and real estate sectors, currently serving as the Chief Executive Officer of Taiba Investments. His tenure marks a significant phase where Dur Hospitality's rich heritage in hospitality is seamlessly integrated into the expansive portfolio of Taiba Investments.\n\nAl-Otaibi's career, spanning over 23 years, is marked by significant contributions and transformative leadership in the hospitality sector. His role at Dur Hospitality was instrumental in elevating the company's profile in property and asset management. As General Manager of Makarem Hospitality Group, part of Dur Hospitality, he ensured operational excellence and upheld high standards in hospitality management.\n\nBeyond his operational expertise, Al-Otaibi's background in finance and accounting has been fundamental to his leadership journey. He held key financial positions at Dur Hospitality, including Internal Auditor, Financial Controller, and Chief Accountant, lending considerable financial insight to his strategic decision-making.\n\nIn his role at Taiba Investments, Al-Otaibi continues to drive growth and innovation in the hospitality and real estate sectors. His active participation in notable industry initiatives underscores his dedication to the industry. He serves on the Marriott EMEA Owner Advisory Distribution Council, the Tourism Committee at the Riyadh Chamber of Commerce & Industry, and the Advisory Board of the Future Hospitality Summit.\n\nRecognized for his outstanding contributions, Al-Otaibi has earned several accolades, including being named among the 'Top 50 Travel and Tourism Leaders' by Forbes ME and appearing in the Executive Power List and Saudi Vision 2030 Power List by Hotelier ME.\n\nAl-Otaibi's educational achievements include a master's degree in International Hospitality Management from the Emirates Academy of Hospitality Management and a bachelor's degree in Accounting from King Saud University. These qualifications have provided a solid foundation for his distinguished career in hospitality and real estate.\n\n",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Investment, Finance & Real Estate"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjU3NDg4NA==",
        "titleTranslations": [
            {
                "value": "The Invisible Hand: The Past and Future of Hospitality",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 10:20:00",
        "endsAt": "2025-05-12 10:40:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=n5n7-zQjIQ8\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTA1OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branding-and-culture",
                "translations": [
                    {
                        "value": "Branding & Culture"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Johannes",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5Njg1LFVzZXJfMjMwNzkzNTgp",
                "jobTitle": "Designer & Musician",
                "lastName": "Torpe",
                "photoUrl": "https://static.swapcard.com/public/images/8da4c012896c43db8bf17de0638a22fc.jpeg",
                "organization": "Johannes Torpe Studios",
                "biography": "From nightclub design to immersive dining experiences and sensory retail solutions for high-end brands; For over 20 years the founder and vision of Johannes Torpe Studios, Danish designer Johannes Torpe, has helped clients worldwide build and strengthen their brands through playful and thought-provoking design solutions.\n\nGuided by the belief that we do our best work when we pursue things that move us, Johannes is an advocate for an unrestrained and intuitive approach to design and life in general. He left school at the age of 12 to play the drums and is completely self-taught as a creative practitioner. \n\nHaving worked in most areas of the world Johannes’ practice has achieved a universality that speaks for itself. His diverse portfolio spans from interior design, industrial design, furniture design to large scale architectural concepts. To Johannes creativity is neither confined to disciplines nor industries. He simply calls himself a design activist, dedicated to telling compelling and authentic stories through design.\n\nAs creative director of the studio, Johannes channels his intuitive approach and comprehensive experience from the many aspects of the design and creative industries he has worked in, into creating an environment where the designers and projects can grow to reach their full potential.\n\nIn 2011 Johannes was named Group Creative Director of renowned high-end consumer electronics brand Bang & Olufsen, injecting new energy into the legendary brand, channeling his own passions for music, storytelling and brand-building. Johannes relinquished the role in October 2015, but continues to conduct creative consultancy work for brands.\n\nWhen time allows Johannes enjoys sharing his design philosophy and unique insights into the business of design. He has spoken at events such as Design Indaba, MIPIM, The International New York Times Luxury Conference and at renowned schools like Savannah College of Art and Design, Esade and Ecole Hôtelière de Lausanne.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branding & Culture"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQ5MQ==",
        "titleTranslations": [
            {
                "value": "Empowering Female Leaders: Fostering Inclusion for Lasting Impact",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 10:30:00",
        "endsAt": "2025-05-12 11:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4NDAwOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "Workshop",
                "translations": [
                    {
                        "value": "Workshop"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMjU3Nzc5NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "yanbu-workshop-room",
                "translations": [
                    {
                        "value": "Yanbu Breakout Room"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Muna Bu",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDY2MjcyLFVzZXJfMTUwMzAyNTYp",
                "jobTitle": "Executive Assistant Manager",
                "lastName": "Khamseen",
                "photoUrl": "https://static.swapcard.com/public/images/f30e328325414f138d0ed91eb8ef40b6.jpeg",
                "organization": "Grand Hyatt Al Khobar Hotel & Residences",
                "biography": "Muna Bukhamseen is an experienced HR leader with nine years in the hospitality industry, currently serving as Executive Assistant Manager – HR. Originally from Al Hasa, Saudi Arabia, she holds a Master’s degree in HR and is part of a Fast Track Leadership Program, aiming to become a General Manager. Muna is passionate about empowering women in hospitality, leading the INSPIRIT country mentoring program and actively contributing to W@Hyatt to foster a supportive workplace for women. Her leadership is guided by purpose, inclusion, and a deep belief in the power of mentorship to shape the industry’s future.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjY0NjA0NA==",
        "titleTranslations": [
            {
                "value": "Inside the Mind of the Global Investor: What Draws Capital to Saudi Arabia",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 10:40:00",
        "endsAt": "2025-05-12 11:05:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=NJ7-ryZbpHM\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Amin",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4NzQ3Mzg2LFVzZXJfMTE3NTI4NDUp",
                "jobTitle": "Managing Director",
                "lastName": "Ismail",
                "photoUrl": "https://static.swapcard.com/public/images/c1ce509234ad4a169b5d394c3565b7e3.jpeg",
                "organization": "Certares",
                "biography": "Amin Ismail is a Managing Director of Certares. Prior to joining Certares, he worked in mergers and acquisitions at American Express Global Business Travel. Amin has served in a number of executive management positions including as the CEO of Palestine Investment Fund’s real estate and hospitality investment company Amaar Group. He started his career working in leveraged finance for Bank of America and Abn Amro Bank. Amin previously served on the Boards of Directors of Nirvana Travel & Tourism.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Christophe",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDY2MTU1LFVzZXJfNjA4NjU0Myk=",
                "jobTitle": "Managing Partner",
                "lastName": "Beauvilain",
                "photoUrl": "https://static.swapcard.com/public/images/517b4a0b6d2947d3bcdb39aca538b4e7.jpeg",
                "organization": "Pygmalion Capital",
                "biography": "Christophe is the Managing Partner of Pygmalion Capital and heads the Investment Committee. Before founding Pygmalion Group in 2017, he was partner at Perenne Capital LLP from 2010, which provided deal sourcing and structuring in the European Hotel sector. He was previously CEO and founding partner of Alphatran Capital LLP, a global equity hedge fund, and partner at Phylon Investment Advisors, a $500M European equity hedge fund. Before that, he worked 7 years at Goldman Sachs International in London as Vice President in Equity Research and Institutional Investment Management. Christophe holds an MBA in Finance from Cass Business School in London and an MSc in Physics from the Institut National Polytechnique de Grenoble (France).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Maximilian",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MTYyMDExLFVzZXJfMTY0NTIyNzkp",
                "jobTitle": "Senior Vice President, Hotels & Hospitality MEA",
                "lastName": "Quack",
                "photoUrl": "https://static.swapcard.com/public/images/bcd83ca8e2534894bc87cd4b98524fac.jpeg",
                "organization": "JLL",
                "biography": "Maximilian has over 10 years of experience in the Middle East specialising in hotel investments and strategic advisory. Since moving to Dubai in 2012, he has worked for Marriott International, HVS Consulting and Damac Group, covering all aspects of hotel development, investments and ownership.\n\nHis professional reach extends throughout the Middle East & Africa with a strong focus on the GCC and further experience in hotel investments covering wider Europe and the Indian Ocean.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjM5NA==",
        "titleTranslations": [
            {
                "value": "Safeguarding Hospitality Investments Amid Market Shifts: Is Saudi Arabia Still the Land of Opportunity?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 11:15:00",
        "endsAt": "2025-05-12 11:55:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=v_F24QKSwTI\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-saudi-arabia",
                "translations": [
                    {
                        "value": "Focus on Saudi Arabia"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzY3Mw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment-finance-and-real-estate",
                "translations": [
                    {
                        "value": "Investment, Finance & Real Estate "
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Yousef",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5MzQ4LFVzZXJfMjAyNzE3Njgp",
                "jobTitle": "Former News-Anchor",
                "lastName": "Gamal El-Din",
                "photoUrl": "https://static.swapcard.com/public/images/5b02a1deed2244c784ae60c9ea7b925e.jpeg",
                "organization": "Bloomberg",
                "biography": "Yousef Gamal El-Din is the founder of Stagespring. He hosts high-profile figures including heads-of-state, ministers, CEOs and billionaires. Notably, his interview with the SNB Chairman in 2023 shook up the financial world, leading to the sale of Credit Suisse.\n\nIn over 15 years of live TV, he has secured exclusive conversations with many celebrated leaders, among them Christine Lagarde. Some 1,500 top decision-makers have joined him so far. He speaks regularly at the Future Investment Initiative and other key global events.\n\nGamal El-Din's journey covers eight years as an anchor with Bloomberg Television and previously at CNBC. The shows looked at the most important business and economic issues shaping markets.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Cyril",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MTY4NjExLFVzZXJfMjM3NzI2NDMp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Piaia",
                "photoUrl": "https://static.swapcard.com/public/images/ddbade2a26114f93981f3e1ca21238f4.jpeg",
                "organization": "Confidential",
                "biography": "A seasoned senior executive with more than two decades of leadership experience in engineering, strategy, corporate finance, real estate, master-development and business management in Europe and Middle East, Cyril Piaia currently serves as the Chief Executive Officer (CEO) @ Confidential.\n\nPreviously, Mr. Piaia leveraged his deep knowledge of the region’s hospitality and real estate sectors to steer the successful development of King Abdullah Economic City (KAEC), one of Saudi Arabia’s significant megaprojects, as CEO of listed company EMAAR, The Economic City (EEC). His visionary stewardship was central to KAEC’s ongoing transformation into a leading city focused on high-end tourism and leisure, along with a world-class manufacturing and logistics hub that will help drive the Kingdom’s economic diversification in line with the goals of Vision 2030.\n\nPrior to joining EMAAR, The Economic City, Mr. Piaia was a Managing Partner & Founder at Stratford & Russell, an independent network of real estate, finance, and hospitality industry professionals with multi-disciplinary expertise across Europe, the Middle East, Africa, and Asia.\n\nPreviously, Mr. Piaia was Chief Executive Officer (CEO) of MUSSTIR Group for 7 years in the Sultanate of Oman, a leading international property & real estate developer operating in more than 20 countries across Middle East, East Europe and East Africa, and focused on high-end real estate mix-use development and mid-scale to ultra-luxury hospitality assets.\n\nMr. Piaia has also served as Chief Executive Officer of ORASCOM Development (Egyptian multi-national real estate and hospitality development group) in Oman, developing the four largest ITC mix-use projects in Oman with residential, commercial, marinas, golf course, hotels, aiming at becoming the top tourism and residential lifestyle destination in the Sultanate.\n\nPrior to that, Mr. Piaia was Senior Manager for leading “Big Five” Arthur Andersen in Paris, specialized in Strategy and Corporate Finance, a role that saw him lead the firm’s European practice for hospitality, real estate, travel, and tourism.\n\nHe holds a Master’s degree in Engineering from École Centrale in Lille, graduated with honors.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "AlaaEldin",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MTY4MTkyLFVzZXJfMjQzMzkxODEp",
                "jobTitle": "Chief Hotels Operating Officer",
                "lastName": "Saleh",
                "photoUrl": "https://static.swapcard.com/public/images/099fd8b9c3ec4de6b7e840eae27f24a5.jpeg",
                "organization": "Rua Al Madinah Holding Company",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Naif",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MjYyMTY0LFVzZXJfMjQzOTU4ODIp",
                "jobTitle": "Chief Business Officer",
                "lastName": "AlMadi",
                "photoUrl": "https://static.swapcard.com/public/images/17626dede6254db69d1e10fd284b2839.jpeg",
                "organization": "Tourism Development Fund",
                "biography": "Naif AlMadi serves as the Chief Business Officer at the Tourism Development Fund. He brings over two decades of experience in corporate and institutional banking relationships, honed during his tenure at Riyad Bank. Mr. AlMadi has held leadership positions across diverse organizations, notably serving as Vice President of Investor Relations at Yazeed Al-Rajhi & Brothers Holding Company. Previous senior roles at Riyad Bank include Regional Director of Private and Institutional Banking and Head of Global Banking Transactions.\nMr. AlMadi holds a Master of Science in Financial and Banking Management from the University of Essex (UK), and a Bachelor of Science in Financial and Banking Management from King Saud University. He is also a holder of a diploma in Finance and Financial Services from Bournemouth Business School (UK). Furthermore, Mr. AlMadi is a graduate of the Senior Leadership Program at IESE Business School (Barcelona), the Leadership Development Program at Harvard Business School, and the Riyad Bank Credit Program.\n\n\nنايف الماضي رئيس قطاع الأعمال في صندوق التنمية السياحي. يمتلك الماضي خبرة تمتد لأكثر من عشرين عاماً في مجال قيادة العلاقات المصرفية للشركات والمؤسسات في بنك الرياض ،وقد تقلد عددا من المناصب القيادية في جهات مختلفة، من بينها نائب الرئيس لعلاقات المستثمرين في \"شركة يزيد الراجحي واخوانه\". \nكما عمل في “بنك الرياض” كمدير أقليمي للخدمات المصرفية الخاصة والمؤسسية، وقد تقلد لدى \" بنك الرياض \" رئيس قسم المعاملات المصرفية العالمية .\n\nيحمل الماضي درجة الماجستير في تخصص العلوم في الإدارة المالية والمصرفية من جامعة إسيكس في مدينة كولشيستر، بريطانيا، ودرجة البكالوريوس في تخصص العلوم في الإدارة المالية والمصرفية من جامعة الملك سعود ،ودرجة دبلوم في تخصص المالية والخدمات المالية من كلية بورنموث للأعمال في مدينة بورنموث، المملكة المتحدة. \n\nالماضي يحمل عدة شهادات من ضمنها ;برنامج القيادة العليا من كلية إدارة الأعمال في معهد الدراسات التجارية العليا في برشلونة، وشهادة برنامج تطوير القيادة من كلية هارفارد للأعمال ، وبرنامج بنك الرياض الائتماني.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Luc",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NTIxMDEyLFVzZXJfMTkyMjk1MTkp",
                "jobTitle": "Vice President, Hospitality Management,",
                "lastName": "Delafosse",
                "photoUrl": "https://static.swapcard.com/public/images/1f75f521c6ea47fc8aadcdc06a488a7f.jpeg",
                "organization": "Al Khozama Investment Company",
                "biography": "Overseeing some of the most exclusive properties around the world, my goal since I embraced the hospitality industry is to consistently uphold the highest standard of service focusing on client satisfaction and return on investment.\nPrior to joining as Vice President of the Al Khozama Group based in Riyadh, I held the role of Vice President Europe for the Jumeirah Group based in London with five hotels in operation and two projects in key European cities.\nDuring my career, I supervised major renovation projects around the world securing necessary preparations for sale, renovations, openings as the hotel primary advisor and working directly for both private owners and international groups.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Focus on Saudi Arabia",
            "Investment, Finance & Real Estate"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjY2NTc0MQ==",
        "titleTranslations": [
            {
                "value": "Curated Connections - Technology, AI & Tech",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 11:30:00",
        "endsAt": "2025-05-12 12:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4Mzk5OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNzQyNjgyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "networking-lounge",
                "translations": [
                    {
                        "value": "Networking Lounge"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Daria",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MzM2MTE0LFVzZXJfMTgzOTc4NDIp",
                "jobTitle": "Project Director",
                "lastName": "Smith",
                "photoUrl": "https://static.swapcard.com/public/images/075d2422d51b4107acf37a36606914a3.webp",
                "organization": "The Bench",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg5Mzk3Mw==",
                                    "title": "Welcome back to the Future Stage",
                                    "beginsAt": "2024-05-01 09:30:00",
                                    "endsAt": "2024-05-01 09:35:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjUyNA==",
        "titleTranslations": [
            {
                "value": "Announcements & Signings",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 11:45:00",
        "endsAt": "2025-05-12 13:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNTg4MzM4MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "centre-stage",
                "translations": [
                    {
                        "value": "Centre Stage"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjU2MDQ4Mg==",
        "titleTranslations": [
            {
                "value": "Beyond the Whistle: The FIFA World Cup 2034’s Ripple Effect on the Saudi Hospitality Sector",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 11:55:00",
        "endsAt": "2025-05-12 12:10:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=bENVozY2xpM\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-saudi-arabia",
                "translations": [
                    {
                        "value": "Focus on Saudi Arabia"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Dr. Sarah",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3MzcxNTM2LFVzZXJfMTU5MjYzMTgp",
                "jobTitle": "Senior Vice President, Head of Hotels KSA",
                "lastName": "Gasim",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/295c94c5f792461ea1fb5840b840ad14.jpeg",
                "organization": "JLL",
                "biography": "Sarah leads JLL’s Hotels & Hospitality business in KSA. She has led several hospitality megaprojects within KSA such as NEOM, PIF Tourism Destination in Taif and Jabal Omar Development Company (JODC).\nPrior to joining JLL, Sarah led the hospitality sector at one of the upcoming tourism destinations in the western region of KSA owned by the Public Investment Fund (PIF). Sarah also obtained a wide range of professional experience from local and international hospitality operators and organisations including IHG, Elaf Group and Booking.com.\nShe was awarded the ‘Best Tourism Trainer in Saudi’ in 2017 by HRH Prince Sultan Bin Salman. In addition, Sarah is a former active member of the United Nations World Tourism Organisation (UNWTO) and the World Travel & Tourism Committee (WTTC).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg4MTEwOQ==",
                                    "title": "Digital Talks: Leveraging Digital Trends to Enhance Hospitality Investment and Operations",
                                    "beginsAt": "2024-04-30 09:05:00",
                                    "endsAt": "2024-04-30 09:20:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Focus on Saudi Arabia"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjUzMjEyMQ==",
        "titleTranslations": [
            {
                "value": "Navigating the Hospitality Investment Industry in Saudi Arabia: A Beginner's Guide",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 12:00:00",
        "endsAt": "2025-05-12 12:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4NDAwOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "Workshop",
                "translations": [
                    {
                        "value": "Workshop"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMjU3Nzc5NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "yanbu-workshop-room",
                "translations": [
                    {
                        "value": "Yanbu Breakout Room"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-saudi-arabia",
                "translations": [
                    {
                        "value": "Focus on Saudi Arabia"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Dunia",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDY2Mjc5LFVzZXJfMjMxNzIxNSk=",
                "jobTitle": "Partner | Head of Travel, Hospitality and Leisure",
                "lastName": "Joulani",
                "photoUrl": "https://static.swapcard.com/public/images/e5df3501067d4a65bfff3c6426c6e5dc.jpeg",
                "organization": "Deloitte Middle East",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "James",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDY2Mjk1LFVzZXJfMTYxMjI3MDkp",
                "jobTitle": "Director Infrastructure & Real Estate",
                "lastName": "Edmondson",
                "photoUrl": "https://static.swapcard.com/public/images/b4c6da4cc95345c3a24107555c9fd881.jpeg",
                "organization": "Deloitte Middle East",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Keri",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MTMyOTgxLFVzZXJfMjMxNzE3Mik=",
                "jobTitle": "Co-Head of Real Estate & Hospitality, MENA",
                "lastName": "Watkins",
                "photoUrl": "https://static.swapcard.com/public/images/6aaf19529dfa48399c84a077374275d3.jpeg",
                "organization": "Baker & McKenzie LLP",
                "biography": "Keri Watkins is co-head of the Real Estate & Hospitality practice in the MENA region. Keri has been advising local and multinational businesses, sovereign wealth funds, family offices and public institutions in the Middle East since 2010.\n \nKeri has extensive real estate, development and hotel related experience and advises on all aspects of the commercial real estate transaction including the initial structuring of the deal, negotiating the transaction documents and post completion aspects. During her time in the Middle East, Keri has spent time on secondment with Dubai Properties Group and Gulf Capital. Keri is ranked by the prestigious legal directories for her work in Real Estate and Hospitality from 2022-2025, most recently as a \"Next Generation Partner\" by Legal 500 and \"Up and Coming\" by Chambers & Partners.\n\nKeri was awarded “Middle East’s most inspiring women leaders in hospitality” in 2024.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Imshan",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MjAxNzU4LFVzZXJfMTc4MDk3NSk=",
                "jobTitle": "Managing Director & Co-Founder",
                "lastName": "Jamal",
                "photoUrl": "https://static.swapcard.com/public/images/4696035bb7a1453ea9e847140c3d223f.jpeg",
                "organization": "EQ Group",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development",
            "Focus on Saudi Arabia"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQwMg==",
        "titleTranslations": [
            {
                "value": "The Changing Face of Saudi Arabia: The Role of Mega Events in Driving Modernization, Infrastructure Growth, and Tourism Excellence",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 12:10:00",
        "endsAt": "2025-05-12 12:40:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=9MTOeh5J3dU\" target=\"_blank\">Click here to watch online</a></p><p>Moderator: <strong>Ahmad Arab,</strong> Founding Partner, Horwath HTL Saudi</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-saudi-arabia",
                "translations": [
                    {
                        "value": "Focus on Saudi Arabia"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Abdullah",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5MDY5LFVzZXJfNjYxNzIzOCk=",
                "jobTitle": "CEO & Managing Director",
                "lastName": "Azhari",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/4fdf53d37b004fe1a6d8cdf05e9fdd85.jpeg",
                "organization": "Saudi Icon Company",
                "biography": "Abdullah Azhari, the Founder and CEO of Saudi Icon, boasts a dynamic leadership style forged through a distinguished 16-year career in the fit-out construction and civil engineering realm. His professional journey commenced at Turner Construction in Boston, USA, following the completion of his undergraduate studies in Massachusetts. Returning to his roots, Abdullah contributed significantly to Saud Consult, a premier engineering firm in KSA, before embarking on the transformative journey of establishing Saudi Icon.\n\nIn his capacity as CEO, Abdullah Azhari stands at the helm of pivotal corporate decisions, operational management, and serves as the crucial liaison between the Board of Directors and Corporate Operations. Charting the strategic course of the company, he executes plans that realize both short and long-term objectives, enhance cost-efficiency, and foster positive relationships with partners, shareholders, and regulatory bodies. Abdullah exercises adept oversight over business operations, financial performance, and investments, concurrently supervising executives to ensure compliance with policies and legal guidelines. His acumen shines in assessing and resolving challenges, actively elevating the company's public profile through strategic events and speaking engagements.\n\nAbdullah's decade-long stewardship has witnessed the pinnacle of excellence in delivering construction and fit-out projects across the Kingdom. Navigating the delicate balance between comprehensive in-house capabilities and a streamlined organizational structure, he has molded Saudi Icon into one of the Kingdom's most esteemed design and build companies, specializing in high-end fit-out and the efficient delivery of fast-track construction projects. Abdullah's visionary leadership extended to the establishment of various business units under the SI umbrella, such as SI Wood Works Factory for joinery works, MonoLine for aluminum works, and Hi-Tech for metal works. Additionally, strategic partnerships have been forged, contributing significantly to SI's competitive advantage across all operational facets.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc4ODc4Nw==",
                                    "title": "The Key to Successful Hospitality Project Development in Saudi Arabia",
                                    "beginsAt": "2024-05-01 11:15:00",
                                    "endsAt": "2024-05-01 11:55:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Gavin",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NjczMzkyLFVzZXJfMjA3MDc0NTMp",
                "jobTitle": "Regional Director",
                "lastName": "Weaver",
                "photoUrl": "https://static.swapcard.com/public/images/7c95a4ed367e40a4b33fe03dc3cc35bc.jpeg",
                "organization": "AtkinsRéalis",
                "biography": "Gavin has over 30 years’ experience as a contractor and consultant PM/QS in ten different countries and four continents. He has worked on prestigious projects throughout his career, with a specific focus on hotels, residential and mixed-use schemes. As well as iconic projects such as Burj Al Arab, Atlantis the Royal and Red Sea Project, Gavin has worked on over 30 hotels from economy to ultra luxury, from city to island.\nHe has gained an immense amount of cultural, contractual and construction procurement experience, managing at Director level in four of those countries. Gavin has also lectured part-time for a UK QS degree, matching his experience with insightful and clear presentation skills.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Maher Abou",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3ODg4OTQ5LFVzZXJfMjMxNzE4Nyk=",
                "jobTitle": "Vice President Operations Saudi Arabia",
                "lastName": "Nasr",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/1e69da694e74461e96c99804a27218ec.jpeg",
                "organization": "IHG Hotels & Resorts",
                "biography": "Maher Abou Nasr has been with IHG for over 10 years. He started his career with the company as Regional Director, Finance & Buisness Support for our operations in the UAE and Near East Africa. He served as Director Development for Middle East and Africa, working with owners and partners across the region with a special focus on KSA.\n\nMost recently as Head of Operations Finance for IMEA, overseeing the Middle East, Africa and South West Asian markets, he helped navigate our team and owner community through the pandemic, leading cash management initiatives and creating operational efficiencies to set the foundation for a strong recovery.\n\nAs VP Operations for Saudi Arabia, Maher Is responsible for the performance of the hotels in Saudi, driving operational excellence, building stronger owner relationships, driving greater owner returns and developing the national talent. He is also focussed on renovations and upgrading the quality of our current portfolio across the nation and driving Journey to Tomorrow, IHG's 10-year responsible business plan, in the country.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxOA==",
                                    "title": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                                    "beginsAt": "2024-05-01 09:15:00",
                                    "endsAt": "2024-05-01 09:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ahmad",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MTY5NzA4LFVzZXJfMjM3NzMxOTYp",
                "jobTitle": "Founding Partner",
                "lastName": "Arab",
                "photoUrl": "https://static.swapcard.com/public/images/fc79302a35f94bfca7d72c5399ca839d.jpeg",
                "organization": "Horwath HTL Saudi",
                "biography": "Ahmad is a founding partner at Horwath HTL Saudi, a leading consultancy in tourism and hospitality. With over 17 years of experience in both public and private sectors, he previously served as Deputy Minister of Strategic Planning and Business Intelligence at the Ministry of Tourism in Saudi Arabia. Ahmad’s expertise lies in strategic planning, business intelligence, and organizational transformation. At Horwath HTL Saudi, he focuses on delivering high-impact consultancy services to accelerate growth and development in the Kingdom's tourism and hospitality sectors.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Focus on Saudi Arabia"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjYzMjY2MA==",
        "titleTranslations": [
            {
                "value": "Building for Tomorrow: At the heart of Riyadh’s New Downtown",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 12:40:00",
        "endsAt": "2025-05-12 12:55:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=gCIpkNq3AFs\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "brand-development",
                "translations": [
                    {
                        "value": "Brand & Destination"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Sarah",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MjY0NDU3LFVzZXJfMTYwMTc5NDcp",
                "jobTitle": "Global Head of Cities",
                "lastName": "Varghese",
                "photoUrl": "https://static.swapcard.com/public/images/e46183acffe546e3aafb6f2d4e0c87b6.jpeg",
                "organization": "KPMG Saudi Arabia",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Julien",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NDI2OTI0LFVzZXJfMjQ0OTgwMzcp",
                "jobTitle": "Executive Director Hospitality",
                "lastName": "Renaud-Perret",
                "photoUrl": "https://static.swapcard.com/public/images/1fb52e3267694691b0eca0cd3524a723.jpeg",
                "organization": "New Murabba Development Company",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Brand & Destination"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjUzNTg4NQ==",
        "titleTranslations": [
            {
                "value": "How Is Saudi Arabia Preparing for a Tourism Transformation to Connect Travelers Locally and Globally?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 13:05:00",
        "endsAt": "2025-05-12 13:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=dwRrZgW9hpU\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-saudi-arabia",
                "translations": [
                    {
                        "value": "Focus on Saudi Arabia"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Steven",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5Mzc3LFVzZXJfMjMwNzkxODMp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Greenway",
                "photoUrl": "https://static.swapcard.com/public/images/135b3657e4e24a59ac1200f5bdf99a80.jpeg",
                "organization": "flyadeal",
                "biography": "Steven Greenway was appointed Chief Executive Officer of Saudi Arabian low-cost airline flyadeal in January 2024, bringing with him over 25 years of travel, airline, loyalty and advisory experience gained around the world.\nHe was a founding member and Chief Commercial Officer of Scoot, Singapore Airlines’ successful LCC subsidiary; CEO of reward-U, a pioneering Hong Kong loyalty/lifestyle programme; and President of Swoop, WestJet’s ultra low-cost subsidiary in Canada.\nWith exposure in C-level and executive board roles in Europe, Middle East, Asia and North America, his expertise ranges from sales and distribution to planning and revenue management, ancillary revenue, digital commerce, loyalty and strategy.\nIn recent years, he joined Boards in the manufacturing AI space (T-DAB.AI - UK), Virtual Reality pilot training (VTR - USA) and airline commercial solutions (Caravelo - Spain).\nPrior to joining flyadeal, he was President Commercial of Pangiam, a solutions and service provider of the efficient flow of people and goods across industries, including travel and transportation.\nSteven has Bachelor degrees in Economics and Political Science",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Jessy El",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NDk2OTEyLFVzZXJfMjM0MDI0MjQp",
                "jobTitle": "Former Journalist",
                "lastName": "Murr",
                "photoUrl": "https://static.swapcard.com/public/images/04471469685a4bc5bdda3ee7c22b0a33.jpeg",
                "organization": "BBC",
                "biography": "Jessy El Murr is a PWC certified corporate trainer and a former BBC & Forbes Middle East journalist with 18+ years of news writing, editing and presenting. She is the Founder of Motahadith, a MENA based flagship corporate training business. \n\nShe covered exclusive news stories from Washington D.C, Afghanistan, Beirut and Riyadh. She has passion for captivating storytelling, public speaking and a successful track record in digital tools. She founded Motahadith|a in 2022, a unique public speaking and media training business, helping C-level executives to increase their media impact and executive presence. Jessy is am a licensed public speaking coach by (EAHEA) and a senior media trainer working with top international consulting firms including PWC. She continues to deliver trainings to senior government officials and top brand executives in Riyadh, Jeddah, Abu Dhabi, Dubai, and Kuwait.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Focus on Saudi Arabia"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjM5Nw==",
        "titleTranslations": [
            {
                "value": "Lunch",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 13:20:00",
        "endsAt": "2025-05-12 14:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [],
        "speakers": [],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjM4Nw==",
        "titleTranslations": [
            {
                "value": "Setting the Scene for Hotel Performance and Development in Saudi Arabia",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 14:00:00",
        "endsAt": "2025-05-12 14:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=b0fwtf_51k4\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzY3Mw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment-finance-and-real-estate",
                "translations": [
                    {
                        "value": "Investment, Finance & Real Estate "
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Philip",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5NzU5LFVzZXJfMTQzNjUzOCk=",
                "jobTitle": "Area Director - Middle East and Africa",
                "lastName": "Wooller",
                "photoUrl": "https://static.swapcard.com/public/images/b0e3e87fc85640eba57074bb73a59231.png",
                "organization": "STR",
                "biography": "Based in Dubai, Philip leads STR’s business development and client relations for the Middle East and Africa region. He spent two decades in hospitality, and his career has spanned several senior positions in hotel operations and management, sales, marketing and revenue management for a variety of hotel companies. Philip joined The Bench in 2006 and transferred to the STR team in 2008.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Sponsor",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Investment, Finance & Real Estate"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjUyNQ==",
        "titleTranslations": [
            {
                "value": "Announcements & Signings",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 14:00:00",
        "endsAt": "2025-05-12 14:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNTg4MzM4MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "centre-stage",
                "translations": [
                    {
                        "value": "Centre Stage"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [],
        "priority": 10
    },
    {
        "id": "UGxhbm5pbmdfMjYyOTQ2MA==",
        "titleTranslations": [
            {
                "value": "Branding with Culture: Forming a Dynamic Ecosystem that Resonates and Connects",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 14:15:00",
        "endsAt": "2025-05-12 15:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=2npeWP1kyPc\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4NDAwOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "Workshop",
                "translations": [
                    {
                        "value": "Workshop"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTA1OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branding-and-culture",
                "translations": [
                    {
                        "value": "Branding & Culture"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Catherine",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4NDQyMDk5LFVzZXJfNzgzNTgxKQ==",
                "jobTitle": "Chief Strategy Officer",
                "lastName": "Edwards",
                "photoUrl": "https://static.swapcard.com/public/images/56b5c581532147f6a330a6a89310b1b3.jpeg",
                "organization": "QUO Global",
                "biography": "Catherine is a brand strategist and storyteller with a deep passion for cultural narratives and human behavior. She joined QUO in 2011 as a content director, later transitioning into brand strategy, where she played a key role in shaping QUO’s approach to brand cultural definition.\n\nAs the leader of QUO’s Growth team, Catherine focuses on expanding the agency’s presence across APAC, the Middle East, and Europe. Whether driving new business or collaborating on client projects, she is passionate about branding theories and methodologies. She believes in the power of storytelling to bring a brand’s core purpose to life, drawing on her background in writing to craft compelling narratives.\n\nCatherine has worked with some of QUO’s most notable clients, reimagining brands for both boutique hotels and global hospitality groups across diverse cultures and destinations. Her experience spans partnerships with industry leaders such as Accor, Marriott, Hilton, NEOM, PIF, Mandarin Oriental Hotel Group, and Deutsche Hospitality.\n\nA graduate of University College London (UCL), Catherine began her career as a journalist, writing and editing for leading lifestyle and business publications in London and Bangkok.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2OTMyMw==",
                                    "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – An unbiased Perspective",
                                    "beginsAt": "2024-04-30 16:35:00",
                                    "endsAt": "2024-04-30 16:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Branding & Culture"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjU3NjA3MA==",
        "titleTranslations": [
            {
                "value": "Risk or Rhetoric: Navigating Climate Risk, Regulation, and Reality in 2025",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 14:20:00",
        "endsAt": "2025-05-12 14:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=cXkKxaKGnjU\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzY0NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-esg",
                "translations": [
                    {
                        "value": "Sustainability & ESG"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Professor Marc",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3ODI0MzEwLFVzZXJfMjM1ODgzNTgp",
                "jobTitle": "Lead in ESG & Sustainability, Executive Education, Department of Banking & Finance",
                "lastName": "Lepere",
                "photoUrl": "https://static.swapcard.com/public/images/349224791da74287bc999e28ae9c3c0e.jpeg",
                "organization": "King’s Business School",
                "biography": "Marc Lepere is Professor of Sustainability at King’s Business School, King's College London. He is Programme Director on The King's-EEA Executive Programme for Hospitality Leaders, designed to equip the C-Suite with actionable insights to lead change in a commercially sustainable and scientifically robust manner.\nHe holds a PhD and a MSc from King’s College London, and is an Economics graduate of Trinity College, Dublin. He is a Fellow of the Higher Education Academy.\nMarc has published in leading journals including Stanford Social Innovation Review, Financial Times and Discovering Truth (series 1) which was nominated for a Pulitzer Prize.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Sustainability & Innovation",
            "Sustainability & ESG"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQ4Nw==",
        "titleTranslations": [
            {
                "value": "The Future of Hotel Asset Management - HAMA Asset Management Workshop - Invitation Only",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 14:30:00",
        "endsAt": "2025-05-12 15:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yMjU3Nzc5NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "yanbu-workshop-room",
                "translations": [
                    {
                        "value": "Yanbu Breakout Room"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Theodor",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MjAxNzczLFVzZXJfMTc3MDgwNSk=",
                "jobTitle": "Co-Founder, President Emeritus, Director of the Supervisory Board, HAMA Europe",
                "lastName": "Kubak",
                "photoUrl": "https://static.swapcard.com/public/images/d4b31ffd5bbf4a779499a807ec6d7d44.png",
                "organization": "Managing Partner, Arbireo Hospitality Invest",
                "biography": "Prior to founding SERVUS International In 1997 with his wife in Istanbul,  Theodor occupied a serious of executive positions in hotels in Europe, Eastern Europe and Asia Pacific (including General Manager, Rooms Division Manager and Maitre d’hotel).\nSERVUS assists private and institutional investors, governmental bodies and hotel operators with new investments as well as existing hotels, resorts and leisure facilities in Europe, Turkey, Russia, Kazakhstan, Georgia, Azerbaijan and Arabian Peninsula.\nFrom 2007 – 2018 Theodor acted as External Advisor Asset Manager and Senior Hotel Investment Manager for Union Investment Real Estate, one of the largest European Institutional Hotel Investors implementing Asset Management Strategies across the portfolio and overseeing and executing transactions in excess of € 2,0 Billion across Europe and the USA.\nIn January 2019 Theodor has taken on the role of Managing Partner in Arbireo Hospitality Invest with the focus on acquiring and repositioning Hotel Assets for its pool of investors. Theodor is also Managing Partner in Value One Hospitality a development and management platform that presently develops hotels in Europe.\nTheodor is Co-founder and acted as its first President of HAMA Europe. Presently he serves as Director on the Supervisory Board.\nTheodor was born, raised, and educated in Vienna – Austria, now “home-officed” in Istanbul with two daughters.\n\nIn his spare time, Theodor gives guest lectures at various universities, has been co-authoring  hospitality  books (such as most recently: The Routledge Companion to International Hospitality Management\" https://www.routledge.com/The-RoutledgeCompanion-to-International-HospitalityManagement/Gardini-OttenbacherSchuckert/p/book/9781138386372) and is involved in the industry in various think tanks and organizations: Mr. Kubak is co-founder of the Hotel Asset Manager Association Europe (HAMA Europe  www.hama-europe.org) and from 2014 - 2017  served as 1st President. Currently Theodor is a member of the Supervisory Board▪",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [],
        "priority": 5
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjUyNg==",
        "titleTranslations": [
            {
                "value": "Start-Up Den",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 14:30:00",
        "endsAt": "2025-05-12 16:00:00",
        "descriptionTranslations": [
            {
                "value": "<p>Clic<a href=\"https://youtu.be/9vQKabtSyWU\" target=\"_blank\">k here to watch online</a></p><p><strong></strong></p><p><strong>Judges:</strong></p><ul><li><strong>Fahad Mohammed Alobailan, </strong>Chief Executive Officer, Baan Holding</li><li><strong>Khalid Alsatti,</strong> Senior Specialist, UN Tourism</li><li><strong>Ahmad Arab</strong>, Founding Partner, Horwath HTL Saudi</li><li><strong>Sundip Patel</strong>, Chief Executive Officer, Ezdaher Financing Company</li></ul><p><strong>Participants:</strong></p><ul><li><strong>Lena AlAmeel</strong>, Founder & Creatrix, Barriya</li><li><strong>Sarah Albaiz,</strong> Managing Director, Qantara</li><li><strong>Asif Alidina</strong>, Co-Founder & CEO, Inntelo AI</li><li><strong>George Bos</strong>, Founder, The Natural Bottle</li><li><strong>Israa Sammoura,</strong> Chief Executive Officer, Meyraki</li><li><strong>Daniel Hill,</strong> Chief Executive Officer, AQUIVIO</li></ul>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNTg4MzM4MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "centre-stage",
                "translations": [
                    {
                        "value": "Centre Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Khalid",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NjM4MjgyLFVzZXJfMjM0ODQ1MTIp",
                "jobTitle": "Senior Specialist",
                "lastName": "Alsatti",
                "photoUrl": "https://static.swapcard.com/public/images/fe82653e3724419b8b5e7ba32b3f3066.jpeg",
                "organization": "UN Tourism",
                "biography": "Senior Innovation Specialist at the United Nations World Tourism Organization, leading innovative programs and strategic partnerships. Previously founder of Destination Arabia, a startup in Saudi Arabia, driving growth and tailored tourism experiences. Alsatti brings with him extensive experience in connecting tourism with technology and investment, focusing on sustainable solutions and impactful networking. Committed to enhancing global tourism through forward-thinking innovation.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Fahad",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NzYxNTg1LFVzZXJfMjMyMjExOTUp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Mohammed Alobailan",
                "photoUrl": "https://static.swapcard.com/public/images/7a338419909044c5b3a29f6d9820e408.jpeg",
                "organization": "BAAN Holding",
                "biography": "With over 21 years of experience and expertise to his role, Fahad is driven by a passion for customer experience and innovation, which has resulted in the successful implementation of several initiatives and projects. Fahad now is the Group CEO and board member of BAAN Holding group that diversify in Entertainment, Hospitality, catering and investment.\nFahad was previously Chief Tourism Officer of Almosafer (part of Seera Group) for over 6 years and has been instrumental in the transformation of Almosafer’s from an online travel agency into a holistic omnichannel travel brand that becomes as a full platform of travel.\nAs a leader in the travel, tourism and entertainment industry & as vice chairman of the Riyadh chamber of commerce & industry's tourism committee, Fahad was spearheading Almosafer’s tourism vertical that encompasses leisure, religious and MICE activities across the company. Fahad was the business lead for Discover Saudi, Almosafer’s Destination Management Company, as well as Mawasim, Almosafer’s Hajj & Umrah tour operator, and created synergies across the company’s tourism portfolio.\nFahad is an active member of the business community and serves on several boards and committees including:\n•Board member – BAAN Holding Group.\n•Chairman - Al Mosafer activities.\n•Vice chairman – Tatweer company.\n•Board member – Touresco.\n•Board Member - Altanfeethi\n•Board member - Malahi Entertainment Company.\n•Excom member - Lumi car rental.\n•Vice chairman – Tourism committee – Riyadh chamber of commerce",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Ahmad",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MTY5NzA4LFVzZXJfMjM3NzMxOTYp",
                "jobTitle": "Founding Partner",
                "lastName": "Arab",
                "photoUrl": "https://static.swapcard.com/public/images/fc79302a35f94bfca7d72c5399ca839d.jpeg",
                "organization": "Horwath HTL Saudi",
                "biography": "Ahmad is a founding partner at Horwath HTL Saudi, a leading consultancy in tourism and hospitality. With over 17 years of experience in both public and private sectors, he previously served as Deputy Minister of Strategic Planning and Business Intelligence at the Ministry of Tourism in Saudi Arabia. Ahmad’s expertise lies in strategic planning, business intelligence, and organizational transformation. At Horwath HTL Saudi, he focuses on delivering high-impact consultancy services to accelerate growth and development in the Kingdom's tourism and hospitality sectors.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Sundip",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MjE4NTI0LFVzZXJfMTI0MTM3Mzgp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Patel",
                "photoUrl": "https://static.swapcard.com/public/images/8cadb1f6b939436ab08ad4dd957f35e2.jpeg",
                "organization": "Ezdaher Financing Company",
                "biography": "Sundip Patel is a visionary entrepreneur whose journey embodies resilience and an unwavering commitment to social impact. Immigrating from Zambia as a child, he developed a lifelong dedication to financial equity and community empowerment. His academic credentials—including an MSc in Social Business from the London School of Economics, an MBA from the University of California, Irvine, and CPA and CMA licenses—have provided a solid foundation for his career.\nIn 2002, Sundip brought his vision to life by founding AVANA Companies, a holding entity that has evolved into a dynamic family of seven world-class brands. United by the mission “Capital for a Better Tomorrow,” these brands offer innovative solutions in private credit, fintech, and small business lending. With over $6.5 billion in funding to date and more than 5,500 global jobs, AVANA Companies has become a powerful force in the financial sector. Its regulated arms—AVANA Capital and AVANA Fund—specialize in financing diverse commercial real estate projects, with a focus on hospitality.\nSundip’s deep understanding of the hospitality industry is evident in his strategic approach and recent high-profile partnerships with Oaktree Capital and IHG Hotels & Resorts. His fintech influence shines through platforms like LendThrive™ and EqualSeat™, which streamline loan origination and distribution. He is also majority owner of AVANA Bank, regulated by the Federal Reserve Board and the Texas Banking Department, and he leads AVANA CUSO, the nation’s premier provider of full-service solutions to Credit Unions. Additionally, Ezdaher Finance Company marks his strategic expansion into Saudi Arabia.\nBeyond business, Sundip founded the Giggle Foundation to support underprivileged children. Splitting his time between Saudi Arabia, Bahrain, India, and Phoenix, Arizona, he continues to inspire as a sought-after speaker on socially and environmentally conscious business practices.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "George",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDU2Mzg2LFVzZXJfMjExMDYxNDYp",
                "jobTitle": "Founder",
                "lastName": "Bos",
                "photoUrl": "https://static.swapcard.com/public/images/e70936d9e2454ff5a458ede8172b6860.jpeg",
                "organization": "The Natural Bottle",
                "biography": "George Bos is the founder and CEO of The Natural Bottle, the world’s first 100% biodegradable, 100% biobased, and 100% recyclable bottle—with a naturally organic look to match its fully organic composition. A Forbes 30 Under 30 honoree and clean tech entrepreneur, George is on a mission to end plastic bottle pollution forever. Backed by leading sustainability advocates like the European Union and early-stage VC investors, The Natural Bottle is poised to disrupt global packaging standards. George brings a powerful story of purpose, product, and possibility to the stage.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Sarah",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDU2Mzg3LFVzZXJfOTE2MzQwMSk=",
                "jobTitle": "Managing director",
                "lastName": "Albaiz",
                "photoUrl": "https://static.swapcard.com/public/images/92cd6e668b364437a639257e07ba12e9.png",
                "organization": "Qantara",
                "biography": "Sarah Albaiz leads strategic development at Qantara, a Saudi-based art infrastructure company shaping how art is sourced, managed, and integrated across hospitality and institutional settings. With a background in fintech and product strategy, her work bridges cultural preservation with scalable systems—bringing art into spaces in ways that are both meaningful and investment-ready.\n\nSarah is also an artist and researcher whose practice explores the intersection of memory, faith, and financial systems.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Lena",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDg3MzcyLFVzZXJfMTYyMzY4NjEp",
                "jobTitle": "Founder & Creatrix",
                "lastName": "AlAmeel",
                "photoUrl": "https://static.swapcard.com/public/images/bdf214f92352452d9e58df6175ee058d.jpeg",
                "organization": "Barriya",
                "biography": "Lena is a Creatrix at Barriya. Mazing in between trees with her head in the clouds since childhood, then later in life gaining practical experience in crafting strategies, product development, and creative thinking—mostly within the tourism, hospitality, and sustainability sectors. Her current focus is within the landscape of creative wellness.\n\nAt Barriya, Lena uses nature as the main tool to craft Saudi herbal-based products combined with experiential creative wellness. She helps hospitality providers get clear on their why and what they want to create—to stand out by creating the work that matters most.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Asif",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDg3NjgwLFVzZXJfMTk5MjMyMTYp",
                "jobTitle": "Co-Founder & CEO",
                "lastName": "Alidina",
                "photoUrl": "https://static.swapcard.com/public/images/1495f0f1b93c4bb38b00242a89aaf7bc.jpeg",
                "organization": "Inntelo AI",
                "biography": "Asif Alidina is the Co-Founder and CEO of Inntelo AI, a conversational and agentic AI platform for hospitality and real estate. Inntelo made history in 2025 by launching the UK’s first AI Concierge, introducing AI-powered communications into daily guest interactions and hotel operations. Backed by Antler, Haatch, Look AI Ventures, and the British Business Bank, the company is live across Europe and the Middle East and was named winner of the FHS Riyadh Startup Den Award 2025. Asif is leading AI adoption in hospitality, helping hotels drive efficiencies, unlock new revenue, and deliver personalisation at scale through agentic AI that can act, reason, and plan in real time.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Israa",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDg4MzM5LFVzZXJfMjIzMTQ5ODQp",
                "jobTitle": "Founder & CEO",
                "lastName": "Sammoura",
                "photoUrl": "https://static.swapcard.com/public/images/af9f243701714499b2a0d7fd38b52204.jpeg",
                "organization": "Meyraki",
                "biography": "Israa Sammoura is a visionary architect and entrepreneur who founded Meyraki in 2020, transforming it into one of the region’s fastest-growing spatial design firms. Under her leadership, Meyraki has delivered over 40 projects across Saudi Arabia, Egypt, and Lebanon, Georgia and Tanzania .\nworking with government entities, luxury developers, and boutique brands.\n\nHolding a Bachelor’s degree in Architectural Engineering from Lebanon and a Master’s in Interior and Living Design from Milan, Israa brings a rare blend of technical precision and creative innovation. Her work bridges aesthetics, functionality, and strategic value — reshaping how spaces are experienced and optimized.\nToday, through Meyraki Insight, she is bringing the next evolution of spatial intelligence, combining data, AI, and design to empower businesses, cities, and communities across the region.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Daniel",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MjAxNjk2LFVzZXJfNTAxNjM2OCk=",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Hill",
                "photoUrl": "https://static.swapcard.com/public/images/ce68aa18215c4e19b6fbd29e0fee5bca.jpeg",
                "organization": "AQUIVIO",
                "biography": "Daniel Hill is a former IFBB World Champion bodybuilder turned entrepreneur, innovating in the field of functional hydration. After studying pharmacy at Goethe University Frankfurt, Daniel pursued a career as a professional athlete, representing global nutraceutical brands. His interest in health optimization led him to explore water technologies, culminating in the co-invention of a patented water treatment system (WO2020148157) that produces alkaline and hydrogen-enriched water to promote human health. Leveraging his expertise in the food supplement industry, Daniel co-founded Aquivio, a company revolutionizing hydration systems with smart, integrated solutions. Aquivio’s technology enables personalized, eco-friendly beverage options while supporting data monitoring and monetization. With its regional headquarters in Saudi Arabia, Aquivio aligns with Vision 2030 by contributing to a healthier, digitalized society.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [],
        "priority": 10
    },
    {
        "id": "UGxhbm5pbmdfMjUzNTg3OQ==",
        "titleTranslations": [
            {
                "value": "Financing Hospitality Ventures: Maximizing Capital for Growth and Success",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 14:30:00",
        "endsAt": "2025-05-12 15:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=Ppru9KxD6B8\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzY3Mw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment-finance-and-real-estate",
                "translations": [
                    {
                        "value": "Investment, Finance & Real Estate "
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Hossam",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTM4MTc4LFVzZXJfMTIwNTE2OTUp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Al-Basrawi",
                "photoUrl": "https://static.swapcard.com/public/images/ab06795985174d609056ebd5d02c872e.jpeg",
                "organization": "Alrajhi Capital",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Sean",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MDY2MTM1LFVzZXJfNDk4NTgyNCk=",
                "jobTitle": "President & CEO",
                "lastName": "Hehir",
                "photoUrl": "https://static.swapcard.com/public/images/2277a5f9559c4030b9dbe17935b2d9d9.jpeg",
                "organization": "Trinity Investments",
                "biography": "Sean Hehir is a Managing Partner and the President and Chief Executive Officer of Trinity.  Mr. Hehir has 28 years of experience in hospitality, 27 years of experience in real estate investment and asset management and has been leading Trinity for 15 years.  In addition to management of Trinity, Mr. Hehir oversees Trinity’s investment activities, including sourcing and executing investment opportunities, formulating investment strategy, and structuring acquisitions and dispositions.  Since joining Trinity in May 1998, Mr. Hehir has executed over $9.5 billion of global real estate transactions in lodging, retail, and residential sectors.\n\nPrior to joining Trinity, Mr. Hehir worked for HVS International, a leading consulting firm to the hospitality industry, as a senior associate performing in-depth market studies, financial analyses, income and expense projections, valuations and feasibility studies, competitive market and property positioning studies, and operational reviews for hotels ranging from limited-service to full-service corporate and resort properties.\n\nMr. Hehir holds a Bachelor of Science degree in Hotel Administration from Cornell University and a Diploma in Hotel Administration from the Hotel Institute Montreux, Switzerland.  Mr. Hehir is a board member of the Hawaii Chapter of The Nature Conservancy, in addition to being an active member of YPO (formerly the Young Presidents’ Organization), a chief executive leadership organization, and The Real Estate Roundtable.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Khaled",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MTMzMDAzLFVzZXJfMTQ2Njc2OCk=",
                "jobTitle": "Partner, Co-Head of Real Estate and Hospitality Middle East",
                "lastName": "Zowayed",
                "photoUrl": "https://static.swapcard.com/public/images/dd92179458104c9f9d5b2de995de9bd8.jpeg",
                "organization": "Baker McKenzie",
                "biography": "Khaled is a leading lawyer that specializes in real estate and hospitality transactions in the Middle East, with a particular focus in Saudi Arabia. Having been involved in hotel transactions in the market since 2011, Khaled has worked on negotiating over 150 hotel management agreement, branded residences, and franchise agreements in KSA. He is praised for his \"commercial approach\" and his \"wealth of knowledge\" that he brings to each hospitality transaction.\n\nHe is recognized by leading directories including Legal 500 - Real Estate & Construction 2025 - Saudi Arabia - as a Leading Partner in his field.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Khalid",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NDIyNTI2LFVzZXJfMjQ0OTUzODYp",
                "jobTitle": "Chief Financial Officer",
                "lastName": "Mulla",
                "photoUrl": "https://static.swapcard.com/public/images/7de0123377d14371b972a4ac5f480405.jpeg",
                "organization": "Rua al Madinah",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development",
            "Investment, Finance & Real Estate"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjYyODA3MQ==",
        "titleTranslations": [
            {
                "value": "The Future of Global Tourism",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 15:00:00",
        "endsAt": "2025-05-12 15:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=Ni54c7dexeM\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Yousef",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5MzQ4LFVzZXJfMjAyNzE3Njgp",
                "jobTitle": "Former News-Anchor",
                "lastName": "Gamal El-Din",
                "photoUrl": "https://static.swapcard.com/public/images/5b02a1deed2244c784ae60c9ea7b925e.jpeg",
                "organization": "Bloomberg",
                "biography": "Yousef Gamal El-Din is the founder of Stagespring. He hosts high-profile figures including heads-of-state, ministers, CEOs and billionaires. Notably, his interview with the SNB Chairman in 2023 shook up the financial world, leading to the sale of Credit Suisse.\n\nIn over 15 years of live TV, he has secured exclusive conversations with many celebrated leaders, among them Christine Lagarde. Some 1,500 top decision-makers have joined him so far. He speaks regularly at the Future Investment Initiative and other key global events.\n\nGamal El-Din's journey covers eight years as an anchor with Bloomberg Television and previously at CNBC. The shows looked at the most important business and economic issues shaping markets.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Philip",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NDU1OTI5LFVzZXJfMTkxMzQ5MzIp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Barnes",
                "photoUrl": "https://static.swapcard.com/public/images/246b45805ccc406aa094b53884a16d4f.jpeg",
                "organization": "Rotana",
                "biography": "Philip Barnes is the Chief Executive Officer (CEO) of Rotana, one of the leading hotel management companies in the region with hotels across the Middle East, Africa, Eastern Europe, and Türkiye. In his current role, Barnes oversees all aspects of Rotana’s growth and operations, from directing long-term strategies to improving day-to-day efficiencies. With a focus on robust expansion in the region and beyond, Barnes plays a pivotal role in propelling Rotana to new heights and driving the company’s ongoing success. \n\nWith over 40 years of experience spanning five continents, Barnes specialises in hotel and resort openings, turnarounds, and asset re-positioning. His successful stints in Asia, Canada, the United Kingdom, and the United States of America underscore the breadth of his expertise and global impact on the industry.\n\nCareer highlights for the British national include 25 years at Fairmont Hotel & Resorts, where he held several senior leadership positions worldwide. In the Middle East, he served as Fairmont Hotels & Resorts’ Regional Vice President of the United Arab Emirates where he oversaw the operations and pre-opening for several properties. He also held the position of Vice President of the Middle East for the group, leading the developments and planned openings in South Africa, the Kingdom of Saudi Arabia, Egypt, the United Arab Emirates, and Oman. Prior to joining Fairmont Hotel & Resorts, Barnes held positions at Four Seasons Hotels & Resorts and Shangri La Hotels & Resorts among other leading international brands.\n\nAt Rotana, Barnes works closely with the wider team to grow Rotana’s legacy and firmly position it as one of the leading hospitality players in the region. He remains dedicated to redefining the hospitality experience, creating Treasured Time for guests and setting new benchmarks for the industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQ4NA==",
        "titleTranslations": [
            {
                "value": "Your Path to Red Sea Global: Exploring Projects and Partnership Opportunities",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 15:15:00",
        "endsAt": "2025-05-12 16:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=oVxlPkLO5DU\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4NDAwOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "Workshop",
                "translations": [
                    {
                        "value": "Workshop"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Gregory",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NDkyNTEzLFVzZXJfMjIxNTg4MzAp",
                "jobTitle": "Group Head of Investments",
                "lastName": "Djerejian",
                "photoUrl": "https://static.swapcard.com/public/images/43eec2cbcadb41b7b2db67506365fd39.jpeg",
                "organization": "Red Sea Global",
                "biography": "Greg Djerejian is the Group Chief Legal Officer and Group Head of Investments at Red Sea Global (RSG), overseeing the Group’s investment and legal functions. With 30 years of experience in investments, real estate, and corporate law, Greg manages joint ventures, strategic partnerships, and investor relations. He has collaborated with top international investors, private equity firms, and sovereign wealth funds across Europe, Asia Pacific, and the MENA region. Greg holds an MBA from Columbia Business School and a Juris Doctor from Georgetown University Law Center, and he is a member of the New York State Bar.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjYyOTQ1NQ==",
        "titleTranslations": [
            {
                "value": "Beyond the App: Transforming Digital Ventures into Offline Hospitality",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 15:15:00",
        "endsAt": "2025-05-12 15:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=GDp5OvrywsM\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Technology & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Michael Acton",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NjA2NTYyLFVzZXJfMTA1Mzc1MTQp",
                "jobTitle": "Co-Founder & Executive Chairman",
                "lastName": "Smith",
                "photoUrl": "https://static.swapcard.com/public/images/aeeea1ec1faf489f89b37288836b84c9.jpeg",
                "organization": "Calm",
                "biography": "Michael is the co-founder and co-Executive Chairman of Calm, the leading mental health brand with the #1 App for Sleep, Meditation and Relaxation. Calm has grown to over 150 million downloads, was the Apple 2017 app of the year, and is the world's first mental health unicorn.\n\n\nPrior to Calm, Michael was the founder of Mind Candy, along with Firebox.com, Ping Pong Fight Club, and Berwickstock music festival. In 2014 he was awarded an OBE for services to the Creative Industries.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Yousef",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5MzQ4LFVzZXJfMjAyNzE3Njgp",
                "jobTitle": "Former News-Anchor",
                "lastName": "Gamal El-Din",
                "photoUrl": "https://static.swapcard.com/public/images/5b02a1deed2244c784ae60c9ea7b925e.jpeg",
                "organization": "Bloomberg",
                "biography": "Yousef Gamal El-Din is the founder of Stagespring. He hosts high-profile figures including heads-of-state, ministers, CEOs and billionaires. Notably, his interview with the SNB Chairman in 2023 shook up the financial world, leading to the sale of Credit Suisse.\n\nIn over 15 years of live TV, he has secured exclusive conversations with many celebrated leaders, among them Christine Lagarde. Some 1,500 top decision-makers have joined him so far. He speaks regularly at the Future Investment Initiative and other key global events.\n\nGamal El-Din's journey covers eight years as an anchor with Bloomberg Television and previously at CNBC. The shows looked at the most important business and economic issues shaping markets.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Technology & Innovation"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQxMA==",
        "titleTranslations": [
            {
                "value": "Is the Pursuit of Luxury Compatible with Sustainability in Saudi Arabian Hospitality?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 15:30:00",
        "endsAt": "2025-05-12 16:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=BxGrqK02gSM\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNzA3NTM4MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "luxury-fandb-and-experiential-hospitality",
                "translations": [
                    {
                        "value": "Luxury, F&B, and Experiential Hospitality"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Ana Lobo",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NjIxNDk3LFVzZXJfMTkyNzk4Nzkp",
                "jobTitle": "Director, Interior Design",
                "lastName": "Martins",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/dd57025983104c75946e38dee4bbbd46.jpeg",
                "organization": "ARC International Design Consultants",
                "biography": "She has extensive experience in various areas, and always looks for a creative approach when developing projects, being a firm believer in teamwork.\n\nHer main focus has been on Retail and Hospitality, including Architecture and especially Interior Design. She has worked on many projects, both national and international, and is always looking for new challenges and opportunities for learning and growth.\n\nIn the hospitality world, she has had the opportunity to work with the big operator brands in various locations all over the world.\n\nWith a focus on Interior design, her main concern is always to find the best solutions, considering the Brand statements, the local culture and the creation of unique sustainable destinations that become exquisite guest experiences.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNw==",
                                    "title": "Creating and Reinventing Destinations: From Conception to Cultivation",
                                    "beginsAt": "2024-05-01 09:50:00",
                                    "endsAt": "2024-05-01 10:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Omar",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5NTIxLFVzZXJfMjQ5ODg1Mzgp",
                "jobTitle": "Chief Development & Luxury Officer",
                "lastName": "Romero",
                "photoUrl": "https://static.swapcard.com/public/images/0f99cc6201cf4279b6c1afe8f6c217f1.jpeg",
                "organization": "Minor Hotel Group Limited",
                "biography": "Omar Romero is the Chief Development and Luxury Officer at Minor Hotels, a leading global hospitality group. In this newly created role, he drives the company's global development strategy, oversees project planning and execution, and cultivates key stakeholder relationships. He also plays a crucial role in shaping and supporting the curation of Minor Hotels' luxury brands, ensuring exceptional guest experiences.\n\nPrior to joining Minor Hotels, Romero served as Chief Development Officer at Six Senses, where he led the global development team for over half his tenure. He has spearheaded the signing of over 50 Hotel Management Agreements and multiple branded residence projects throughout his career. \n\nIn addition, Romero successfully navigated and contributed to strategic direction during three distinct ownership transitions involving Soneva Group, Pegasus Capital Advisors LP, and InterContinental Hotels Group. Romero holds a degree from the esteemed Ecole Hôtelière de Lausanne and Les Roches Hotel Management School. With over two decades of experience in the hospitality industry, he brings a wealth of knowledge and a global perspective to his role at Minor Hotels.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Hicham",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3Njc3NTYxLFVzZXJfMjA4NDAyNjkp",
                "jobTitle": "Chief Business Officer",
                "lastName": "Hassouni",
                "photoUrl": "https://static.swapcard.com/public/images/aece1262c2e749f39b7ea4cd5a20e880.jpeg",
                "organization": "Our Habitas, EVP KSA Ennismore",
                "biography": "Hicham brings 23 years of extensive experience to Ennismore. He has held senior positions at renowned advisory firms and played pivotal roles in leading hotel groups, including Accor and Rosewood Hotel Group. Based in Riyadh since 2020, he has deep insights into the Saudi market and, most recently, served as Chief Strategy Officer at Boutique Group.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Richard",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4NzQ3NTU1LFVzZXJfNjc4NjMwMyk=",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Williamson",
                "photoUrl": "https://static.swapcard.com/public/images/4bbae35ad27d473a9510a393ab25dfd0.jpeg",
                "organization": "Considerate Group",
                "biography": "Richard Williamson is the COO of Considerate Group, a data-driven sustainability consultancy, focused on the hospitality and tourism sectors, with offices in London and New York and a local partner in Dubai. Richard oversees Considerate’s Middle Eastern business, having previously worked for KPMG and PwC in the UAE and Oman. \n\nConsiderate Group develops tailor-made ESG frameworks and sustainability strategies for hotels and tourism companies, working with owners, operators, SWFs and asset managers around the world.  As well as transition risk mitigation, Considerate focuses on delivering the financial benefits of investment.\n\nServices include asset-level and portfolio decarbonisation and net zero strategies, hotel energy assessments, ESG due diligence, certification and accreditation. Considerate also operates a data platform, Con-Serve™ a premier ESG data-intelligence platform tailored specifically to the hospitality industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2MA==",
                                    "title": "Sustainable Horizons: Catalyzing Change Through Green Investments",
                                    "beginsAt": "2024-04-30 12:25:00",
                                    "endsAt": "2024-04-30 12:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Luxury, F&B, and Experiential Hospitality"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjY2NTczOA==",
        "titleTranslations": [
            {
                "value": "Curated Connections - Funding",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 15:30:00",
        "endsAt": "2025-05-12 16:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4Mzk5OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNzQyNjgyOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "investor-lounge",
                "translations": [
                    {
                        "value": "Investor Lounge"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [],
        "priority": 20
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjM5OQ==",
        "titleTranslations": [
            {
                "value": "Service Excellence in Vulnerable Times",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 16:00:00",
        "endsAt": "2025-05-12 16:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=0AWja3Ag3LM\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTA1OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branding-and-culture",
                "translations": [
                    {
                        "value": "Branding & Culture"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNzA3NTM4MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "luxury-fandb-and-experiential-hospitality",
                "translations": [
                    {
                        "value": "Luxury, F&B, and Experiential Hospitality"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Carsten K.",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3MDQ1NjY5LFVzZXJfMjMxNTI0MzQp",
                "jobTitle": "Entrepreneur",
                "lastName": "Rath",
                "photoUrl": "https://static.swapcard.com/public/images/6e37976db2e44fa7aacf9e2b457f78f0.jpeg",
                "organization": "Passion for Excellence AG",
                "biography": "Carsten K. Rath: From a Former \"Bad Role Model\" to Germany’s Leading Service Expert\n\nCarsten K. Rath describes himself as a former bad role model—simply because that was how he was trained. Back then, service was more rigid than heartfelt, and leadership was about control rather than customer orientation. Today, we know better. In his own words: \"Service makes the difference!\"\n\nCarsten K. Rath has worked his way from a terrace waiter to an international service brand. He has opened and managed some of the world's most prestigious hotels, including Hotel Adlon in Berlin and The Ritz-Carlton in Naples, Florida. Today, n-tv refers to him as \"Germany’s No. 1 Service Expert.\" As a sought-after keynote speaker, he inspires audiences on major international stages. As a management consultant, he provides businesses of all sizes with insights on customer enthusiasm and service excellence.\n\nHe writes service quality columns for leading publications such as Capital, Bunte, n-tv, Travel News, Reiselust, and more. Capital calls him \"THE hotel expert.\" Additionally, Carsten K. Rath is the founder of the hotel ranking \"The 101 Best Hotels.\"\n\nThroughout his career, Carsten K. Rath has been honored with multiple awards, including \"Hotel Manager of the Year\" and \"Host of the Year.\" He has also received the \"Innovation Award of the German Tourism Industry.\"\n\nHigh-jump legend Carlo Thränhardt once said about him: \"If service excellence were a competitive sport, Carsten would have broken world records multiple times.\" A statement that perfectly suits Carsten K. Rath, whose personal motto is:\n\"Service excellence is an attitude. Leadership, too!\"",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branding & Culture",
            "Luxury, F&B, and Experiential Hospitality"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjYzMTQwNA==",
        "titleTranslations": [
            {
                "value": "Announcements & Signings",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 16:00:00",
        "endsAt": "2025-05-12 17:30:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNTg4MzM4MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "centre-stage",
                "translations": [
                    {
                        "value": "Centre Stage"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [],
        "priority": 10
    },
    {
        "id": "UGxhbm5pbmdfMjU2MDQ4OA==",
        "titleTranslations": [
            {
                "value": "TenX Leadership Talk: The Future of Mid-Scale & Upscale Hospitality in Saudi Arabia’s Transforming Tourism Sector",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 16:15:00",
        "endsAt": "2025-05-12 16:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=dmVB26uC7rs\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-saudi-arabia",
                "translations": [
                    {
                        "value": "Focus on Saudi Arabia"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzY3Mw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment-finance-and-real-estate",
                "translations": [
                    {
                        "value": "Investment, Finance & Real Estate "
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jessy El",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NDk2OTEyLFVzZXJfMjM0MDI0MjQp",
                "jobTitle": "Former Journalist",
                "lastName": "Murr",
                "photoUrl": "https://static.swapcard.com/public/images/04471469685a4bc5bdda3ee7c22b0a33.jpeg",
                "organization": "BBC",
                "biography": "Jessy El Murr is a PWC certified corporate trainer and a former BBC & Forbes Middle East journalist with 18+ years of news writing, editing and presenting. She is the Founder of Motahadith, a MENA based flagship corporate training business. \n\nShe covered exclusive news stories from Washington D.C, Afghanistan, Beirut and Riyadh. She has passion for captivating storytelling, public speaking and a successful track record in digital tools. She founded Motahadith|a in 2022, a unique public speaking and media training business, helping C-level executives to increase their media impact and executive presence. Jessy is am a licensed public speaking coach by (EAHEA) and a senior media trainer working with top international consulting firms including PWC. She continues to deliver trainings to senior government officials and top brand executives in Riyadh, Jeddah, Abu Dhabi, Dubai, and Kuwait.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Ron",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTM3ODc2LFVzZXJfMTk0NzMyNik=",
                "jobTitle": "President",
                "lastName": "Pohl",
                "photoUrl": "https://static.swapcard.com/public/images/761b085b2385463baabb37776817bcae.jpeg",
                "organization": "BWH Hotels",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Focus on Saudi Arabia",
            "Investment, Finance & Real Estate"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjY0NjA1MQ==",
        "titleTranslations": [
            {
                "value": "The Mukaab: Building Tomorrow’s Opportunities, Today",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 16:15:00",
        "endsAt": "2025-05-12 17:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=x2JgTYOCMoQ\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4NDAwOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "Workshop",
                "translations": [
                    {
                        "value": "Workshop"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0ODk4Mw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "intelligence-talks",
                "translations": [
                    {
                        "value": "Intelligence Talks"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Stephen",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5Mjk1NTgxLFVzZXJfMjEwNzY5MDUp",
                "jobTitle": "Senior Director of Development",
                "lastName": "Rossouw",
                "photoUrl": "https://static.swapcard.com/public/images/f0f81072af1e4c2c94bef5b9af555e52.jpeg",
                "organization": "New Murabba Development Company",
                "biography": "As a member of the development leadership team of the New Murabba Development Company, Stephen oversees mixed-use and hospitality real estate assets within Riyadh’s new iconic Mukaab. Prior to his role with New Murabba, Stephen has led major development and infrastructure projects across Europe and Australasia.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Julien",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NDI2OTI0LFVzZXJfMjQ0OTgwMzcp",
                "jobTitle": "Executive Director Hospitality",
                "lastName": "Renaud-Perret",
                "photoUrl": "https://static.swapcard.com/public/images/1fb52e3267694691b0eca0cd3524a723.jpeg",
                "organization": "New Murabba Development Company",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Intelligence Talks"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjU4NDQ4Nw==",
        "titleTranslations": [
            {
                "value": "From London to Riyadh - Perspectives from a Pioneering Developer on the Future of Branded Living",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 16:30:00",
        "endsAt": "2025-05-12 17:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=8caE6aIcKRg\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences",
                "translations": [
                    {
                        "value": "Branded Residences"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Nick",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3OTEzNzI0LFVzZXJfMjMxNzgzOTEp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Candy",
                "photoUrl": "https://static.swapcard.com/public/images/97a1ef7bc8bb47fc9a6ce1108c7fc3a3.jpeg",
                "organization": "Candy Capital",
                "biography": "Nick Candy is a British luxury real estate developer and co-founder of world-leading interior design and development management firm Candy & Candy (now Candy London). His groundbreaking project – the globally celebrated One Hyde Park – revolutionised the property market worldwide, breaking industry records and setting unparalleled new standards in luxury design and living. \n\nNick operates a private family office overseeing a diverse group of companies spanning real estate, design, development, and a portfolio of multi-stage investments in tech, digital media, consumer and sports, biotech, sustainability, and natural resources.\n\nWith a long-standing affiliation with the Middle East, Candy is actively engaged in a number of significant real estate and hospitality projects across the region through joint venture partnerships at the highest level.\n\nRecognised as a distinguished figure and innovator within the real estate community, Nick is a regular commentator in the media on industry topics and trends, and his visionary insights have earned him widespread acclaim and recognition.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Keri",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MTMyOTgxLFVzZXJfMjMxNzE3Mik=",
                "jobTitle": "Co-Head of Real Estate & Hospitality, MENA",
                "lastName": "Watkins",
                "photoUrl": "https://static.swapcard.com/public/images/6aaf19529dfa48399c84a077374275d3.jpeg",
                "organization": "Baker & McKenzie LLP",
                "biography": "Keri Watkins is co-head of the Real Estate & Hospitality practice in the MENA region. Keri has been advising local and multinational businesses, sovereign wealth funds, family offices and public institutions in the Middle East since 2010.\n \nKeri has extensive real estate, development and hotel related experience and advises on all aspects of the commercial real estate transaction including the initial structuring of the deal, negotiating the transaction documents and post completion aspects. During her time in the Middle East, Keri has spent time on secondment with Dubai Properties Group and Gulf Capital. Keri is ranked by the prestigious legal directories for her work in Real Estate and Hospitality from 2022-2025, most recently as a \"Next Generation Partner\" by Legal 500 and \"Up and Coming\" by Chambers & Partners.\n\nKeri was awarded “Middle East’s most inspiring women leaders in hospitality” in 2024.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Jerry",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MDY2MTA0LFVzZXJfMjE4NDAxOTcp",
                "jobTitle": "Group CEO",
                "lastName": "Inzerillo",
                "photoUrl": "https://static.swapcard.com/public/images/b946c29ec7c24b2091410172ac1ed515.jpeg",
                "organization": "Diriyah Company",
                "biography": "Gerard “Jerry” Inzerillo is a globally celebrated Forbes-cover visionary in the hospitality and tourism industry, with a deep aptitude for positioning strategies and iconic developments. Over the course of his five-decade career in the industry, he has been a champion for the sector and its people, and the creative and logistical mind behind some of the world’s most innovative luxury brand activations and spectacular development launches.\n\nIn recognition of his leadership and empathetic outreach to the global tourism community during the COVID-19 pandemic, he was voted the ‘’Corporate Hotelier of the World’’ by Hotels Magazine, considered the most prestigious recognition in Global Hospitality as well as the “Tourism for Peace Award” by the World Association of Non-Governmental Organizations (WANGO), honoring Inzerillo’s unique contributions to world peace by bringing people together through travel and tourism.\n\nIn June 2018, Inzerillo was appointed by HRH The Crown Prince Mohammed Bin Salman of the Kingdom of Saudi Arabia to be the founding CEO of the newly created Diriyah Gate Development Authority, (DGDA), a USD $63 Billion Vision 2030 giga-project aimed at restoring and reimagining the ancestral home of the original Saudi state. In this role, Inzerillo is charged with developing and implementing master plans to turn 74 square kilometers of development area into one of the world’s greatest gathering places and the center of culture and heritage in the Middle East. The Masterplans will encompass world-class cultural, entertainment, retail, hospitality, educational, religious, office and residential assets, with the UNESCO World Heritage site of At-Turaif as its center-point. Phase 1 was successfully opened in 2022 for the Global Summit of the World Travel and Tourism Council – WTTC, as well as the UNWTO 45th Global Tourism Summit in 2023.\n\nAt-Turaif was inaugurated by The Custodian of the Two Holy Mosques King Salman bin Abdulaziz Al Saud in November 2019, followed by hosting the G20 in November 2020 – the first time that the G20 has had its Presidency held by a Middle Eastern country.\n\nWhen complete, the development will add 27 billion Saudi riyals to the Kingdom of Saudi Arabia's GDP, attract 27 million visitors and employ more than 55,000 people.\n\nInzerillo also serves as Vice Chairman of the Forbes Travel Guide. The Forbes Travel Guide Five-Star Award is universally accepted as the Olympic gold medal of Global Hospitality. As CEO of Forbes Travel Guide from 2014 to 2018, Inzerillo successfully spearheaded the globalization of the North American company’s international footprint to more than 100 countries worldwide.\n\nInzerillo was President and CEO of IMG Artists, the global leader in artist management, performing arts and lifestyle events planning from 2012 to 2014. At IMG Artists, he directed global strategies for music, events, festivals, and government consulting and artist and facility management businesses.\n\nFrom 1991 to 2011, Inzerillo was president of Kerzner Entertainment Group, where he raised the profile and positioning of its properties in South Africa, the Bahamas, Dubai, Morocco, Mauritius, Mexico, the Maldives, as well as conceptualized and positioned the start-up of its One&Only and Atlantis brands. He oversaw the now-legendary launches of The Lost City at Sun City in South Africa, Atlantis in the Bahamas and Atlantis, Dubai, the latter considered to be the most covered hotel resort, including achieving the front cover of Time magazine.\n\nFrom 1991 to 1996, Inzerillo served as COO of Sun City, the unique South African resort complex built by Sol Kerzner. While in South Africa, he enjoyed a close personal friendship Nelson Mandela. In 1994, Inzerillo coordinated major portions of Mr Mandela’s Presidential Inauguration in South Africa. In 2023 he was awarded the inaugural ‘’ Lifetime Achievement Award” from the Nelson Mandela Childern Fund for his devotion and dedication to Nelson Mandela and his causes Commemorative the 10th Anniversary of his passing.\n\nIn 1987, he was the founding President and CEO of Morgans Hotel Group, later rebranded as Ian Schrager Hotels. While there, he conceptualized and opened Morgans, Royalton and Paramount in New York; the Delano in Miami Beach; and Mondrian in L.A.\n\nThroughout, Inzerillo’s leadership has led to the conceptual success of breakout brands such as Atlantis, One&Only Resorts, Ian Schrager Hotels, Four Seasons and Hilton Hotels.\n\nIn his personal life, Inzerillo has long been involved with philanthropy, especially with respect to children, education, and HIV/AIDS. He was honored with a Knighthood by the Knights of Malta in Rome, Italy, in 1996 as well as in 2023 receiving Presidential Medal of Volunteerism and Service from US President Joseph Biden. Inzerillo is also a Founding Advisory Board Member of the Clinton AIDS Foundation.\n\nInzerillo is the recipient of a host of awards and distinctions including being featured on the cover of Forbes Magazine",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjUzMzkxNQ==",
        "titleTranslations": [
            {
                "value": "Unveiling Market Trends: Insights into Branded Residences in the Kingdom",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 17:00:00",
        "endsAt": "2025-05-12 17:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=lMWDK4wviT8\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences",
                "translations": [
                    {
                        "value": "Branded Residences"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Daniel von",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3MTY0OTI2LFVzZXJfOTc0MTM4OSk=",
                "jobTitle": "Senior Vice President, Global Mixed-Use Development",
                "lastName": "Barloewen",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/5cf473e2ddec40608d2edc80e017428d.jpeg",
                "organization": "Accor One Living",
                "biography": "Daniel von Barloewen is the Regional Vice President of Accor One Living and Head of Mixed-Use for Accor for Europe, Middle East, Africa and India. His remit covers development, brand advisory & marketing support for development partners, as well as operations for branded residences, golf, private members’ clubs, and co-working.\n\nBoasting 42 brands, over 6,500 open and pipeline hotels with c.1,000,000 rooms, Accor is the world's 2nd largest branded residential operator (with over 150 open and pipeline residence projects, approximately 25,000 Residences, with more than USD $15bn of value of real estate licensed under 25 of its brands in the Accor and Ennismore portfolio). In 2023 more than $2.2Bn of residential real estate was sold under Accor brands.\n\nAccor offers world class residential expertise, bringing iconic brands and legendary hospitality service to private home ownership. Located in prime urban locations and the sought after resort destinations, our residential properties are a natural extensions of our iconic hotel brands. Providing development partners with a tremendous value creation opportunity, our branded private residences offer the potential to generate significant brand premiums and enhanced hotel economics as a result of co-location strategy, which help drive supplementary revenue (F&B, Spa) to the hotel.\n\nPrior to joining Accor, Daniel von Barloewen founded a real estate consultancy business, Strategic Development Advisors Ltd, which provided a range of development advisory services as well as hotel operator searches and contract negotiation to both institutional and private Attendeess. Before that, he was head of Mixed-Use Development Europe at Marriott International, and previously spent 11 years at Savills where he created and ran the Global Residential Development Consultancy department.\n\nOriginally a development surveyor, Daniel brings an over 18-year track record on the advisory side and hotel operator side of residential, mixed-use and integrated resort development projects, in over 40 countries, with particular expertise on branded residences and co-located hotel and residential development. He is skilled at working with a wide range of Attendees and developer profiles, with the ability to focus strategically on opportunity analysis, value generation, risk reduction, exit strategy, ROI and development strategy evaluation.\n\nDaniel speaks 4 languages, is also a Major in the British Army Reserves, and has served with distinction in Afghanistan. He holds a Bachelors Degree from the University of Durham, a Masters Degree from CASS Business School and is a Member of the Chartered Management Institute.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                                    "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 16:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Julien",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3Nzk3MzQwLFVzZXJfMTEyNTg3NTEp",
                "jobTitle": "Senior Director, Mixed-Use Development (EMEA)",
                "lastName": "Laloye",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/87c9b931df3243d1a7ea88d1c7554587.jpeg",
                "organization": "Marriott International",
                "biography": "With over a decade of extensive experience in the hospitality and real estate sectors, Julien is adept at driving mixed-use development projects to success. Currently serving as the Senior Director of Mixed-Use Development for the EMEA region at Marriott International, he looks after the growth of Marriott brands in the branded residential sector across the EMEA region.\n\nPrior to his current role, he held pivotal positions at renowned organizations across diverse global locations. During his tenure as Vice President – Hotels Advisory for JLL in Nairobi, then Hong-Kong, he advised investors and developers on their hospitality investments across sub-Saharan Africa as well as Asia Pacific. His tenure with Emaar Hospitality Group in hotel and branded residence development further enriched his understanding of development dynamics in the regional market.\n\nFueled by a passion for innovation and a commitment to excellence, Julien continues to drive forward-thinking strategies that redefine mixed-use developments, leaving a lasting impact on the landscape of hospitality and real estate.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                                    "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 16:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ali",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MTY5NzMxLFVzZXJfMTU3NTczMzUp",
                "jobTitle": "Senior Director Head of Hospitality, Hotels & Tourism",
                "lastName": "Manzoor",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/ee75f5da2004484ebe7a16782b1cd54b.jpeg",
                "organization": "CBRE MENA",
                "biography": "Ali is Head of Hotels & Tourism at CBRE in the Middle East, dedicated to providing creative, hands-on hospitality expertise across the region.\n \nHaving been in the industry for over 15 years, Ali is a well-established hospitality specialist with experience in hotel advisory, valuations and operations. During his time in the Middle East, Ali has worked with developers, Attendeess and governmental institutions on feasibility studies, hotel valuations, pricing strategies, asset reviews and optimum site use for both large-scale multi-use projects and stand-alone assets. He has also led several owner-operator Hotel Management Agreement negotiations across a number of jurisdictions.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxNA==",
                                    "title": "Travelling for Good: Innovations in Luxury Travel for Responsible Tourism Development",
                                    "beginsAt": "2024-04-30 14:55:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Stephen",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4NzkzNDQ4LFVzZXJfMjQxMjIzMDMp",
                "jobTitle": "Head of Development",
                "lastName": "Cheesebrough",
                "photoUrl": "https://static.swapcard.com/public/images/0f320eb6971948a3a0d568db60bb941a.png",
                "organization": "Red Sea Global",
                "biography": "Stephen Cheesebrough is the Red Sea destination's Head of Development at Red Sea Global (RSG).\n\nStephen leads the development of The Red Sea destination, one of the world’s most ambitious regenerative tourism destinations. His role spans the planning, development, and delivery of integrated resort communities, setting new benchmarks for sustainable tourism and luxury living in Saudi Arabia.\n\n\nJoining the company in 2018, he is responsible for overseeing asset business planning, master planning, design and delivery of all real estate projects within The Red Sea with a particular focus on hospitality, residential and experiential assets, and operator selection for The Red Sea’s portfolio as well as The Red Sea’s employee village.\n\nWith over 20 years of global real estate experience across Europe, the Middle East, and Asia, Stephen has a proven track record in development, asset management, master planning, investment strategy, and operational leadership. Prior to joining RSG, he held senior roles at Al Ghurair Properties, Sultan Investments, and Kublai Holdings, managing multi-billion-dollar real estate portfolios and large-scale development projects.\n\n\nStephen began his real estate career in Europe, co-founding a successful property investment firm before transitioning into senior leadership roles in the Middle East. Stephen brings a strategic, entrepreneurial approach to RSG, ensuring the destination’s developments are not only world-class but also aligned with Saudi Vision 2030 goals for sustainable growth.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQwOQ==",
        "titleTranslations": [
            {
                "value": "FHS Evening Reception at Maison Assouline - Hosted by RIKAZ",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-12 19:00:00",
        "endsAt": "2025-05-12 23:00:00",
        "descriptionTranslations": [
            {
                "value": "<p>You are cordially invited to a night of culture, creativity, and connection. Join our exclusive social gathering celebrating the elegant fusion of art and hospitality. Mingle with industry visionaries and creative luminaries for an evening where culinary artistry meets aesthetic inspiration.</p><p><a href=\"https://wkf.ms/4m4KnFR\">Click here to RSVP.</a></p><p>Coaches will leave from outside the main entrance of the Prince Sultan Grand Hall at 6pm.</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4Mzk5OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjY2MjU2NQ==",
        "titleTranslations": [
            {
                "value": "Pilates at the Top of the Tower",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 07:00:00",
        "endsAt": "2025-05-13 08:00:00",
        "descriptionTranslations": [
            {
                "value": "<p>Location: Top of the Al Faisaliah Tower, The Globe</p><p>A 60-minute Pilates class offering a blend of core strengthening, flexibility enhancement, and total body toning. This low-impact session focuses on precise movements for posture, balance, and muscle definition. Suitable for all skill levels, it's a perfect way to stretch, strengthen, and rejuvenate both body and mind.</p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4Mzk5OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Networking"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQwMQ==",
        "titleTranslations": [
            {
                "value": "Welcome Back",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 09:30:00",
        "endsAt": "2025-05-13 09:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=VWNucvVNjuE\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jessy El",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NDk2OTEyLFVzZXJfMjM0MDI0MjQp",
                "jobTitle": "Former Journalist",
                "lastName": "Murr",
                "photoUrl": "https://static.swapcard.com/public/images/04471469685a4bc5bdda3ee7c22b0a33.jpeg",
                "organization": "BBC",
                "biography": "Jessy El Murr is a PWC certified corporate trainer and a former BBC & Forbes Middle East journalist with 18+ years of news writing, editing and presenting. She is the Founder of Motahadith, a MENA based flagship corporate training business. \n\nShe covered exclusive news stories from Washington D.C, Afghanistan, Beirut and Riyadh. She has passion for captivating storytelling, public speaking and a successful track record in digital tools. She founded Motahadith|a in 2022, a unique public speaking and media training business, helping C-level executives to increase their media impact and executive presence. Jessy is am a licensed public speaking coach by (EAHEA) and a senior media trainer working with top international consulting firms including PWC. She continues to deliver trainings to senior government officials and top brand executives in Riyadh, Jeddah, Abu Dhabi, Dubai, and Kuwait.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQwNg==",
        "titleTranslations": [
            {
                "value": "Saudi Arabia Tourism Outlook: Shaping the Future from 2025 to 2040",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 09:35:00",
        "endsAt": "2025-05-13 10:05:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=mcihRWppLTg\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzYxNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "religious-tourism",
                "translations": [
                    {
                        "value": "Religious Tourism"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Muhammad",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MTY5NzY0LFVzZXJfMTI0Mjk4OTAp",
                "jobTitle": "President Domestic Tourism Business Unit",
                "lastName": "Bassrawi",
                "photoUrl": "https://static.swapcard.com/public/images/68d5ac9db08a4bc8b12240a95d18bc31.jpeg",
                "organization": "Saudi Tourism Authority",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Dunia",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDY2Mjc5LFVzZXJfMjMxNzIxNSk=",
                "jobTitle": "Partner | Head of Travel, Hospitality and Leisure",
                "lastName": "Joulani",
                "photoUrl": "https://static.swapcard.com/public/images/e5df3501067d4a65bfff3c6426c6e5dc.jpeg",
                "organization": "Deloitte Middle East",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Ibrahim",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NDg5ODIzLFVzZXJfMjMyNTI2Mzgp",
                "jobTitle": "Chairman",
                "lastName": "Alturki",
                "photoUrl": "https://static.swapcard.com/public/images/f3a84e0a281f44c1a786dbbe6d2fc7e2.jpeg",
                "organization": "Growth Partner",
                "biography": "Ibrahim Alturki is the Chairman of Growth Partner and a recognized expert in tourism, Hajj, and Umrah across Saudi Arabia and the broader region. With more than 22 years of experience, he has led strategic transformation projects focused on institutional development, data systems, and service integration for both public and private sectors.\n\nHe has played a leading role in national initiatives with government entities such as the Ministry of Tourism, Ministry of Hajj and Umrah, Ministry of Housing, Guests of God Program, and the Royal Commission for Makkah, as well as advising the Saudi Tourism Authority, General Authority for Awqaf, and several regional municipalities.\n\nIbrahim’s international contributions include projects in Egypt, Malaysia, Indonesia, Pakistan, India, Sudan, Uzbekistan, Germany, and other key tourism source markets. He has developed digital platforms, guided tourism data governance, and helped design market entry strategies aligned with Vision 2030.\n\nAs a trusted advisor to regulatory bodies like the Egyptian Tourism Federation, Uzbek Hajj Authority, and Sudan’s Supreme Council for Hajj and Umrah, Ibrahim is widely respected for his ability to bridge policy, strategy, and innovation.\n\nHe holds a Postgraduate Diploma in Business Administration from the University of Michigan.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Elie",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NTIxMjA5LFVzZXJfMTQ1Mzg3MCk=",
                "jobTitle": "Chief Development Officer, The Middle East, Northeast Africa, Cyprus and Greece",
                "lastName": "Milky",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/3e57faf6b16b416ba6dece262ac74733.jpeg",
                "organization": "Radisson Hotel Group",
                "biography": "Elie Milky is the Chief Development Officer for the Middle East, Northeast Africa, Greece, and Cyprus at Radisson Hotel Group, where he leads the Group’s strategic expansion and drives the growth of its diverse brand portfolio across key markets. His role covers development and conversions for all of Radisson’s core brands, including Prize by Radisson, Park Inn by Radisson, Radisson, Radisson Individuals, Radisson RED, Radisson Blu, art’otel, and Radisson Collection.\n\n\nElie was recently promoted to this expanded role following a successful 15-year journey with Radisson Hotel Group, where he joined in 2010 as Business Development Manager. Since then, he has become a driving force behind the company’s growth in the region, signing iconic deals, forging long-term relationships with key owners, and helping launch new brand propositions across diverse markets.\n\nA Lebanese national, Elie began his career in hotel operations, holding various management roles in Lebanon and the UAE from 2000 to 2005. He later joined HVS in London and Dubai, where he conducted feasibility studies, valuations, and strategic advisory across Europe, the Middle East, and Africa. This foundation in real estate and investment laid the groundwork for his transition into hotel development.\n\nElie is widely respected for his leadership style, market intuition, and ability to convert opportunities into long-term value. His strengths lie in strategic deal-making, whether signing single-asset or portfolio deals, and in launching brands and asset types that align with market demand. He is passionate about building meaningful partnerships and adding value to owner investments.\n\nHe holds an MBA in International Hospitality Management, specializing in Hotel Real Estate and Finance from IMHI–ESSEC Business School in Paris, and a BA in Hospitality Management and Tourism from Notre Dame University in Lebanon.\n\nOutside of work, Elie finds energy and inspiration in music, travel, sports, gastronomy, and quality time with his family. His purpose is rooted in leadership, growth, and balance.",
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxOA==",
                                    "title": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                                    "beginsAt": "2024-05-01 09:15:00",
                                    "endsAt": "2024-05-01 09:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTgzMDQzMA==",
                                    "title": "Navigating Regulatory Shifts: Legal Dynamics Reshaping Hospitality Real Estate in the Region and their Impact on Tourism Offerings",
                                    "beginsAt": "2024-05-01 10:20:00",
                                    "endsAt": "2024-05-01 10:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development",
            "Religious Tourism"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjY3MDk0Mg==",
        "titleTranslations": [
            {
                "value": "Welcome Remarks",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 10:00:00",
        "endsAt": "2025-05-13 10:05:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=embTsoDEzGQ\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzMxNDMyMjY0LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman & CEO",
                "lastName": "Worsley",
                "photoUrl": "https://static.swapcard.com/public/images/65ef700e7da4493ea8d79d2e53ba7532.jpeg",
                "organization": "The Bench",
                "biography": "Jonathan Worsley began his career at Forte and Holiday Inns before moving into hotel advisory roles at PKF and CBRE. In 1997, he co-founded IHIF Berlin, followed by The Bench, which started as a daily benchmarking company for the hotel industry and in 2008 merging with STR to create STR Global.  \n\nThe Bench evolved into a leading organiser of premier hospitality investment conferences and Jonathan continued bringing the hospitality investment community together in various parts of the world through AHIC - now Future Hospitality Summit (FHS), FHS Saudi, FHS Africa and SAHIC in Latin America. Later, he expanded into aviation and F&B with AviaDev and GRIF. \n\nIn 2020, Jonathan led The Bench’s pivot to virtual events, launching Hospitality Tomorrow and FHS for the G20 Saudi Secretariat. He continues to drive industry innovation through initiatives like the Startup Den and Lead the Change while serving on the boards of Fresh on Table, Envi Lodges, and other startups shaping the future of hospitality. \n\nHe is also a trustee of the World Sustainable Hospitality Alliance, Future Talent – a musical charity, a member of Women in Hospitality (WiH) and recently completed a board term with the Ras Al Khaimah Tourism Development Authority.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQxNw==",
        "titleTranslations": [
            {
                "value": "Planning with Purpose: Integrating Tourism Strategy and Conservation in Destination Development",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 10:05:00",
        "endsAt": "2025-05-13 10:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=rInvwQtAw4Q\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "esg",
                "translations": [
                    {
                        "value": "ESG & Human Capital"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzYzNA==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "destination-development",
                "translations": [
                    {
                        "value": "Destination Development    "
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Waleed",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5MDMwLFVzZXJfMTYyNTQwNzIp",
                "jobTitle": "Commercial Director",
                "lastName": "Abualnadi",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/88c841025ae541499e96edae25303cdc.jpeg",
                "organization": "Saudi Icon Company",
                "biography": "Waleed M. Abualnadi serves as the Commercial Director at Saudi Icon, bringing with him a rich professional background immersed in the construction, engineering, and fitout industry spanning nine years. His journey is marked by an unwavering commitment to continuous growth and excellence.\n\n Beginning his career with an engineering internship at Drake & Skull (ICC in KSA), Waleed acquired invaluable hands-on experience. Transitioning to the role of Electrical Engineer at ABEG KSA, he further honed his skills. Since 2016, Waleed has been pivotal in the success of Saudi Icon where he currently holding the position of Commercial Director.\n\n In his multifaceted role, Waleed adeptly manages three critical dimensions—cost analysis, technical documentation, presentations, and day-to-day commercial aspects of projects. His noteworthy contributions to the successful bids for Saudi Icon cannot be understated, helping to deliver high-profile hospitality projects, including the JW Marriott, Four Points Sheraton, Sindalah Hotel Clusters, and the Red Sea Global hotel projects. Beyond hospitality, Waleed has played a significant role in securing various projects in the government, semi-government, and private sectors. \n\nWaleed holds a degree in Electrical and Computer Engineering from the American University of Beirut. Beyond that, he earned his Masters degree from Leeds University in the UK, equipping him with advanced skills in managing engineering/tech business units. Outside the professional sphere, Waleed is a devoted husband and father to two wonderful children, Elyse and Mohammad. The intersection of his personal and professional life is evident through his marriage to a seasoned hotelier, offering a unique perspective on the hospitality industry.\n\n Waleed eagerly anticipates contributing insights and engaging with industry professionals at the Future Hospitality Summit.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5OQ==",
                                    "title": "Building Tomorrow: The Impact of Sustainable Construction on Evolving Demand Trends",
                                    "beginsAt": "2024-05-01 11:45:00",
                                    "endsAt": "2024-05-01 12:25:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTQ0Nw==",
                                    "title": "Data Talks: An Overview of Factors Impacting Hospitality Construction Costs in KSA",
                                    "beginsAt": "2024-04-29 14:20:00",
                                    "endsAt": "2024-04-29 14:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Joe",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3OTkwMjMwLFVzZXJfODI0ODc4NCk=",
                "jobTitle": "Founder & Managing Director",
                "lastName": "Tabet",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/92f3ad3bab5d49eebb2b626ffb308ba2.jpeg",
                "organization": "JT+Partners",
                "biography": "Joe Tabet is an award-winning architect and visionary business leader with over two decades of global experience in architecture and the construction industry. As the Founder and Managing Director of JT+Partners, Joe has built a reputation for delivering bold, sustainable, and culturally inspired design solutions that redefine urban living and hospitality experiences.\n\nIn 2015, Joe launched JT+Partners. Under his strategic leadership, the firm rapidly evolved into a globally recognized multidisciplinary consultancy, with projects spanning the Middle East, Africa, Europe, and beyond. Today, the firm boasts a diverse team of over 125 professionals across offices in Dubai, Abu Dhabi, and Beirut.\n\nJoe’s leadership style is rooted in innovation and adaptability. He champions progressive design thinking, cutting-edge technologies like digital twins, modular construction, 3D printing, and embraces the Internet of Things to future-proof his work. His ability to translate cultural narratives into timeless, cost-efficient design solutions has earned him industry acclaim and a loyal international clientele.\n\nJT+Partners' portfolio includes a wide spectrum of landmark projects—ranging from hotels, resorts, residential towers, and masterplans to hospitals and leisure destinations in UAE, KSA, Egypt, Seychelles, Greece, and beyond. The firm has received multiple honors from Cityscape, Arabian Property Awards, MEA Awards, and more.\n\nA strong advocate of corporate social responsibility, Joe fosters an inclusive, people-first company culture and supports initiatives around wellness, sustainability, and education. He is also a regular speaker at universities, design panels, and global forums—sharing his knowledge to inspire the next generation of architects.\n\nJoe Tabet’s visionary approach, global perspective, and commitment to excellence have positioned him as one of the region’s most influential architectural voices—shaping environments that go far beyond design.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg1NjIzMA==",
                                    "title": "TenX Leadership Talks: To the Metaverse with Hospitality",
                                    "beginsAt": "2024-04-30 15:20:00",
                                    "endsAt": "2024-04-30 15:35:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Hussam",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4ODg4MTk4LFVzZXJfMjQxNjU2NDcp",
                "jobTitle": "Co-Founder & CEO",
                "lastName": "Alhuzaimi",
                "photoUrl": "https://static.swapcard.com/public/images/e801aa11e54b4bbd8fa458a7fc56210d.jpeg",
                "organization": "Evolve Hospitality",
                "biography": "Hussam Alhuzaimi\nCEO – EVOLOVE  HOSPITALITY \n\nHospitality & Services | Masters Business Hospitality  | Hotel Development | Events & EXPO | Heritage & Culture | Tourism | Environment & Conservation |  PMP, PRINCE2, Lead Auditor ISO14001 [EMS] ,ISO 9001 [TQM] .LEED\n\nHussam Alhuzaimi has 20 years of experience in the space of Hospitality,  Events Tourism,  Sport & culture, MICE, Private & Government sectors.  \n\nToday He leads development of Mixed-Used Projects with hospitality components current project valuation is SR1.2 Billion.  Hussam holds a Master's Degree in Hospitality From Victoria University, Australia, Certified in Project Management PRINCE2.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Ben",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5ODQ0LFVzZXJfMTE5MTc1Nik=",
                "jobTitle": "Founder & Managing Partner",
                "lastName": "Baseley-Walker",
                "photoUrl": "https://static.swapcard.com/public/images/d56dd714dff84ff7aaf1c558c1c30e56.jpeg",
                "organization": "Andart Global",
                "biography": "Ben is the Managing Partner of Andart Global, a boutique strategy and advisory firm based in the GCC .He leads Andart’s strategy and reputation management work, delivering flagship projects across the GCC region.\n\nBen has extensive experience working in diplomacy, technology and global affairs for both private and public sector stakeholders including governments, the UN and multinational corporations.\n\nBen and his team excel in helping clients effectively craft a compelling and authentic position while actively safeguarding reputation. Notable GCC projects focused on situation-specific tactical advisory for destination marketing strategy, and increasing awareness of emerging markets and tourist destinations.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTQ0NQ==",
                                    "title": "How the changing City Dynamic influences Hospitality Offerings and the Consumer",
                                    "beginsAt": "2024-05-01 09:35:00",
                                    "endsAt": "2024-05-01 10:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MA==",
                                    "title": "Insights from Asia: What lessons can be learnt from other fast growing markets around the world?",
                                    "beginsAt": "2024-04-30 15:30:00",
                                    "endsAt": "2024-04-30 16:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Natasha",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NTY0MjU1LFVzZXJfNDg4MzkyMyk=",
                "jobTitle": "Director, Visitor Experience – Nature Reserve",
                "lastName": "Martin",
                "photoUrl": "https://static.swapcard.com/public/images/65f3b3eb8108429996df288db4a3aa7c.jpeg",
                "organization": "NEOM",
                "biography": "Natasha is a tourism expert that specializes in early-stage adventure and responsible tourism development. She has over fifteen years experiences across 30 countries, typically frontier and niche destinations including Saudi Arabia, Nepal, Greenland, and Namibia. She holds a Masters in Tourism Administration from The George Washington University.\n\nNatasha is currently the Director of Visitor Experience at the NEOM Nature Reserve where her main objective is to ensure that tourism is a tool for conservation. This includes designing and employing innovative destination management solutions, developing nature-positive and meaningful experiences and assets, and attracting tourists keen to explore the incredible array of opportunities that conservation tourism has to offer.\n\n ",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "ESG & Human Capital",
            "Destination Development"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjU2MDUxNw==",
        "titleTranslations": [
            {
                "value": "Keynote: Industry Insights from a Saudi Perspective",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 10:05:00",
        "endsAt": "2025-05-13 10:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=biecNPUK4DA\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences",
                "translations": [
                    {
                        "value": "Branded Residences"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jeff",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5ODMyLFVzZXJfMTc4MTEwNSk=",
                "jobTitle": "Chief Business Officer, Global Head of Mixed-Use",
                "lastName": "Tisdall",
                "photoUrl": "https://static.swapcard.com/public/images/665f0d09e03b46308f0adb0fb8011c4e.png",
                "organization": "Accor One Living",
                "biography": "Jeff Tisdall is Chief Business Officer, Accor One Living and Global Head of Mixed-Use. Accor One Living is an industry first mixed-use platform, focused on the development and operation of branded residences. Leveraging Accor’s two decades of residential experience pioneered under iconic brands like Fairmont and Raffles, the Group is now developing trend setting residential solutions across luxury, lifestyle, premium and midscale segments. \n\nPrior to joining Accor in 2013 (via FRHI Hotels and Resorts), Tisdall was the Managing Director of Singapore-based LIFT, where he served as branded residential advisor to FRHI and the Jumeirah Group. Previously, Tisdall worked with Wyndham Worldwide in Dubai, as Managing Director with responsibility for the company’s RCI and Registry Collection brands in the Middle East and North Africa region. He was also Vice President of Real Estate at Kingdom Hotel Investments, where he managed the company’s residential and commercial real estate portfolio. Earlier in his career, Tisdall spent 13 years with Intrawest, leaving as a Senior Vice President at the company’s premium vacation ownership division. \n\nTisdall holds a degree from McGill University in Canada and lives in Dubai with his family.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjU4NDQ5Nw==",
        "titleTranslations": [
            {
                "value": "Stakeholder perspectives – How do branded residences create value for investors, homeowners and brands",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 10:20:00",
        "endsAt": "2025-05-13 11:15:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=cH0s6dLYCek\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences",
                "translations": [
                    {
                        "value": "Branded Residences"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Daniel von",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3MTY0OTI2LFVzZXJfOTc0MTM4OSk=",
                "jobTitle": "Senior Vice President, Global Mixed-Use Development",
                "lastName": "Barloewen",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/5cf473e2ddec40608d2edc80e017428d.jpeg",
                "organization": "Accor One Living",
                "biography": "Daniel von Barloewen is the Regional Vice President of Accor One Living and Head of Mixed-Use for Accor for Europe, Middle East, Africa and India. His remit covers development, brand advisory & marketing support for development partners, as well as operations for branded residences, golf, private members’ clubs, and co-working.\n\nBoasting 42 brands, over 6,500 open and pipeline hotels with c.1,000,000 rooms, Accor is the world's 2nd largest branded residential operator (with over 150 open and pipeline residence projects, approximately 25,000 Residences, with more than USD $15bn of value of real estate licensed under 25 of its brands in the Accor and Ennismore portfolio). In 2023 more than $2.2Bn of residential real estate was sold under Accor brands.\n\nAccor offers world class residential expertise, bringing iconic brands and legendary hospitality service to private home ownership. Located in prime urban locations and the sought after resort destinations, our residential properties are a natural extensions of our iconic hotel brands. Providing development partners with a tremendous value creation opportunity, our branded private residences offer the potential to generate significant brand premiums and enhanced hotel economics as a result of co-location strategy, which help drive supplementary revenue (F&B, Spa) to the hotel.\n\nPrior to joining Accor, Daniel von Barloewen founded a real estate consultancy business, Strategic Development Advisors Ltd, which provided a range of development advisory services as well as hotel operator searches and contract negotiation to both institutional and private Attendeess. Before that, he was head of Mixed-Use Development Europe at Marriott International, and previously spent 11 years at Savills where he created and ran the Global Residential Development Consultancy department.\n\nOriginally a development surveyor, Daniel brings an over 18-year track record on the advisory side and hotel operator side of residential, mixed-use and integrated resort development projects, in over 40 countries, with particular expertise on branded residences and co-located hotel and residential development. He is skilled at working with a wide range of Attendees and developer profiles, with the ability to focus strategically on opportunity analysis, value generation, risk reduction, exit strategy, ROI and development strategy evaluation.\n\nDaniel speaks 4 languages, is also a Major in the British Army Reserves, and has served with distinction in Afghanistan. He holds a Bachelors Degree from the University of Durham, a Masters Degree from CASS Business School and is a Member of the Chartered Management Institute.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                                    "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 16:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Imran",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4Njk4NDQ3LFVzZXJfMTYwMzk4ODgp",
                "jobTitle": "Executive Director Hospitality Development & Dean of Centre Expertise, CoE",
                "lastName": "Changezi",
                "photoUrl": "https://static.swapcard.com/public/images/f9218e8dc3d1467883cad34709a59cf1.png",
                "organization": "Diriyah Company",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Rohan",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDYyNDI5LFVzZXJfMTU3NjE3NzUp",
                "jobTitle": "Associate Vice President, Real Estate & Development",
                "lastName": "Ranade",
                "photoUrl": "https://static.swapcard.com/public/images/5c50ff2690024f8e88f60a8ffb14bc17.jpeg",
                "organization": "The Indian Hotels Company Limited",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Rashid",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MTY3NTc5LFVzZXJfMTYwMzgxNzgp",
                "jobTitle": "Portfolio Director",
                "lastName": "Aboobacker",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/657107b0213243948feee33d7bdfc6ec.jpeg",
                "organization": "Rua Al Madinah Holding Company",
                "biography": "Rashid Aboobacker is the Portfolio Director of Asset Management at Rua Al Madinah Holding, a wholly-owned subsidiary of Saudi Arabia’s Public Investment Fund (PIF) that aims to elevate the experience of residents and visitors to the holy city of Madinah through a range of holistic urban development projects. As the owner's representative, he currently oversees the construction of hotel and branded residence assets as well as managing the retail and office components within Rua Al Madinah development project. Rashid previously held the post of Director of Business Development at the Riyadh-based Amaala. Prior to that, he worked as a director at TRI Consulting in Dubai, where he gave developers and owners of hospitality and mixed-use properties in the MENA area strategic guidance.\n\nRashid Aboobacker holds certificates from esteemed organizations, including Cornell University and the London School of Economics, as well as a Master's degree in international business",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Rico",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MzkwNTAyLFVzZXJfOTM2ODI5MCk=",
                "jobTitle": "Head of Global Residential Development Consultancy",
                "lastName": "Picenoni",
                "photoUrl": "https://static.swapcard.com/public/images/5f9894b3287d4f55aeeb70c91486e8ed.jpeg",
                "organization": "Savills",
                "biography": "Rico is head of global residential development consultancy with Savills UK, with a background in hotel and branded residential strategy including programming, mixed-use integration & standalone branding models, as well as best practices in legal & contractual structuring within the greater hospitality context.\n\nRico works in international markets including North America, Europe, the Middle East and APAC. His experience involves project feasibility, contract negotiations & commercial structuring, as well as operational structuring and mixed-use integration.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjYyOTQ1Ng==",
        "titleTranslations": [
            {
                "value": "The Power of the Middle: Scalable, Sustainable, Smart",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 10:40:00",
        "endsAt": "2025-05-13 11:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=EPVEJnCiF6M\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "brand-development",
                "translations": [
                    {
                        "value": "Brand & Destination"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Nikolina",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3MDQ1NzQwLFVzZXJfMTkxNjg5NjAp",
                "jobTitle": "Former Minister Tourism",
                "lastName": "Angelkova",
                "photoUrl": "https://static.swapcard.com/public/images/be577fb8e2b044c98cc51dc0dc10fb55.jpeg",
                "organization": "Bulgaria",
                "biography": "Nikolina Angelkova is a Harvard business school alumni 2010, graduated from the Leadership development program. In April 2023 she completed Harvard Kennedy School of Government Executive Program for “Global Leadership and Public Policy in the 21st century.” She is Master in Law from UNWE, Sofia and she has specialized financial management of the EU structural funds, regional policy and government to the Institute of Public Administration in Maastricht and the Regional Institute for Public Administration in Nantes, France. She has done a number of executive education programs in Harvard business school for real estate development, negotiations and mergers and acquisitions.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Duncan",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4NjcxNDA2LFVzZXJfNDk4NTU2MCk=",
                "jobTitle": "Chief Executive Officer, Middle East, Africa & Asia Pacific - Premium, Midscale & Economy",
                "lastName": "O’Rourke",
                "photoUrl": "https://static.swapcard.com/public/images/1c3e3941e7364f5499e61c5ed5068869.jpeg",
                "organization": "Accor",
                "biography": "Duncan O’Rourke holds a degree from César Ritz Colleges in Switzerland and a MBA from Reims Management School.\n\nWith more than 30 years’ experience within the industry, he held several executive positions in Europe, the US and the Middle East. From 2004, he served as General Manager for Kempinski in various destinations before being promoted to the position of Regional Director overseeing the Operations of the properties in the Middle East. In 2008, he was appointed Chief Operating Officer of Kempinski Hotels and became part of the Management Board at the same time.\n\nDuncan joined Accor in 2016 as COO Europe for the Luxury and Premium segment before taking over as COO Central Europe. In that capacity, he was responsible for more than 470 hotels and 13 brands within Germany, Austria and Switzerland. In October 2020, Duncan was appointed CEO Northern Europe, overseeing more than 1,100 hotels and 40,000 team members across 32 countries, and joins Accor’s Executive Committee.\n\nIn January 2023, Duncan joined Accor’s Premium, Midscale & Economy Executive Committee as the division’s CEO Middle East, Africa, Turkey & Asia Pacific.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Dimitris",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MjAxNzUwLFVzZXJfMTc3MDc3NSk=",
                "jobTitle": "President, Europe, Middle East, Eurasia and Africa (EMEA)",
                "lastName": "Manikis",
                "photoUrl": "https://static.swapcard.com/public/images/af79623c9c6b421abb885caf4ccb29d4.jpeg",
                "organization": "Wyndham Hotels & Resorts",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Brand & Destination"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQxOA==",
        "titleTranslations": [
            {
                "value": "Balancing Growth: Unlocking the Potential of Mid-Market Hospitality in Saudi Arabia's Luxury Landscape",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 11:00:00",
        "endsAt": "2025-05-13 11:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=MOI47uMRHEw\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-saudi-arabia",
                "translations": [
                    {
                        "value": "Focus on Saudi Arabia"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Ayman",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5MDk1LFVzZXJfMTkyNjQ0MDgp",
                "jobTitle": "Director, Business Development, Middle East, Egypt and Pakistan",
                "lastName": "Ezzeddine",
                "photoUrl": "https://static.swapcard.com/public/images/29bcc24eaa2e4b15877b20aaf9a571ae.jpeg",
                "organization": "Radisson Hotel Group",
                "biography": "Ayman Ezzeddine is a seasoned hospitality and business development professional, currently serving as the Director of Development for the Middle East, Egypt and Pakistan at Radisson Hotel Group since January 2024. Based in Dubai, UAE, Ayman brings over a decade of experience in various leadership roles across prominent hospitality brands. His career is marked by a keen understanding of what owners and guests seek in the industry, consistently creating successful strategies that align these interests.\n\nHis career started with Kempinski Hotels followed by a few years with Shaza Hotels, and his career in business development is further highlighted by his tenure at WATG and Wimberly Interiors as the Business Development Director for the MEA region. During this time, he played a crucial role in expanding the company’s footprint across the Middle East and Africa. Before joining Radisson Hotel Group, Ayman was the Regional Director of Business Development at Golden Tulip MENA / Louvre Hotels Group.\n\nAyman is motivated by the region's remarkable growth and is committed to contributing to the rapid expansion of the Radisson Hotel Group, one of the largest hotel groups in the world\n\nWhen not working, Ayman enjoys exploring the industry from a tourist's perspective by traveling and immersing himself in new cultures",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Adil",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3MTAzNjM3LFVzZXJfMTg0NTE3Njkp",
                "jobTitle": "Development Director MENA",
                "lastName": "Jabrayilov",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/e8db8e58573c4e0ba752101aa67f06b4.jpeg",
                "organization": "Louvre Hotels Group",
                "biography": "My name is Adil Jabrayilov, and I am 26 years old. Originally Azerbaijani, I am a graduate of Glion Institute of Higher Education with a major degree in International Hotel Development and Real Estate Finance. I have also completed few eCornell courses, namely Hotel Real Estate Investments and Hotel Planning and Design and I have been acknowledged as a Certified Hotel Valuer by International Association of Hotel Appraisers.\n\nI have started my career in Hilton Worldwide as part of a Feasibility & Investment Analysis team for Middle East and Africa region. Following few years in Dubai office, I have joined Hilton’s Development team for Central and Eastern Europe region and have been covering Turkish and Azerbaijani markets. After a successful time in Hilton’s Istanbul corporate office being involved in multiple deal signings, I have come back to the Middle East and joined Royal Group as the Development Manager Hospitality. I have led the development process for multiple projects across the EMEA embarking multiple milestones, including but not limited 2 luxury hotel developments in Seychelles, 1 in Greece, and few in the Middle East Region. The one that I particularly would like to call off is Mallside Hotel & Residences Dubai Hills, Curio Collection by Hilton. The following property consists both of hotel and branded residences parts and it is noteworthy that the residences have sold out already during the pre-launch period.\n\nI am currently Development Director for MENA region for Louvre Hotels Group and develop such esteemed brands as Royal Tulip, Golden Tulip, Tulip Hotels & Residences, Campanile, Kyriad, Tempting Places and Hotels & Preference. The following brands have huge potential to grow their presence further in the MENA market and add incredible value to the properties from both return on investment and guest experience. With 1’700 hotels globally across 60 countries, Louvre Hotels Group currently licenses or operates 55 hotels across the MENA region and we aim to reach 100 hotels within the next few years.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNA==",
                                    "title": "Economic Resurgence: The rise of Mid-Scale Hotels in Cities across the Kingdom",
                                    "beginsAt": "2024-04-30 16:30:00",
                                    "endsAt": "2024-04-30 17:10:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Oussama",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NTUyMDUwLFVzZXJfMjA4MDcxNTUp",
                "jobTitle": "Partner - Head of Hospitality, Tourism & Leisure Advisory Services MENA",
                "lastName": "El Kadiri",
                "photoUrl": "https://static.swapcard.com/public/images/dc29cc55509a4976a69bfc9f6d8f860c.png",
                "organization": "Knight Frank",
                "biography": "Having an extensive experience in real estate & hospitality management across Europe and the Middle East and North Africa, Oussama benefits from unique experience having previously headed the hotel development activities in the Middle East for international operators such as Accor with a focus on the Premium, Midscale and Economy brands of the group, as well as Radisson Hotel Group with a focus on Saudi Arabia.\nHis real estate and hospitality consulting experience spans over a variety of geographies within the EMEA region. While being a hospitality specialist, Oussama has had exposure to most asset classes including hospitality, residential, retail, entertainment and MICE which are key in advising on the best-in-class mixed-use project. Oussama advised on the tourism & hospitality segment for many of the shaping projects in Saudi Arabia, including KAFD, NEOM, Al Ula, Al Soudah, Dirriyah Gate and many others.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Alexey",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDg4NjE5LFVzZXJfMTYyMjQ0MjYp",
                "jobTitle": "Senior Director Development",
                "lastName": "Korobkin",
                "photoUrl": "https://static.swapcard.com/public/images/4a630fefcc5e4195bf62d40aac672cf6.jpeg",
                "organization": "IHG Hotels & Resorts",
                "biography": "Alexey Korobkin, Senior Director Development Middle East & Africa \n\nAlexey leads IHG Hotels & Resorts’ development across the Middle East & Africa, driving the expansion of IHG’s diverse brand portfolio and forging key partnerships to accelerate growth in the region.\n\nPreviously, Alexey served as a Senior Development Director for IHG in Russia. Prior to joining IHG, Alexey worked in development at Azimut Hotels, Marriott International and InterContinental Hotels Group (IHG) for almost 10 years. In that time, Alexey helped to expand the portfolio of brands in the region as well as drive strong returns for owners.\n\nPrior to working in hotel development, Alexey headed up the Moscow Consulting & Valuation practice of HVS Global Hospitality Services, where he specialized in strategic consulting, valuations and investment advisory across Russia & the CIS.\n\nAlexey also worked for various hotel management companies within the hospitality industry across Europe, the US and Russia and served in such operational departments as Rooms Division, Revenue Management and Food & Beverage.\n\nAlexey obtained BSc Economics and Finance from the University of London, as well as an MBA in Hotel Management from César Ritz, Switzerland.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Talal",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MjAxNzAxLFVzZXJfMTU3MTE2MTEp",
                "jobTitle": "Director - Lodging Development",
                "lastName": "Yousif",
                "photoUrl": "https://static.swapcard.com/public/images/428a15093f314eee8b743a4763a1cd75.jpeg",
                "organization": "Marriott International",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development",
            "Focus on Saudi Arabia"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjU4NDUwMQ==",
        "titleTranslations": [
            {
                "value": "Navigating the Legal Framework of Branded Residences in Saudi Arabia",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 11:15:00",
        "endsAt": "2025-05-13 11:40:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=Wogwo4UO8CI\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences",
                "translations": [
                    {
                        "value": "Branded Residences"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Khaled",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MTMzMDAzLFVzZXJfMTQ2Njc2OCk=",
                "jobTitle": "Partner, Co-Head of Real Estate and Hospitality Middle East",
                "lastName": "Zowayed",
                "photoUrl": "https://static.swapcard.com/public/images/dd92179458104c9f9d5b2de995de9bd8.jpeg",
                "organization": "Baker McKenzie",
                "biography": "Khaled is a leading lawyer that specializes in real estate and hospitality transactions in the Middle East, with a particular focus in Saudi Arabia. Having been involved in hotel transactions in the market since 2011, Khaled has worked on negotiating over 150 hotel management agreement, branded residences, and franchise agreements in KSA. He is praised for his \"commercial approach\" and his \"wealth of knowledge\" that he brings to each hospitality transaction.\n\nHe is recognized by leading directories including Legal 500 - Real Estate & Construction 2025 - Saudi Arabia - as a Leading Partner in his field.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Moustafa",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MzI5Nzk4LFVzZXJfMTYwOTUzNzIp",
                "jobTitle": "Founder & Partner",
                "lastName": "Said",
                "photoUrl": "https://static.swapcard.com/public/images/18bdf4b7d36e46a4909308223311f493.jpeg",
                "organization": "Wisefields",
                "biography": "Moustafa is a founding partner specialising in real estate, hotels, and tourism. He has extensive experience in real estate, particularly in hotel and branded residence developments. \n\nWith considerable experience in the United Arab Emirates, Saudi Arabia, and other jurisdictions in the region, Moustafa represent numerous prominent master developers, sub-developers, and hotel owners and operators in the region, earning recognition for his sophisticated development practice. \n\nHe has been recognised as a leading real estate lawyer by Chambers Global from 2014 through 2022, and by Legal 500 EMEA for 2014, 2016 through to 2023.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgzMDQzMA==",
                                    "title": "Navigating Regulatory Shifts: Legal Dynamics Reshaping Hospitality Real Estate in the Region and their Impact on Tourism Offerings",
                                    "beginsAt": "2024-05-01 10:20:00",
                                    "endsAt": "2024-05-01 10:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Rhonda",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MzkyMTYyLFVzZXJfMjU2NjcwNik=",
                "jobTitle": "General Legal Counsel",
                "lastName": "Hare",
                "photoUrl": "https://static.swapcard.com/public/images/d9b704e2c809432c8f726b912549a0fb.jpeg",
                "organization": "Ennismore",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjUyOA==",
        "titleTranslations": [
            {
                "value": "Announcements & Signings",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 11:30:00",
        "endsAt": "2025-05-13 13:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8yNTg4MzM4MA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "centre-stage",
                "translations": [
                    {
                        "value": "Centre Stage"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [],
        "priority": 10
    },
    {
        "id": "UGxhbm5pbmdfMjUzNTg4NA==",
        "titleTranslations": [
            {
                "value": "Could Hotel F&B set a World first by dominating the Mid Sector Dining Market in the kingdom?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 11:30:00",
        "endsAt": "2025-05-13 11:50:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=hhXwi5QB8Vg\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNzA3NTM4MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "luxury-fandb-and-experiential-hospitality",
                "translations": [
                    {
                        "value": "Luxury, F&B, and Experiential Hospitality"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Stefan",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3Nzk3MzcyLFVzZXJfMTg5OTI1OTMp",
                "jobTitle": "Managing Partner-Consulting",
                "lastName": "Breg",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/41525c7c9fe74668bbba9fb57926cf94.jpeg",
                "organization": "KEANE: Consult & Create",
                "biography": "Stefan is Managing Partner-Consulting at KEANE providing the lead on strategic F&B consulting for KEANE’s studios in Birmingham, Dubai and Riyadh. KEANE leverage a unique ’consult & create’ model and has established itself as one of the region’s leading F&B consulting firms. He has previously held regional leadership roles at Starwood/Marriott for EMEA, IHG (SE Asia) Hilton (Europe) and E&Y Consulting. Stefan has over 500 F&B concepts to his name and brought brands such as Buddha Bar, Hakkasan, Pierre Gagnaire and Embassy to the Middle East as well as helped develop icons such as Mall of the Emirates and Yas Island.  KEANE are currently working on the leading giga projects in the Kingdom of Saudi Arabia and have built a reputation for their industry-leading approach to F&B strategy, masterplanning, concept development, interior and brand design.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTM3OA==",
                                    "title": "Exploring New Frontiers: Pioneering the Future of Entertainment and Beach Clubs in the Kingdom",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ola",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3Nzk3Mzc3LFVzZXJfMjM1NzE1NDgp",
                "jobTitle": "Founder & CEO",
                "lastName": "Kayal",
                "photoUrl": "https://static.swapcard.com/public/images/6a9f9d2752154c5393f4e3a56a69651c.jpeg",
                "organization": "Nabati",
                "biography": "As the founder of Nabati: A Conscious Eatery, this Saudi chef seamlessly integrates her passion for food and sustainability. Crafting a dining experience that is both innovative and mindful. Her entirely plant-based, gluten-free, and refined sugar-free menu embodies a commitment to zero waste and plastic-free principles, redefining ethical dining. She also pioneered a nutritious ice cream, demonstrating that indulgence and well-being can harmoniously coexist. Through Nabati, she transforms the way we engage with food by making sustainability not just a choice but a refined, accessible, and deeply satisfying way of life.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Muin",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3MjI0MDc0LFVzZXJfMjA3ODc2NzAp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Serhan",
                "photoUrl": "https://static.swapcard.com/public/images/2ca186381f1a453c84f2b9e39d502d5b.jpeg",
                "organization": "Amsa Hospitality",
                "biography": "Driving Amsa Hospitality’s business growth as Chief Executive Officer, Muin leverages his 24 years of global experience with leading hotel chains to guide the team toward long-term success. His career as an award-winning hotelier has showcased his ability to build and operate successful mega properties, even in upscale locations. A prolific public speaker, Muin’s achievements have earned him numerous accolades within the hospitality industry both in the Kingdom and abroad.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Ibrahim",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDU3MzM3LFVzZXJfMTE2NzYwOTAp",
                "jobTitle": "Executive Partner",
                "lastName": "Alsini",
                "photoUrl": "https://static.swapcard.com/public/images/30e0413f819443c987dd30afe7faa919.jpeg",
                "organization": "Inaar",
                "biography": "Dr. Ibrahim Alsini brings over 25 years of leadership in tourism, hospitality, and cultural development. He leads INAAR Consultancy, a Saudi-based firm advising government entities and corporates on hospitality strategy, cultural tourism, and food sector transformation—delivering projects that align operational excellence with global benchmarks.\n\nA former Vice President at Saudi Airlines Catering and Dean of the Faculty of Tourism at King Abdulaziz University, Dr. Alsini has played a pivotal role in shaping Saudi Arabia’s tourism and hospitality landscape. He has served as a judge for the Middle East Hotelier Awards and the Saudi Tourism Excellence Awards.\n\nDr. Alsini holds a PhD in Hospitality Management from the University of Surrey and a Proficiency Certificate from Ecole Hôtelière de Lausanne. He also represents The Protocol School of Washington in Saudi Arabia, supporting the advancement of international protocol and corporate etiquette standards across sectors.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Luxury, F&B, and Experiential Hospitality"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjY2NTczOQ==",
        "titleTranslations": [
            {
                "value": "Curated Connections - Wellness",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 11:30:00",
        "endsAt": "2025-05-13 12:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4Mzk5OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNzQyNjgyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "networking-lounge",
                "translations": [
                    {
                        "value": "Networking Lounge"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [],
        "priority": 19
    },
    {
        "id": "UGxhbm5pbmdfMjYyOTQ2MQ==",
        "titleTranslations": [
            {
                "value": "Selling Luxury: Marketing Branded Residences to Chinese Investors",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 11:40:00",
        "endsAt": "2025-05-13 12:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=vn9fJWTgl8A\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences",
                "translations": [
                    {
                        "value": "Branded Residences"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Sally",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4NzQ4MDM0LFVzZXJfMjA4MDk1MTMp",
                "jobTitle": "Founder and Managing Director",
                "lastName": "Maier-Yip",
                "photoUrl": "https://static.swapcard.com/public/images/e167271ea40e48a09196616faa91965f.jpeg",
                "organization": "11K Consulting",
                "biography": "Sally is a trusted cross-cultural communications advisor with a simple mission to help ambitious companies to grow in the complex China market, domestically and abroad.\n\nOver the past two decades, Sally has built a successful career on delivering award-winning multi-stakeholder communications strategies for multi-national and local companies.\n\nIn 2015, Sally founded 11K Consulting - a London-based China-specialist communications consultancy that unlocks the market potential of Chinese high-net-worth-individuals and investors through sharing unique insights, tailored communications strategies and providing unparalleled access. \n\nWith teams in London and Shanghai and affiliate networks in Singapore, Hong Kong, UAE, the USA, and globally, 11K are a team of modern, multi-lingual trusted advisors who are culturally astute, connected and who understand your business priorities as well as the needs and aspirations of these valuable customer groups.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjUzMzkwOQ==",
        "titleTranslations": [
            {
                "value": "The Transformation Economy is here, are you ready?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 11:50:00",
        "endsAt": "2025-05-13 12:05:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=nbCa7dFIwys\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4NDAwMw==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "Keynote Presentation",
                "translations": [
                    {
                        "value": "Keynote Presentation"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNzA3NTM4MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "luxury-fandb-and-experiential-hospitality",
                "translations": [
                    {
                        "value": "Luxury, F&B, and Experiential Hospitality"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jake",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTM3NjQzLFVzZXJfMjMwODg4ODUp",
                "jobTitle": "Founder, Chair, and Chief of Innovation and Impact",
                "lastName": "Haupert",
                "photoUrl": "https://static.swapcard.com/public/images/f7beff0998f34f81828285391e0e2930.jpeg",
                "organization": "Transformational Travel Council",
                "biography": "Jake Haupert is a recognized figure in the field of transformative tourism, speaking, teaching, and guiding its expansion and implementation. He is a founder and/or owner of eight travel brands that stretch across the category, including glamping, wine touring, and inbound and outbound adventure travel companies.\n\nCurrently, Jake is shepherding the Transformational Travel Council (TTC) and is Chair of its Institute. He and his team guide purpose-driven travel leaders, brands, and destinations in understanding and embracing sustainability practices, transformative experience strategy, the transformation economy, and regenerative community development.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Luxury, F&B, and Experiential Hospitality"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjU4NDUwMw==",
        "titleTranslations": [
            {
                "value": "The Brand Advantage: How Branding Enhances Sales & Marketing in Residential Real Estate",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 12:00:00",
        "endsAt": "2025-05-13 12:40:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=Fa4LknM4CmY\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences",
                "translations": [
                    {
                        "value": "Branded Residences"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Lindsay",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NjM4ODg0LFVzZXJfMjM0ODQ4NTQp",
                "jobTitle": "Global Vice President, Residential Marketing",
                "lastName": "McGinn",
                "photoUrl": "https://static.swapcard.com/public/images/40e3583390b74ba990aac2988788e0b8.jpeg",
                "organization": "Accor One Living",
                "biography": "Lindsay McGinn leads residential marketing for Accor One Living, Accor’s turn-key 360 degree platform focused on the development, marketing and operation of branded residential. With over 20 years experience in luxury marketing, Lindsay brings together her global network and brand marketing expertise to residential developers, optimizing strategies and campaigns for the 25+ Accor brands with residential.  \n\nPrior to joining Accor, she held senior residential marketing positions at Rosewood Hotel Group and Four Seasons Hotels and Resorts. She started her luxury marketing career in 2005 with New York based real estate and hospitality branding agency, The Seventh Art.\n\nLindsay holds a degree from the University of Toronto and lives in Switzerland with her family.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Jade",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NDY2OTE1LFVzZXJfMjQ1MjI4NTcp",
                "jobTitle": "Founding Director",
                "lastName": "Hall",
                "photoUrl": "https://static.swapcard.com/public/images/20ae492278794ffb805447011a571dad.png",
                "organization": "Astral Placemaking Group",
                "biography": "Jade Hall is a placemaking strategist, experience designer, and founder of Astral Placemaking Group. Formerly at Savills, she led global placemaking and marketing strategies across London, Europe, and the Middle East. Jade has shaped renowned projects, from The Leadenhall Building’s business community transformation to Elektrownia Powiśle’s blend of heritage and modern experiences. She has also consulted across confidential giga projects under NDA and continues to consult on transformative developments in the Middle East. Astral Placemaking Group delivers destinations through immersive storytelling, brand experience, customer-first strategy, creativity and innovation. Jade merges commercial insight with culture to craft meaningful, future-ready places.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Antony",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NTAwNjg4LFVzZXJfMTU2OTkyMDMp",
                "jobTitle": "Chief Experience Officer",
                "lastName": "Doucet",
                "photoUrl": "https://static.swapcard.com/public/images/b6e466680e154bcf9f83b26c91b2e645.jpeg",
                "organization": "Kerten Hospitality",
                "biography": "",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Clare",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NTA5MTA5LFVzZXJfMjEwMzE0MzUp",
                "jobTitle": "Partner-Residential Consultancy",
                "lastName": "Moukabaa",
                "photoUrl": "https://static.swapcard.com/public/images/0ee07435fc6c4c29a963cc3c1b3184e3.jpeg",
                "organization": "Knight Frank Middle East Limited",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Branded Residences"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQwNA==",
        "titleTranslations": [
            {
                "value": "Branding Saudi: Forming an Authentic Identity in a Global Market",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 12:05:00",
        "endsAt": "2025-05-13 12:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=4gWja2qMcuM\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTA1OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branding-and-culture",
                "translations": [
                    {
                        "value": "Branding & Culture"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "focus-on-saudi-arabia",
                "translations": [
                    {
                        "value": "Focus on Saudi Arabia"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Catherine",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4NDQyMDk5LFVzZXJfNzgzNTgxKQ==",
                "jobTitle": "Chief Strategy Officer",
                "lastName": "Edwards",
                "photoUrl": "https://static.swapcard.com/public/images/56b5c581532147f6a330a6a89310b1b3.jpeg",
                "organization": "QUO Global",
                "biography": "Catherine is a brand strategist and storyteller with a deep passion for cultural narratives and human behavior. She joined QUO in 2011 as a content director, later transitioning into brand strategy, where she played a key role in shaping QUO’s approach to brand cultural definition.\n\nAs the leader of QUO’s Growth team, Catherine focuses on expanding the agency’s presence across APAC, the Middle East, and Europe. Whether driving new business or collaborating on client projects, she is passionate about branding theories and methodologies. She believes in the power of storytelling to bring a brand’s core purpose to life, drawing on her background in writing to craft compelling narratives.\n\nCatherine has worked with some of QUO’s most notable clients, reimagining brands for both boutique hotels and global hospitality groups across diverse cultures and destinations. Her experience spans partnerships with industry leaders such as Accor, Marriott, Hilton, NEOM, PIF, Mandarin Oriental Hotel Group, and Deutsche Hospitality.\n\nA graduate of University College London (UCL), Catherine began her career as a journalist, writing and editing for leading lifestyle and business publications in London and Bangkok.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg2OTMyMw==",
                                    "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – An unbiased Perspective",
                                    "beginsAt": "2024-04-30 16:35:00",
                                    "endsAt": "2024-04-30 16:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Govind",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4NzQzMjk0LFVzZXJfOTg4NzQ0Nik=",
                "jobTitle": "Head of Development - MEA",
                "lastName": "Mundra",
                "photoUrl": null,
                "organization": "Wyndham Hotels & Resorts",
                "biography": "Govind Mundra, Head of Development – Middle East and Africa at Wyndham Hotels & Resorts \n\nGovind Mundra is the Head of Development for the Middle East and Africa (MEA) region at Wyndham Hotels & Resorts (WHR), based in Dubai, UAE. In this role, he leads the strategic expansion of WHR’s hotel portfolio across MEA, driving growth and development initiatives in key emerging markets.\n\nWith over 23 years of experience in hospitality development, real estate, and construction, Govind has worked extensively across South West Asia, the Middle East, and Africa. He began his career in 2002 as a Junior Engineer with a design consultancy in Assam, India, before joining Ambuja Realty Development Limited (now Ambuja Neotia Group) in 2003. Over his seven-year tenure, he advanced to Assistant General Manager – Design & Development, contributing significantly to real estate and hospitality projects in Eastern India.\n\nAfter completing his Master’s degree in 2011, Govind joined Wyndham Hotels & Resorts as Senior Manager – Development (Indian Ocean). He later moved to Johannesburg, South Africa, to serve as General Manager – Development (Sub-Saharan Africa) for Taj Hotels. In 2016, he rejoined WHR as Director of Development for the Eurasia region, playing a key role in the company’s expansion over the next eight years. In December 2023, he took on his current position, leading development efforts for WHR in the MEA region.\n\nGovind holds a Master’s degree in Hospitality Administration from École Hôtelière de Lausanne, a Certificate in Hotel Real Estate & Asset Management from Cornell University, and a Bachelor's degree in Civil Engineering from Visvesvaraya Technological University, India.\n\nLinkedIn Profile - http://in.linkedin.com/pub/govind-mundra/1a/b01/105",
                "withEvent": {
                    "eventProfile": {
                        "type": "Delegate",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Majed",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDg2NjUxLFVzZXJfMTU3NTkzNTkp",
                "jobTitle": "Vice President Business Development",
                "lastName": "Kaki",
                "photoUrl": "https://static.swapcard.com/public/images/8acd316f3c1f44b583238b3133d41f94.jpeg",
                "organization": "Elaf Group",
                "biography": "Majed Saud Kaki is a Saudi professional specializing in the tourism and business management sector, with over 20 years of extensive experience. He holds a bachelor’s degree in hospitality, Restaurant, and Tourism Management from Mount Ida College in Newton, Massachusetts, USA, and a master’s degree in Economic Development and Tourism Management from Boston University, reflecting his strong academic commitment to his field.\n\nMajed has held several prominent leadership positions at Elaf Group, progressing from a Business Development Officer to Assistant Manager, then Manager of Travel and Tourism, and eventually General Manager of Travel and Tourism. He advanced to serve as Vice President of Business Development and Vice President of Travel and Tourism, contributing significantly to the company's growth and service expansion. He also served as General Manager at Advance Food Company. Additionally, Majed was an active member of the National Committee for Hajj and Umrah at the Makkah Chamber of Commerce.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Saurabh",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDk5OTYyLFVzZXJfMTkxODMwMTYp",
                "jobTitle": "Area Director - Operations, Middle East & CIS",
                "lastName": "Tiwari",
                "photoUrl": "https://static.swapcard.com/public/images/8586cf1bbe494758b8b061fb551ae9a3.jpeg",
                "organization": "The Indian Hotels Company Limited (IHCL)",
                "biography": "Saurabh Tiwari was appointed General Manager of Taj Dubai, Business Bay in August 2021, leading a team of over 400 employees, 296 guest rooms and suites and 5 exquisite restaurant and lounges. Started his career in India and then moved to Dubai however he had the ambition to move forward and leave his footprint in different cities around the globe. Working his way up starting from London, Mallorca, Ibiza and then finally the City of Dreams – Dubai.\n\nUsing his extensive experience in the food and beverage industry, luxury hotel management and pre openings from around the world, he has brough new insights to Taj Dubai within 2 years. From the year of appointment in 2021 to 2022, occupancy increased by 23.5%, revenue by 43.5% and ADR by 16.2%. In 2023, Saurabh managed to exceed budgets and almost matched occupancy and revenue of 2022, keeping in mind that the first 3 months of 2022 included EXPO2020.\n\nHaving worked for brands across Middle East, Asia and Europe, Saurabh has a comprehensive mindset and key understanding of consumer behaviours and their developing needs and wants. Saurabh is a strong believer in ‘keeping your employees happy, will lead to happy customers’. This leads him to do constant checks on staff accommodations, to make sure living standards are up to mark, includes healthy meals in the staff canteen for healthy living, train and develop all staff, which include Arabic lessons for employees to cater to the UAE market and empowering all middle managers to help them grow within the industry. He goes into every detail when it comes to employee satisfaction. He is proficient in guiding and motivating the team towards achieving visionary goals by efficiently positioning them with Taj values and brand knowledge. Tiwari religiously believes in an open-door policy, be it the Director or any other staff, his doors are always open to talk to and discuss any issues that may arise. He will never let any guest leave the premises of Taj Dubai without a smile.\n\nBecause of Saurabh’s strong F&B background, he is very involved in upgrading all the outlets. Recently Tree House and Miss Tess have got a brand-new look and menu with an implementation of live music and much more. He works very closely with the Executive Chef in creating memorable experiences for his guest and ensures his guest leaves as positive ambassador of the Taj experience.\n\nTaj Dubai, is the flagship of Taj Hotels in the UAE opened in 2015 and offers a modern and contemporary setting with touches of beautiful artistry and legendary Taj service, known as ‘Tajness’.\n\n‘If we win, we win together, you can’t always cross the road alone’- Saurabh Tiw",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            }
        ],
        "categories": [
            "Branding & Culture",
            "Focus on Saudi Arabia"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjU4NDQ5MA==",
        "titleTranslations": [
            {
                "value": "How to Make a Brand Last?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 12:30:00",
        "endsAt": "2025-05-13 12:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=roUq2Zwh9tY\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Maud",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NTk5NTgyLFVzZXJfNTI4NzE4KQ==",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Bailly",
                "photoUrl": "https://static.swapcard.com/public/images/edfc860d7115437ab95c00263a3833b7.jpeg",
                "organization": "Sofitel Legend, Sofitel, MGallery & Emblems",
                "biography": "Maud Bailly graduated from the École Normale Supérieure, Sciences Po Paris, and ENA before joining the Inspection Générale des Finances. She later became Director of Gare Montparnasse and Head of the Economic & Digital Pole for Prime Minister Manuel Valls. In 2017, she joined Accor as Chief Digital Officer. In 2020, she became CEO of Southern Europe, overseeing nearly 1,900 hotels. Since January 2023, she has been CEO of Sofitel Legend, Sofitel, MGallery & Emblems, leading nearly 250 hotels and serving on Accor’s Luxury & Lifestyle Executive Committee.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Jessy El",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NDk2OTEyLFVzZXJfMjM0MDI0MjQp",
                "jobTitle": "Former Journalist",
                "lastName": "Murr",
                "photoUrl": "https://static.swapcard.com/public/images/04471469685a4bc5bdda3ee7c22b0a33.jpeg",
                "organization": "BBC",
                "biography": "Jessy El Murr is a PWC certified corporate trainer and a former BBC & Forbes Middle East journalist with 18+ years of news writing, editing and presenting. She is the Founder of Motahadith, a MENA based flagship corporate training business. \n\nShe covered exclusive news stories from Washington D.C, Afghanistan, Beirut and Riyadh. She has passion for captivating storytelling, public speaking and a successful track record in digital tools. She founded Motahadith|a in 2022, a unique public speaking and media training business, helping C-level executives to increase their media impact and executive presence. Jessy is am a licensed public speaking coach by (EAHEA) and a senior media trainer working with top international consulting firms including PWC. She continues to deliver trainings to senior government officials and top brand executives in Riyadh, Jeddah, Abu Dhabi, Dubai, and Kuwait.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjY2NTczNw==",
        "titleTranslations": [
            {
                "value": "Curated Connections - Branded Residences",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 12:30:00",
        "endsAt": "2025-05-13 13:00:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4Mzk5OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "branded-residences",
                "translations": [
                    {
                        "value": "Branded Residences"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNzQyNjgyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "networking-lounge",
                "translations": [
                    {
                        "value": "Networking Lounge"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [
            "Branded Residences"
        ],
        "priority": 19
    },
    {
        "id": "UGxhbm5pbmdfMjUzMzkxMA==",
        "titleTranslations": [
            {
                "value": "All-Inclusive Reimagined: How Gen Z and Luxury are Redefining the Upscale Travel Experience",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 12:45:00",
        "endsAt": "2025-05-13 13:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=r63_ohH6HKo\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNzA3NTM4MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "luxury-fandb-and-experiential-hospitality",
                "translations": [
                    {
                        "value": "Luxury, F&B, and Experiential Hospitality"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Gregory",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3MDA1MTM3LFVzZXJfNTk4NjAxMyk=",
                "jobTitle": "Group Deputy CEO",
                "lastName": "Lanter",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/bd21592bd99c45d3afe4fb5b2ccc5f1c.jpeg",
                "organization": "Club Med",
                "biography": "Gregory Lanter graduated from the Paris HEC Business School. He joined Club Med Group and its development teams in 2004, especially in charge of Africa and Middle East. He was appointed Vice President Global Development in 2009, which was later extended to Construction matters. His teams are positioned in Miami, Paris, Singapore and Shanghai. He is a member of the Group Executive Board.\n\nThe Development Construction and Property team is a strong contributor to the success of Club Med’s strategy, aiming at being the most desirable holiday lifestyle brand.\n\nClub Med is settled on almost 70 of the most extra-ordinary sites on Earth, where Club Med was most of the time the first ever international resort operator (Cancun, Punta Cana, Maldives, Mauritius, Bali…). Its development has strongly accelerated, with projects over 4 continents, with a very specific focus on contributing to sustainable tourism, specifically by promoting sustainable certifications in construction.\n\nClub Med offers a unique combination of an expert premium resort manager (over 60 years of experience) and a unique Tour Operating company, recognized and directly physically distributed in 35 different markets in the world.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc5Mjk5MA==",
                                    "title": "Splashes of Success: Saudi Arabia's Thriving Leisure Landscape for the Changing Demographics",
                                    "beginsAt": "2024-04-30 17:10:00",
                                    "endsAt": "2024-04-30 17:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Ben",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5ODQ0LFVzZXJfMTE5MTc1Nik=",
                "jobTitle": "Founder & Managing Partner",
                "lastName": "Baseley-Walker",
                "photoUrl": "https://static.swapcard.com/public/images/d56dd714dff84ff7aaf1c558c1c30e56.jpeg",
                "organization": "Andart Global",
                "biography": "Ben is the Managing Partner of Andart Global, a boutique strategy and advisory firm based in the GCC .He leads Andart’s strategy and reputation management work, delivering flagship projects across the GCC region.\n\nBen has extensive experience working in diplomacy, technology and global affairs for both private and public sector stakeholders including governments, the UN and multinational corporations.\n\nBen and his team excel in helping clients effectively craft a compelling and authentic position while actively safeguarding reputation. Notable GCC projects focused on situation-specific tactical advisory for destination marketing strategy, and increasing awareness of emerging markets and tourist destinations.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTQ0NQ==",
                                    "title": "How the changing City Dynamic influences Hospitality Offerings and the Consumer",
                                    "beginsAt": "2024-05-01 09:35:00",
                                    "endsAt": "2024-05-01 10:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MA==",
                                    "title": "Insights from Asia: What lessons can be learnt from other fast growing markets around the world?",
                                    "beginsAt": "2024-04-30 15:30:00",
                                    "endsAt": "2024-04-30 16:00:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Luxury, F&B, and Experiential Hospitality"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjY0MzM0OA==",
        "titleTranslations": [
            {
                "value": "Pathways to Holistic Wellness: Mapping Saudi Arabia’s Role in Global Wellness Tourism",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 13:00:00",
        "endsAt": "2025-05-13 13:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=IVNzArNQjw0\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU4Nzc2OQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "wellness-and-medical-tourism",
                "translations": [
                    {
                        "value": "Wellness & Medical Tourism"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Tommy",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3Nzk2OTcwLFVzZXJfMjA2NTM4NDUp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Lai",
                "photoUrl": "https://static.swapcard.com/public/images/bc47785a482845cbbbe015c71339eca7.jpeg",
                "organization": "Alyvate Hospitality",
                "biography": "Tommy Lai is the Co-Founder and Chief Executive Officer of Alyvate Hospitality, a strategic joint venture with Dossen Hotel Management Group, the 5th largest hotel management company in China. Alyvate Hospitality is dedicated to redefining excellence in the hospitality industry and elevating its brands to a global platform.\n\nPrior, Tommy was Chief Executive Officer at General Hotel Management Pte Ltd (GHM) where he played a pivotal role in driving their growth and global presence in the luxury hospitality sector, particularly with the success of The Chedi properties across various international destinations. Some key highlights of his impactful tenure include establishing an exclusive ultra-luxury hotel brand for the Kingdom of Saudi Arabia as well as rejuvenating and transforming historic landmarks into stunning hotels.\n\nTommy’s significant contributions have been recognized with a coveted spot on Hotelier Middle East’s esteemed Executive Power List for 2021 and 2022, solidifying his influence in the GCC region’s hotel industry. He also secured a position in the top 30 Saudi Arabia Vision 2030 Power List, attesting to his profound impact on the Kingdom’s flourishing hospitality sector.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Lindsay",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MzM0ODUyLFVzZXJfMjM4NjQ5Njcp",
                "jobTitle": "Sr. Director Wellness Strategy",
                "lastName": "Madden-Nadeu",
                "photoUrl": "https://static.swapcard.com/public/images/87e1ecef3d3c4645add000e7ba2a1f90.jpeg",
                "organization": "Red Sea Global",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Nicolas",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDE4ODMzLFVzZXJfMTYyMTUyMTkp",
                "jobTitle": "Head of Hotel Advisory",
                "lastName": "Nasra",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/2107edc501364b20835b2031eb656fc5.jpeg",
                "organization": "Colliers MENA",
                "biography": "Nicolas Nasra is the Head of Hotel Advisory for the MENA region at Colliers, based in Dubai. With extensive expertise in hospitality strategy, development consultancy, and financial feasibility across the UAE, Saudi Arabia, and Oman, he advises top-tier developers, sovereign entities, banks, and private offices. Nicolas is known for challenging the status quo, bringing a data-driven yet human-centric approach to tourism and real estate advisory. A Canadian professional with a passion for technology, philosophy, and high-end gastronomy, he combines analytical precision with creative insight to help shape the region’s most ambitious hospitality and destination projects.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Nw==",
                                    "title": "Navigating Tomorrow's Hospitality: The Evolutionary Intersection of AI, IT, and Human Touch for Unparalleled Guest Experiences",
                                    "beginsAt": "2024-04-30 14:30:00",
                                    "endsAt": "2024-04-30 15:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc5Mjk1Nw==",
                                    "title": "The Power of AI in Hospitality: Practical Solutions for Investors",
                                    "beginsAt": "2024-04-30 15:00:00",
                                    "endsAt": "2024-04-30 15:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Heidi",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5NDA3LFVzZXJfMjA3ODcyNzMp",
                "jobTitle": "Vice President",
                "lastName": "Grimwood",
                "photoUrl": "https://static.swapcard.com/public/images/eb20c4adab4d4074a0ae22542e4a75e6.jpeg",
                "organization": "ELE | NA Elements of Nature",
                "biography": "Heidi Grimwood’s journey in the wellness industry began at just 19 and has evolved into a remarkable career spanning over 25 years in spa and wellness operations and development. Celebrated as a forward-thinking luminary, Heidi is renowned for her innovative approach to conceptualizing and executing exceptional wellness programs.\n\nHer diverse experience includes pivotal roles such as Co-Director at FG Innovation Management Ltd, where she pioneered spa management in Ireland, and founding the inaugural corporate gym at Virgin Atlantic Airways HQ. Heidi’s expertise has been sought after at prestigious destinations including Inchydoney Lodge & Spa, Aghadoe Heights Hotel & Spa, aboard the QE2 Oceanliner during its world cruise, and at One and Only Reethi Rah in the Maldives, along with her contributions to Steiner Transocean – Worldwide’s global reach.\n\nAs a sought-after speaker, Heidi has shared her insights at international business and wellness summits, including key industry events focused on leadership, innovation, and sustainability. Her thought leadership continues to inspire professionals and shape the direction of global wellness trends.\n\nIn recognition of her dedication and pioneering contributions to the wellness field, Heidi was honored as Global Spa Leader of the Year at the World Spa and Wellness Awards 2022. Now, as Wellness Personality of the Year at the Hotelier Maldives Awards 2024, Heidi’s remarkable achievements and forward-thinking leadership continue to shape the future of wellness on a global scale.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Guest",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Wellness & Medical Tourism"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQyMw==",
        "titleTranslations": [
            {
                "value": "FHS Awards",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 13:20:00",
        "endsAt": "2025-05-13 13:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><strong>Future Leader Award (in partnership with Sommet Education) Winner: </strong>Lama AlQawasmi, Co-Founder and COO, Hospitality Talents</p><p><strong>Jury Members for the Future Leader Award:</strong></p><ul><li><strong>Louis Nicolas Barrios, </strong>Regional Manager Innovation Education and Investment, UN Tourism</li><li><strong>Carlos Díez de la Lastra</strong>, Chief Executive Officer, Les Roches</li><li><strong>Anouck Weiss, </strong>Chief Communication Officer, Sommet Education & Co-founder and Executive Vice President, Sommet Education Foundation</li><li><strong>Jonathan Worsley,</strong> Chairman & CEO, The Bench</li></ul><p><strong>Impact Leader Award Winner: </strong>Narjes Fallatah, Revenue Manager, Makkah Clock Royal Tower, A Fairmont Hotel</p><p><strong>Jury Members for the Impact Leader Award:</strong></p><ul><li><strong>Dr. Abeer A. Alamri,</strong> Skills Development and Talent Optimization Expert</li><li><strong>Nikolina Angelkova, </strong>Former Minister Tourism, Bulgaria</li><li><strong>Sarah Gasim, </strong>Senior Vice President, Head of Hotels KSA, JLL</li></ul>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzMxNDMyMjY0LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman & CEO",
                "lastName": "Worsley",
                "photoUrl": "https://static.swapcard.com/public/images/65ef700e7da4493ea8d79d2e53ba7532.jpeg",
                "organization": "The Bench",
                "biography": "Jonathan Worsley began his career at Forte and Holiday Inns before moving into hotel advisory roles at PKF and CBRE. In 1997, he co-founded IHIF Berlin, followed by The Bench, which started as a daily benchmarking company for the hotel industry and in 2008 merging with STR to create STR Global.  \n\nThe Bench evolved into a leading organiser of premier hospitality investment conferences and Jonathan continued bringing the hospitality investment community together in various parts of the world through AHIC - now Future Hospitality Summit (FHS), FHS Saudi, FHS Africa and SAHIC in Latin America. Later, he expanded into aviation and F&B with AviaDev and GRIF. \n\nIn 2020, Jonathan led The Bench’s pivot to virtual events, launching Hospitality Tomorrow and FHS for the G20 Saudi Secretariat. He continues to drive industry innovation through initiatives like the Startup Den and Lead the Change while serving on the boards of Fresh on Table, Envi Lodges, and other startups shaping the future of hospitality. \n\nHe is also a trustee of the World Sustainable Hospitality Alliance, Future Talent – a musical charity, a member of Women in Hospitality (WiH) and recently completed a board term with the Ras Al Khaimah Tourism Development Authority.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Luis Nicolas",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5OTgwLFVzZXJfMTE4OTk5NTQp",
                "jobTitle": "Regional Manager Innovation Education and Investment",
                "lastName": "Barrios",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/3e48bf508a3f4f5a855d9b179a19b4ec.jpeg",
                "organization": "UN Tourism",
                "biography": "Luis Nicolás Barrios Medina-Montoya, Innovation Education and Investments Regional Manager for the UNWTO Regional Office in Riyadh. \n\nMaster in Project Management from Esden Business School. PMI-certified PMP. Master in Marketing and Commercial Management from IE Business School. Master in Audio-visual Production from IEEA. Degree in Audio-visual Communication from the University of Malaga. \n\nExpert in technology and innovation applied to the tourism sector. From February 2003 until June 2020, he developed his professional career in Tourism in SEGITTUR, a state-owned company integrated into the Spanish Ministry of Industry Trade and Tourism and attached to the State Secretariat for Tourism, responsible for promoting innovation (R&D) in the Spanish tourism sector, both in the public sector.      \n\nSince 2012 he was involved, in different capacities, in the development and management of the Smart Tourist Destinations program. From 2019 to 2022 he was responsible for the direction and coordination of all the Smart Tourism Destination Projects in Latin America, coordinating projects in Tequila, Medellín and Bogotá.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5MA==",
                                    "title": "Shaping the Kingdom's Destiny: Cultivating Excellence in Hospitality to Shaping Policies and Initiatives that Contribute to Making Hospitality a Great Industry to Work in",
                                    "beginsAt": "2024-04-30 17:50:00",
                                    "endsAt": "2024-04-30 18:30:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Nikolina",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3MDQ1NzQwLFVzZXJfMTkxNjg5NjAp",
                "jobTitle": "Former Minister Tourism",
                "lastName": "Angelkova",
                "photoUrl": "https://static.swapcard.com/public/images/be577fb8e2b044c98cc51dc0dc10fb55.jpeg",
                "organization": "Bulgaria",
                "biography": "Nikolina Angelkova is a Harvard business school alumni 2010, graduated from the Leadership development program. In April 2023 she completed Harvard Kennedy School of Government Executive Program for “Global Leadership and Public Policy in the 21st century.” She is Master in Law from UNWE, Sofia and she has specialized financial management of the EU structural funds, regional policy and government to the Institute of Public Administration in Maastricht and the Regional Institute for Public Administration in Nantes, France. She has done a number of executive education programs in Harvard business school for real estate development, negotiations and mergers and acquisitions.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Dr. Sarah",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3MzcxNTM2LFVzZXJfMTU5MjYzMTgp",
                "jobTitle": "Senior Vice President, Head of Hotels KSA",
                "lastName": "Gasim",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/295c94c5f792461ea1fb5840b840ad14.jpeg",
                "organization": "JLL",
                "biography": "Sarah leads JLL’s Hotels & Hospitality business in KSA. She has led several hospitality megaprojects within KSA such as NEOM, PIF Tourism Destination in Taif and Jabal Omar Development Company (JODC).\nPrior to joining JLL, Sarah led the hospitality sector at one of the upcoming tourism destinations in the western region of KSA owned by the Public Investment Fund (PIF). Sarah also obtained a wide range of professional experience from local and international hospitality operators and organisations including IHG, Elaf Group and Booking.com.\nShe was awarded the ‘Best Tourism Trainer in Saudi’ in 2017 by HRH Prince Sultan Bin Salman. In addition, Sarah is a former active member of the United Nations World Tourism Organisation (UNWTO) and the World Travel & Tourism Committee (WTTC).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg4MTEwOQ==",
                                    "title": "Digital Talks: Leveraging Digital Trends to Enhance Hospitality Investment and Operations",
                                    "beginsAt": "2024-04-30 09:05:00",
                                    "endsAt": "2024-04-30 09:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Dr. Abeer",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NTg1MDM1LFVzZXJfMjM0NTI1MzYp",
                "jobTitle": "Skills Development and Talent Optimization Expert",
                "lastName": "Alamri",
                "photoUrl": "https://static.swapcard.com/public/images/a96df3d5f0c84807a351df07dfc4e15c.jpeg",
                "organization": "",
                "biography": "Dr. Alamri is an expert psychometrician and certified evaluator with extensive experience in building capabilities and enhancing human capital quality across both government and private sectors. She has achieved impactful outcomes through her professional expertise in constructing scales and measuring knowledge, attitudes, and public opinion. Dr. Alamri has significant experience in developing indicators, as well as quality and performance standards. She has also contributed to the establishment of evidence-based decision support systems. Driven by a passion for understanding human behavior through data analytics, Dr. Alamri aims to improve the quality of education, work, and life for individuals.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Anouck",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MjEzMTM4LFVzZXJfMjM3OTcxMjMp",
                "jobTitle": "Chief Communication Officer, Sommet Education",
                "lastName": "Weiss",
                "photoUrl": "https://static.swapcard.com/public/images/4aa512d63690417fb592e5e14fa6118a.jpeg",
                "organization": "Co-founder and Executive Vice President, Sommet Education Foundation",
                "biography": "Anouck Weiss is a seasoned Communication Executive with a strong track-record and expertise in tourism, hospitality, and education. She began her career at the French Embassy to the UN, then led corporate advertising at Accor hotel group before heading communication of Sofitel luxury properties globally. Before joining Sommet Education in 2019, she was Head of Communication at Ecole Hôtelière de Lausanne. Chief Communication Officer and Co-founder of the Sommet Education Foundation, she champions access to education, scholarships, and sustainable practices in hospitality.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Carlos",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MjMyNDgwLFVzZXJfMjM4MDYwNTAp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Díez de la Lastra",
                "photoUrl": "https://static.swapcard.com/public/images/518a18db85dd40628e26d9847a175eb3.jpeg",
                "organization": "Les Roches",
                "biography": "Recognized by Forbes Travel as one of the 50 most influential figures in tourism and among the top 150 tourism professionals in Spain, he brings nearly three decades of experience in higher education and international expansion. \nAs CEO of Les Roches since March 2022, Carlos oversees the institution’s international campuses in Switzerland, Spain, the UAE, and China, along with an affiliated campus near New Delhi. Les Roches, founded in Switzerland in 1954, is ranked among the world’s top five institutions in hospitality and leisure management. His leadership focuses on driving the school's global expansion and strengthening its reputation as a worldwide leading institution in hospitality management education.  \nUnder his leadership, Les Roches has embarked on an ambitious plan of international expansion and has positioned itself at the forefront of innovation in the Hospitality sector. \nPrior to his current role, Carlos served as Managing Director of Les Roches Marbella (2014–2022), where he played a pivotal role in the institution’s expansion and global recognition. His career also includes executive positions at Universidad Europea de Madrid and Universidad Europea de Canarias within the Laureate International Universities network. \nBeyond his work at Les Roches, Carlos actively contributes to the industry through various executive boards, foundations, and expert groups. He is a member of the UN Tourism Online Education Committee and has advised key industry initiatives, including Costa del Sol Tourism’s crisis response strategy during the COVID-19 pandemic. \nA sought-after speaker at international conferences, Carlos is known for his deep understanding of market trends and strong connections with industry leaders. He holds a degree in Economics and Business Administration from the Complutense University of Madrid and an MBA from IEDE Business School.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Lama",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NDE4Mzg3LFVzZXJfMjQ0OTI3MDIp",
                "jobTitle": "Co-Founder & COO",
                "lastName": "AlQawasmi",
                "photoUrl": "https://static.swapcard.com/public/images/5d27d4543c2a4075b57e2c418d0fbda4.jpeg",
                "organization": "Hospitality Talents",
                "biography": "Lama AlQawasmi is a Co-Founder and COO of Hospitality Talents, a company focused on improving hospitality recruitment and training across the region. She holds a bachelor’s degree in International Hospitality Business from Glion Institute of Higher Education and is currently pursuing her master’s degree in Entrepreneurship and Innovation in the Hospitality Industry at Glion. Lama has experience developing hospitality concepts, training programs, and consultancy solutions tailored to the needs of businesses in Saudi Arabia and beyond. Her work focuses on practical improvements that raise operational standards and support industry development.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Narjes",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NDk2OTMxLFVzZXJfMjQ1MzkzMDUp",
                "jobTitle": "Revenue Manager",
                "lastName": "Mohammed",
                "photoUrl": "https://static.swapcard.com/public/images/a8bd1871a3d04d8db3cd7156a77b5bee.jpeg",
                "organization": "Makkah clock Royal Tower. A Fairmont Hotel",
                "biography": "Narjes Fallatah is the Revenue Manager at Makkah Clock Royal Tower, A Fairmont Hotel — one of the region’s largest and most iconic properties. She holds an Executive Master’s in International Hotel Management from Les Roches and has a strong background in pricing strategy, market analysis, and commercial performance. As one of the very few Saudi females in Revenue Management, Narjes is passionate about empowering local talent and driving innovation in the hospitality industry. Her leadership is focused on data-driven decisions, strategic growth, and fostering a more inclusive future for the next generation of hospitality professionals in Saudi Arabia.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQyNA==",
        "titleTranslations": [
            {
                "value": "Lunch",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 13:30:00",
        "endsAt": "2025-05-13 14:15:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [],
        "speakers": [],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjU2MDUxOQ==",
        "titleTranslations": [
            {
                "value": "Welcome Remarks - Net Positive Solution Labs powered by World Sustainable Hospitality Alliance (On Invitation Only)",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 14:00:00",
        "endsAt": "2025-05-13 14:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=QjnlB2nTeKs\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzY0NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-esg",
                "translations": [
                    {
                        "value": "Sustainability & ESG"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Glenn",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5NDk3LFVzZXJfMTU3NTczMjQp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Mandziuk",
                "photoUrl": "https://static.swapcard.com/public/images/b19e8296c97244568fcf237831af441c.jpeg",
                "organization": "World Sustainable Hospitality Alliance",
                "biography": "Glenn Mandziuk is the Chief Executive Officer of the World Sustainable Hospitality Alliance – the leading global network in responsible hospitality. He is an internationally recognised CEO with over 25 years of leadership experience in advancing sustainable practices in tourism, hospitality and economic development, and establishing strategies and programmes that inspire responsible growth. \nWithin his role as CEO of the Alliance, Glenn has led the development of the organisation’s updated Pathway to Net Positive Hospitality, which enables all hotels to work towards having a net positive impact, no matter their starting point. Together with the Alliance’s Head of Business Development, Glenn has substantially expanded the organisation’s network for responsible hospitality, which now represents over 50,000 hotels, equating to 7 million rooms, along with a wide network of over 30 expert partners. What’s more, Glenn has been the pioneer behind multiple high-level Sustainable Hospitality Alliance Summits, which bring together CEO and C-suite leaders from across the Alliance’s membership. Alongside his leadership of the Alliance, Glenn has been chosen to be Co-chair of the Sustainable Markets Initiative Hospitality and Tourism Task Force, alongside Considerate Group Co-founding Partner, Xenia zu Hohenlohe. The Task Force focuses on creating new business models, reducing emissions, and investing in people to support a sustainable hospitality and tourism sector and communities. He has also been appointed as member of the Institute of Tourism and Hospitality Professional (ITHP) Advisory Council, and the International CHRIE Industry Advisory Council (IAC), the first of its kind in the organisation’s 75-year history.\nPrior to becoming CEO of the Sustainable Hospitality Alliance, Glenn was President and Chief Executive Officer of Canada’s Thompson Okanagan Tourism Region (TOTA) with its 4,000 industry stakeholders. Glenn’s leadership resulted in the organisation being recognised as a global champion of excellence and innovation in sustainable destination management and responsible industry development practices. The team received recognition from the United Nations World Tourism Organisation (UNWTO), World Travel and Tourism Council (WTTC), World Travel Awards, and Responsible Tourism Institute’s Biosphere Gold Certification – a first in the Americas. In addition, the UNWTO awarded TOTA Quest Certification for excellence in leadership, execution and governance capacities – only the third such recognition for a destination management organisation bestowed in the world.\nGlenn has 10 years’ experience in the hospitality industry in family-owned and operated hotels and resorts and holds a Master of Environmental Design degree majoring in sustainable tourism planning. He is also a director on the Board of the Global Sustainable Tourism Council and the Responsible Tourism Institute.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2MA==",
                                    "title": "Sustainable Horizons: Catalyzing Change Through Green Investments",
                                    "beginsAt": "2024-04-30 12:25:00",
                                    "endsAt": "2024-04-30 12:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg4MjUwMg==",
                                    "title": "Data Talks: Why ESG data and benchmarking is key to continuing the Hospitality sector's global growth.",
                                    "beginsAt": "2024-04-29 14:35:00",
                                    "endsAt": "2024-04-29 14:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Jonathan",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzMxNDMyMjY0LFVzZXJfMTU3NTczMzYp",
                "jobTitle": "Chairman & CEO",
                "lastName": "Worsley",
                "photoUrl": "https://static.swapcard.com/public/images/65ef700e7da4493ea8d79d2e53ba7532.jpeg",
                "organization": "The Bench",
                "biography": "Jonathan Worsley began his career at Forte and Holiday Inns before moving into hotel advisory roles at PKF and CBRE. In 1997, he co-founded IHIF Berlin, followed by The Bench, which started as a daily benchmarking company for the hotel industry and in 2008 merging with STR to create STR Global.  \n\nThe Bench evolved into a leading organiser of premier hospitality investment conferences and Jonathan continued bringing the hospitality investment community together in various parts of the world through AHIC - now Future Hospitality Summit (FHS), FHS Saudi, FHS Africa and SAHIC in Latin America. Later, he expanded into aviation and F&B with AviaDev and GRIF. \n\nIn 2020, Jonathan led The Bench’s pivot to virtual events, launching Hospitality Tomorrow and FHS for the G20 Saudi Secretariat. He continues to drive industry innovation through initiatives like the Startup Den and Lead the Change while serving on the boards of Fresh on Table, Envi Lodges, and other startups shaping the future of hospitality. \n\nHe is also a trustee of the World Sustainable Hospitality Alliance, Future Talent – a musical charity, a member of Women in Hospitality (WiH) and recently completed a board term with the Ras Al Khaimah Tourism Development Authority.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                                    "title": "Closing Remarks",
                                    "beginsAt": "2024-05-01 13:15:00",
                                    "endsAt": "2024-05-01 13:20:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                                    "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 15:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                                    "title": "Welcome Remarks",
                                    "beginsAt": "2024-04-29 15:00:00",
                                    "endsAt": "2024-04-29 15:15:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                                    "title": "Let's meet the Future with Desi",
                                    "beginsAt": "2024-04-30 10:30:00",
                                    "endsAt": "2024-04-30 10:40:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                                    "title": "Start-Up Den",
                                    "beginsAt": "2024-04-30 14:15:00",
                                    "endsAt": "2024-04-30 15:45:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Sustainability & ESG"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjY1NDE0OA==",
        "titleTranslations": [
            {
                "value": "Enhancing Lives Through Innovation: Crafting Visitors' Experiences for Building Resilient, Sustainable Cities",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 14:25:00",
        "endsAt": "2025-05-13 14:40:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=yq7RPbQXUkU\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Ben",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5ODQ0LFVzZXJfMTE5MTc1Nik=",
                "jobTitle": "Founder & Managing Partner",
                "lastName": "Baseley-Walker",
                "photoUrl": "https://static.swapcard.com/public/images/d56dd714dff84ff7aaf1c558c1c30e56.jpeg",
                "organization": "Andart Global",
                "biography": "Ben is the Managing Partner of Andart Global, a boutique strategy and advisory firm based in the GCC .He leads Andart’s strategy and reputation management work, delivering flagship projects across the GCC region.\n\nBen has extensive experience working in diplomacy, technology and global affairs for both private and public sector stakeholders including governments, the UN and multinational corporations.\n\nBen and his team excel in helping clients effectively craft a compelling and authentic position while actively safeguarding reputation. Notable GCC projects focused on situation-specific tactical advisory for destination marketing strategy, and increasing awareness of emerging markets and tourist destinations.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTQ0NQ==",
                                    "title": "How the changing City Dynamic influences Hospitality Offerings and the Consumer",
                                    "beginsAt": "2024-05-01 09:35:00",
                                    "endsAt": "2024-05-01 10:05:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg5NDI0MA==",
                                    "title": "Insights from Asia: What lessons can be learnt from other fast growing markets around the world?",
                                    "beginsAt": "2024-04-30 15:30:00",
                                    "endsAt": "2024-04-30 16:00:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Abdulrahman",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MjY2NTgwLFVzZXJfMTI0MTg2Nzkp",
                "jobTitle": "Chief Data and Innovation Officer",
                "lastName": "Ibrahim",
                "photoUrl": "https://static.swapcard.com/public/images/bd2ff042a6b6469a85f66c52328c07bc.jpeg",
                "organization": "Madinah Development Authority",
                "biography": "Abdulrahman Ibrahim leads innovative, human-centric smart city initiatives. With 27 years of private- and public-sector experience, he enhances urban development through technology and open data to improve quality of life and drive socio-economic growth. He's the winner of the World Innovation Award 2023 by the World Organization for Development.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjY0NjA0Ng==",
        "titleTranslations": [
            {
                "value": "The Existential Business Case for Net Positive Hospitality",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 14:30:00",
        "endsAt": "2025-05-13 14:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=-A1qYqvX0yM\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Caty",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDYyMjY2LFVzZXJfMjQyNzMyNTYp",
                "jobTitle": "Net Positive Innovation Lead",
                "lastName": "Batten",
                "photoUrl": "https://static.swapcard.com/public/images/9319aed7c71b4babb23f9b95cad8c84c.jpeg",
                "organization": "World Sustainable Hospitality Alliance",
                "biography": "Co creating and implementing business strategies to accelerate our collective transition to Net Positive impact, for climate, Nature and people. Equipping leaders with the mindset and tools required to navigate the complexity of our rapidly changing world, helping them transition away from risk toward resilience. ",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjY1ODUzMQ==",
        "titleTranslations": [
            {
                "value": "Setting the Scene for Hospitality Asset Stability: Balancing Financial Strength for Owners & Brands",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 14:40:00",
        "endsAt": "2025-05-13 14:55:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=Hq0j9bTHIPg\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzY3Mw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment-finance-and-real-estate",
                "translations": [
                    {
                        "value": "Investment, Finance & Real Estate "
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Nicolas",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDE4ODMzLFVzZXJfMTYyMTUyMTkp",
                "jobTitle": "Head of Hotel Advisory",
                "lastName": "Nasra",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/2107edc501364b20835b2031eb656fc5.jpeg",
                "organization": "Colliers MENA",
                "biography": "Nicolas Nasra is the Head of Hotel Advisory for the MENA region at Colliers, based in Dubai. With extensive expertise in hospitality strategy, development consultancy, and financial feasibility across the UAE, Saudi Arabia, and Oman, he advises top-tier developers, sovereign entities, banks, and private offices. Nicolas is known for challenging the status quo, bringing a data-driven yet human-centric approach to tourism and real estate advisory. A Canadian professional with a passion for technology, philosophy, and high-end gastronomy, he combines analytical precision with creative insight to help shape the region’s most ambitious hospitality and destination projects.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Nw==",
                                    "title": "Navigating Tomorrow's Hospitality: The Evolutionary Intersection of AI, IT, and Human Touch for Unparalleled Guest Experiences",
                                    "beginsAt": "2024-04-30 14:30:00",
                                    "endsAt": "2024-04-30 15:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc5Mjk1Nw==",
                                    "title": "The Power of AI in Hospitality: Practical Solutions for Investors",
                                    "beginsAt": "2024-04-30 15:00:00",
                                    "endsAt": "2024-04-30 15:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Serena",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3ODI0MTIwLFVzZXJfMTQxNjU3Njgp",
                "jobTitle": "Chief Growth Officer",
                "lastName": "Lim",
                "photoUrl": "https://static.swapcard.com/public/images/cca0cb3e45514a56a843e289363626ad.jpeg",
                "organization": "The Ascott Limited",
                "biography": "Serena is Chief Growth Officer at The Ascott Limited (Ascott), leading its global business development team to steer and manage the company’s growth in management and franchise contracts globally . Supporting the group’s development ambitions through an asset light strategy to deliver strong recurring fee income, Serena and her team drives continued opportunities to extend Ascott’s geographic reach across key growth markets.\n\nShe joined Ascott in January 2023 and brings over two decades of experience in hotel development, strategic planning and feasibility.\n\nMost recently in the role of Vice President, Development, Southeast Asia and Korea at the InterContinental Hotels Group (IHG), Serena was responsible for leading IHG’s development strategy and extended growth teams in the region. Serena played an integral role in implementing initiatives to align culture with strategy and processes as a key member of the leadership team. \n\nPrior to joining IHG, Serena was responsible for development efforts in Southeast Asia at Marriott International, where she held the role of Regional Vice President. She spent early parts of her career with Starwood Hotels and Resorts, where she led the company’s expansion across Southeast Asia, while overseeing feasibility and strategic planning efforts in Asia Pacific. \n\nSerena graduated on the Dean’s List with a Bachelor of Science (Distinction) in Hotel Administration and Major in Finance at Cornell University, School of Hotel Administration.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                                    "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 16:15:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Investment, Finance & Real Estate"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjY0NjA0OA==",
        "titleTranslations": [
            {
                "value": "Strategic foresight and horizon scanning: What lies ahead for Hospitality and Tourism in this rapidly changing world",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 14:45:00",
        "endsAt": "2025-05-13 15:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=8HGNkRn9L_U\" target=\"_blank\">Click here  to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Pascal",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NDkyNTQ2LFVzZXJfMjAwNDMyNzQp",
                "jobTitle": "Partner",
                "lastName": "Armoudom",
                "photoUrl": "https://static.swapcard.com/public/images/7be19e1298dd4c7ca64f06f4cec210a6.jpeg",
                "organization": "Kearney",
                "biography": "During his first 18 years with Kearney, Pascal worked with clients in the tourism, luxury, and consumer industries across Europe and Asia, helping them to grow and improve their businesses, before being recruited to lead the strategy for Amaala, a luxury tourism destination on the Red Sea coast. “I was in charge of developing the experiential strategies for everything from mobility to arts and culture, as well as overseeing all of the strategic partnerships for the resort,” Pascal adds.\n\nAfter moving on to become strategy advisor to a Middle East investment fund dedicated to developing the cultural, entertainment, tourism, and sports sectors, Pascal returned to Kearney in 2023 and is now a partner in the firm’s transportation and travel practice, with a focus on tourism, leisure, and hospitality, based in Riyadh.\n\nHaving grown up on Reunion Island in the Indian Ocean, and spent time living and working in mainland France, London, and Shanghai, Pascal has a knack for bringing a global perspective to his work. As he puts it, “When you have been in consulting for a while, you start to spot familiar patterns. Every place and every firm has its own character and challenges, but I would hope that what I bring to my clients is an ability to put things in perspective, and shortcut some of the problems they face.”\nPascal graduated from Essec Business school MBA.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Charlotte",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NDk2NzA1LFVzZXJfMjQ1MzkxOTAp",
                "jobTitle": "Lead Urban Transformation & Tourism",
                "lastName": "Boutboul",
                "photoUrl": "https://static.swapcard.com/public/images/0436bba0b0a94716a482baec4f3be6ff.jpeg",
                "organization": "World Economic Forum",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": null,
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjU2MzY1OA==",
        "titleTranslations": [
            {
                "value": "Hospitality Asset Stability: Balancing Financial Strength for Owners & Brands",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 14:55:00",
        "endsAt": "2025-05-13 15:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=qvdeYBtPSlQ\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "hotelisation-of-traditional-assets",
                "translations": [
                    {
                        "value": "Hotelisation of Traditional Assets"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Hassan",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3MDA1MjY5LFVzZXJfMjMxMjMwMDQp",
                "jobTitle": "Chief Hospitality Operations Officer",
                "lastName": "Ahdab",
                "photoUrl": "https://static.swapcard.com/public/images/9cf68577bdff4a38be44c9fbf2850f25.jpeg",
                "organization": "Taiba Investments",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Siegfried",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MTcyMDE3LFVzZXJfMTkwOTUxNzQp",
                "jobTitle": "Vice President & Head of Development Middle East, India and Africa",
                "lastName": "Nierhaus",
                "photoUrl": "https://static.swapcard.com/public/images/1520d185856a42d8883a3dcb4b287cd1.jpeg",
                "organization": "H World International",
                "biography": "Siegfried Nierhaus is a highly respected name in the Middle Eastern hospitality industry, widely recognized for his passion, dedication, and commitment to excellence in both his work and his team. Born and raised in a family of restaurateurs and hoteliers in Germany and Austria, Siegfried inherited a deep love for hospitality from an early age, welcoming guests at his family’s business from the age of four.\nWith a career spanning over 30 years, Siegfried has spent 15 years in France and the past 20 years based in Dubai, with responsibilities across the Middle East, India, Asia, and Africa.\n\nThroughout his career in the Middle East, Siegfried has held senior leadership and board-level positions with international hotel operators, hotel owners, and hospitality consulting firms. He is notably the only German hospitality professional consistently recognized among the Top 50 Hoteliers in the Middle East since 2011.\nSiegfried’s core expertise lies in opening new hotels and enhancing existing properties. He has successfully led the opening of more than 20 hotels across the Middle East and Africa. As Head of Future Hotel Openings, his strategic planning, innovative thinking, effective coordination and communication, meticulous attention to detail, and talent for selecting the right pre-opening team members have all played a pivotal role in the successful launch of each project.\n\nHis exceptional leadership, unwavering dedication, and passion for the industry have made him an icon in the hospitality world. Siegfried’s extensive knowledge and experience have made him a highly sought-after consultant worldwide by hotel owners and operators. He is especially known for his ability to understand clients' unique needs and deliver tailored solutions that exceed expectations.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Delegate",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Samer",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MjY2NzkxLFVzZXJfMTgzNzkwODQp",
                "jobTitle": "Chief Asset Management Officer",
                "lastName": "Sabra",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/d70a454a25eb49d39b9086c7bb899092.jpeg",
                "organization": "Jabal Omar Development Co.",
                "biography": "Experienced investment and real estate professional with over 20 years in GCC countries, including KSA, UAE, and Kuwait. Known for leading company transformations through diversification, investment in new ventures, and strengthening real estate portfolios. Currently, Chief of Assets at Jabal Omar Development Co., tasked with optimizing assets valued over SAR 20 billion. Previously established and managed Bakheet Holding, overseeing diverse business lines such as heavy machinery trading, real estate development, F&B, and general investment. Specialties include general management, mergers & and acquisitions, investment analysis, real estate development, and project management.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTg3MTQ0NQ==",
                                    "title": "How the changing City Dynamic influences Hospitality Offerings and the Consumer",
                                    "beginsAt": "2024-05-01 09:35:00",
                                    "endsAt": "2024-05-01 10:05:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Nicolas",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDE4ODMzLFVzZXJfMTYyMTUyMTkp",
                "jobTitle": "Head of Hotel Advisory",
                "lastName": "Nasra",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/2107edc501364b20835b2031eb656fc5.jpeg",
                "organization": "Colliers MENA",
                "biography": "Nicolas Nasra is the Head of Hotel Advisory for the MENA region at Colliers, based in Dubai. With extensive expertise in hospitality strategy, development consultancy, and financial feasibility across the UAE, Saudi Arabia, and Oman, he advises top-tier developers, sovereign entities, banks, and private offices. Nicolas is known for challenging the status quo, bringing a data-driven yet human-centric approach to tourism and real estate advisory. A Canadian professional with a passion for technology, philosophy, and high-end gastronomy, he combines analytical precision with creative insight to help shape the region’s most ambitious hospitality and destination projects.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDU5Nw==",
                                    "title": "Navigating Tomorrow's Hospitality: The Evolutionary Intersection of AI, IT, and Human Touch for Unparalleled Guest Experiences",
                                    "beginsAt": "2024-04-30 14:30:00",
                                    "endsAt": "2024-04-30 15:00:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTc5Mjk1Nw==",
                                    "title": "The Power of AI in Hospitality: Practical Solutions for Investors",
                                    "beginsAt": "2024-04-30 15:00:00",
                                    "endsAt": "2024-04-30 15:20:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Joao",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5Mzk0NDY3LFVzZXJfMTU3NzY1Nzcp",
                "jobTitle": "Vice President for Asset Management",
                "lastName": "Cravo",
                "photoUrl": "https://static.swapcard.com/public/images/47e5e9bd8e7945f0a673016cfabaf97d.jpeg",
                "organization": "United Hospitality Management",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Hotelisation of Traditional Assets"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjU2MDUxMg==",
        "titleTranslations": [
            {
                "value": "Empowering Local Talent for a New Era of Hospitality: Driving Cultural Change in KSA",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 15:30:00",
        "endsAt": "2025-05-13 15:45:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=7d4efZAObPk\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "technology-and-innovation",
                "translations": [
                    {
                        "value": "Technology & Innovation"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Linh K.",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4NzQ3NzA2LFVzZXJfMTc4NjQwMyk=",
                "jobTitle": "Owner & Managing Director",
                "lastName": "Vu",
                "photoUrl": "https://static.swapcard.com/public/images/2e26cd668f984527a1694e1fa6459c8d.jpeg",
                "organization": "Key Hospitality Consulting",
                "biography": "Linh Vu is an international hotel strategist and founder of Key Hospitality Consulting, advising investors and developers on hotel concept development, operator selection, and complex cross-border transactions across Southeast Asia, Europe, and Saudi Arabia. With over 15 years of experience, she has successfully negotiated agreements with leading global operators for a wide range of hospitality assets, from beach resorts to vibrant urban destinations. \n\nA member of the International Society of Hospitality Consultants (ISHC), Linh is also a passionate advocate for talent development. She led a national partnership with Ecole Hôtelière de Lausanne (EHL) to launch vocational training centers that are redefining hospitality education in Vietnam.\n\nShe holds an Executive MBA from Columbia Business School, London Business School, and the University of Hong Kong, and is widely recognized for her negotiation acumen, cross-cultural fluency, and strategic leadership in emerging markets.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Aseel",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5NTQzMzIwLFVzZXJfMTU5MjQ5MjMp",
                "jobTitle": "Hotel Talent Development Manager",
                "lastName": "Hussain Bondagjy",
                "photoUrl": "https://static.swapcard.com/public/images/7186201b027e4b559da332e0aae95aa3.jpeg",
                "organization": "NEOM",
                "biography": "Aseel’s passion is to inspire young Saudis; to encourage, and motivate them to embrace a career in hospitality, her role at NEOM (Saudi Arabia’s visionary Giga project on the Red Sea coast) aligns perfectly with this. As part of the Hotel Development team, Aseel is responsible for driving the development and implementation of its workforce development strategy, which is aimed at creating an empowered and competent pipeline of future leaders in hospitality. \nA fluent English speaker with Arabic as her mother tongue, Aseel holds a bachelor’s degree in business administration and a master’s degree in Hospitality and Tourism Management from Ken State University where she was recognized with the International Alumni Award, which is bestowed to students who have gained global recognition in their respective fields.\n\nApart from her international credentials, Aseel also has a deep understanding of the region, having previously worked in Dubai and Abu Dhabi. She was also part of the inaugural cohort of post graduate employees at NEOM which saw only ten high potential candidates selected from more than 12,000 applicants.\n\nAseel began her career at NEOM within its tourism department, making significant contributions towards its tourism strategy by developing a variety of marketing collateral including compelling audio and visual campaigns. She is now a ‘Rising Star’ in NEOM’s Hotel Development business unit having recently been awarded as such at the inaugural ‘Leaders in Hospitality Awards KSA’ held by Hotel & Catering News Middle East.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                                    "title": "FHS Awards - Winner Announcement",
                                    "beginsAt": "2024-05-01 10:35:00",
                                    "endsAt": "2024-05-01 10:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": [
            "Technology & Innovation"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQxMQ==",
        "titleTranslations": [
            {
                "value": "The Future Workforce: Empowering Talent, Leadership, and Inclusion",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 15:45:00",
        "endsAt": "2025-05-13 16:25:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=tk0YeslLoTk\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "esg",
                "translations": [
                    {
                        "value": "ESG & Human Capital"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Andre",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4Njk4MTY0LFVzZXJfMjEzNDE4Njcp",
                "jobTitle": "Founder & CEO",
                "lastName": "Wiringa",
                "photoUrl": "https://static.swapcard.com/public/images/da31899a1026461a9cb04b6d60b0be52.jpeg",
                "organization": "Start Reverse",
                "biography": "Andre is keynote speaker and Strategy Consultant, working with senior business leaders on Reverse Leadership, Cultural Transformation, Award-winning Customer Experience, as well as Transformational Learning.\n\nHe is the founder of Start Reverse, a boutique consultancy with projects in the region and around the globe. The Reverse philosophy has impacted many leading hotel brands and the (work) lives of hundreds of thousands of leaders and professionals in Hospitality and beyond.\n\nAndre is the heart and mind behind this disruptive approach, boosting relevance, engagement and loyalty. He is also the author of the ‘START REVERSE’ books (The Novel and The Journey).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Amir Ali",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTIwMDY0LFVzZXJfMTA1NTAwNjAp",
                "jobTitle": "Senior Vice President - India, Middle East & Africa",
                "lastName": "Golbarg",
                "photoUrl": "https://static.swapcard.com/public/images/b262847250324bb7bf84f87e8cf6bf6b.jpeg",
                "organization": "Minor Hotel Group Limited",
                "biography": "Amir Golbarg heads up the Middle East & Africa region for Minor Hotels, in addition to the Indian Ocean islands of the Seychelles and Mauritius. Minor Hotels’ global portfolio currently totals 560 hotels in 58 countries and includes the highly-acclaimed luxury Anantara brand and the upscale Avani brand. Amir currently oversees a total of 36 properties across 13 countries in addition to driving the development of the strong pipeline of properties within the region across multiple brands.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Delegate",
                        "withEvent": {
                            "speakerOnPlannings": []
                        }
                    }
                }
            },
            {
                "firstName": "Muin",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3MjI0MDc0LFVzZXJfMjA3ODc2NzAp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Serhan",
                "photoUrl": "https://static.swapcard.com/public/images/2ca186381f1a453c84f2b9e39d502d5b.jpeg",
                "organization": "Amsa Hospitality",
                "biography": "Driving Amsa Hospitality’s business growth as Chief Executive Officer, Muin leverages his 24 years of global experience with leading hotel chains to guide the team toward long-term success. His career as an award-winning hotelier has showcased his ability to build and operate successful mega properties, even in upscale locations. A prolific public speaker, Muin’s achievements have earned him numerous accolades within the hospitality industry both in the Kingdom and abroad.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Benoît-Etienne",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3OTQ3MTI3LFVzZXJfMjM2NTkwNjAp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Domenget",
                "photoUrl": "https://static.swapcard.com/public/images/440ed8fcbcaf42e79a006e97e8553b98.jpeg",
                "organization": "Sommet Education",
                "biography": "Graduating from HEC business school in Paris, Benoît-Etienne Domenget started his career with Accor Group, managing different hotel properties before joining the corporate office as Senior Vice-President Development to head the group’s strategic development in Europe, Middle-East and Africa (EMEA) regions.\nFrom 2011 to 2015, Benoit-Etienne acted as Managing Director of Accor Switzerland, leading the expansion of the brand portfolio in the Swiss market and directly supervising its 55 properties. He was then called to the helm of Michel Reybier Hospitality Group, including luxury hotels such as La Réserve and Victoria-Jungfrau Collection, vineyards and wellness businesses. \nIn January 2017, Benoît-Etienne was appointed CEO of the newly-formed Sommet Education, encompassing the prestigious Swiss hospitality management schools of Glion Institute of Higher Education and Les Roches Global Hospitality Education. The group was founded following the institutions’ acquisition by investment company Eurazeo.\nSince then, he led the acquisition of École Ducasse in 2019, of South African Education leader Invictus and Indian School of Hospitality in 2021 and initiated the expansion of École Ducasse in Bangkok, Abu Dhabi doubling the group global footprint. Under his guidance Sommet Education became the world’s leader in Hospitality and Luxury education with a global network of 5 brands, over 20 campuses, 20 000 students and learners and a network of 60 000 influential alumni with the industry.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Aseem",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MjU5NjUwLFVzZXJfMjA4MTE4ODcp",
                "jobTitle": "Founder & Chief Executive",
                "lastName": "Kapoor",
                "photoUrl": "https://static.swapcard.com/public/images/884c20583e464ec89357946867bc7743.jpeg",
                "organization": "ARK People Solutions",
                "biography": "Aseem Kapoor is Founder & Chief Executive of ARK People Solutions, a consultancy specializing in bringing brands to life through people. He leads a team of hospitality, talent and brand experience professionals who are passionate about creating impact to re-define success for those they work with.\n\nWith a diverse set of leadership experiences, Aseem specialises in crafting agile and innovative business-driven talent and culture functions. Under his leadership, ARK has rapidly grown by creating talent strategies covering all aspects of the people experience, including developing brand culture, and standards, and designing learning content. ARK also excels in crafting customer journey maps, enabling businesses to deliver a consistent brand experience across all touchpoints. ARK also manages mystery shopping, compliance audits and continuous improvement processes to ensure operational excellence.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "ESG & Human Capital"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjY2NTYxOQ==",
        "titleTranslations": [
            {
                "value": "A Net Positive vision for the future of hospitality – and how to achieve it",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 15:45:00",
        "endsAt": "2025-05-13 16:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=hYDefclZkcc\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "esg",
                "translations": [
                    {
                        "value": "ESG & Human Capital"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Caty",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDYyMjY2LFVzZXJfMjQyNzMyNTYp",
                "jobTitle": "Net Positive Innovation Lead",
                "lastName": "Batten",
                "photoUrl": "https://static.swapcard.com/public/images/9319aed7c71b4babb23f9b95cad8c84c.jpeg",
                "organization": "World Sustainable Hospitality Alliance",
                "biography": "Co creating and implementing business strategies to accelerate our collective transition to Net Positive impact, for climate, Nature and people. Equipping leaders with the mindset and tools required to navigate the complexity of our rapidly changing world, helping them transition away from risk toward resilience. ",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "ESG & Human Capital"
        ],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjY2NTc0MA==",
        "titleTranslations": [
            {
                "value": "Curated Connections - Hospitality Education & Talent",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 15:45:00",
        "endsAt": "2025-05-13 16:15:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xNTA4Mzk5OA==",
                "definition": {
                    "isDefault": true,
                    "name": "Type"
                },
                "value": "networking",
                "translations": [
                    {
                        "value": "Networking"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNzQyNjgyOA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "networking-lounge",
                "translations": [
                    {
                        "value": "Networking Lounge"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [],
        "priority": 19
    },
    {
        "id": "UGxhbm5pbmdfMjYwNjExNQ==",
        "titleTranslations": [
            {
                "value": "Beyond Recruitment: Creating Communities, Not Just Workforces",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 16:25:00",
        "endsAt": "2025-05-13 16:40:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=DsK6fljfu_o\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Patrick",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTIwMzUxLFVzZXJfMTU3NzU2MjAp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Smith",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/54f79764c96e4a9eb94fc822fb7bad32.jpeg",
                "organization": "Strive Services Group",
                "biography": "Patrick has been in the region since 2004 and is Chief Operating Officer for Strive Services Group. Along with his team of over 900 staff, he drives the strategic and operational direction of the business.\n\nPatrick is passionate about responding to market conditions with products that meet the demanding challenges of the hospitality sector. He has over 25 years of industry experience, beginning his career at The Savoy Group Management Training Programme and later with full-time consulting roles at PKF and HVS International.\n\nStrive Services Group delivers over 20+ real estate services through its four business divisions: Home Services, Facilities Management, Managed Housing and Property Management.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Mg==",
                                    "title": "TenX Leadership Talks: Redefining Priorities - Why are our People often an Afterthought when it comes to Accommodation?",
                                    "beginsAt": "2024-04-30 17:35:00",
                                    "endsAt": "2024-04-30 17:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Linh K.",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4NzQ3NzA2LFVzZXJfMTc4NjQwMyk=",
                "jobTitle": "Owner & Managing Director",
                "lastName": "Vu",
                "photoUrl": "https://static.swapcard.com/public/images/2e26cd668f984527a1694e1fa6459c8d.jpeg",
                "organization": "Key Hospitality Consulting",
                "biography": "Linh Vu is an international hotel strategist and founder of Key Hospitality Consulting, advising investors and developers on hotel concept development, operator selection, and complex cross-border transactions across Southeast Asia, Europe, and Saudi Arabia. With over 15 years of experience, she has successfully negotiated agreements with leading global operators for a wide range of hospitality assets, from beach resorts to vibrant urban destinations. \n\nA member of the International Society of Hospitality Consultants (ISHC), Linh is also a passionate advocate for talent development. She led a national partnership with Ecole Hôtelière de Lausanne (EHL) to launch vocational training centers that are redefining hospitality education in Vietnam.\n\nShe holds an Executive MBA from Columbia Business School, London Business School, and the University of Hong Kong, and is widely recognized for her negotiation acumen, cross-cultural fluency, and strategic leadership in emerging markets.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjY0NjA0OQ==",
        "titleTranslations": [
            {
                "value": "How to lead your destination to Net Positive: essential ways of ‘thinking, being and doing’ for 2030 and beyond",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 16:30:00",
        "endsAt": "2025-05-13 17:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=QADEng_dR6k\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Caty",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MDYyMjY2LFVzZXJfMjQyNzMyNTYp",
                "jobTitle": "Net Positive Innovation Lead",
                "lastName": "Batten",
                "photoUrl": "https://static.swapcard.com/public/images/9319aed7c71b4babb23f9b95cad8c84c.jpeg",
                "organization": "World Sustainable Hospitality Alliance",
                "biography": "Co creating and implementing business strategies to accelerate our collective transition to Net Positive impact, for climate, Nature and people. Equipping leaders with the mindset and tools required to navigate the complexity of our rapidly changing world, helping them transition away from risk toward resilience. ",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjU2MDQ4Mw==",
        "titleTranslations": [
            {
                "value": "Revitalizing Aging Assets: Maximizing Performance & Energy Efficiency in Hospitality Investments",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 16:40:00",
        "endsAt": "2025-05-13 17:00:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=F_4O6BKx9uM\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "sustainability-and-innovation",
                "translations": [
                    {
                        "value": "Sustainability & Innovation"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yNjYzMzY3Mw==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment-finance-and-real-estate",
                "translations": [
                    {
                        "value": "Investment, Finance & Real Estate "
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Glenn",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5NDk3LFVzZXJfMTU3NTczMjQp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Mandziuk",
                "photoUrl": "https://static.swapcard.com/public/images/b19e8296c97244568fcf237831af441c.jpeg",
                "organization": "World Sustainable Hospitality Alliance",
                "biography": "Glenn Mandziuk is the Chief Executive Officer of the World Sustainable Hospitality Alliance – the leading global network in responsible hospitality. He is an internationally recognised CEO with over 25 years of leadership experience in advancing sustainable practices in tourism, hospitality and economic development, and establishing strategies and programmes that inspire responsible growth. \nWithin his role as CEO of the Alliance, Glenn has led the development of the organisation’s updated Pathway to Net Positive Hospitality, which enables all hotels to work towards having a net positive impact, no matter their starting point. Together with the Alliance’s Head of Business Development, Glenn has substantially expanded the organisation’s network for responsible hospitality, which now represents over 50,000 hotels, equating to 7 million rooms, along with a wide network of over 30 expert partners. What’s more, Glenn has been the pioneer behind multiple high-level Sustainable Hospitality Alliance Summits, which bring together CEO and C-suite leaders from across the Alliance’s membership. Alongside his leadership of the Alliance, Glenn has been chosen to be Co-chair of the Sustainable Markets Initiative Hospitality and Tourism Task Force, alongside Considerate Group Co-founding Partner, Xenia zu Hohenlohe. The Task Force focuses on creating new business models, reducing emissions, and investing in people to support a sustainable hospitality and tourism sector and communities. He has also been appointed as member of the Institute of Tourism and Hospitality Professional (ITHP) Advisory Council, and the International CHRIE Industry Advisory Council (IAC), the first of its kind in the organisation’s 75-year history.\nPrior to becoming CEO of the Sustainable Hospitality Alliance, Glenn was President and Chief Executive Officer of Canada’s Thompson Okanagan Tourism Region (TOTA) with its 4,000 industry stakeholders. Glenn’s leadership resulted in the organisation being recognised as a global champion of excellence and innovation in sustainable destination management and responsible industry development practices. The team received recognition from the United Nations World Tourism Organisation (UNWTO), World Travel and Tourism Council (WTTC), World Travel Awards, and Responsible Tourism Institute’s Biosphere Gold Certification – a first in the Americas. In addition, the UNWTO awarded TOTA Quest Certification for excellence in leadership, execution and governance capacities – only the third such recognition for a destination management organisation bestowed in the world.\nGlenn has 10 years’ experience in the hospitality industry in family-owned and operated hotels and resorts and holds a Master of Environmental Design degree majoring in sustainable tourism planning. He is also a director on the Board of the Global Sustainable Tourism Council and the Responsible Tourism Institute.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2MA==",
                                    "title": "Sustainable Horizons: Catalyzing Change Through Green Investments",
                                    "beginsAt": "2024-04-30 12:25:00",
                                    "endsAt": "2024-04-30 12:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg4MjUwMg==",
                                    "title": "Data Talks: Why ESG data and benchmarking is key to continuing the Hospitality sector's global growth.",
                                    "beginsAt": "2024-04-29 14:35:00",
                                    "endsAt": "2024-04-29 14:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Amr",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MzM1MDYyLFVzZXJfMjMwOTU3MzQp",
                "jobTitle": "Strategy & Growth Director, Project & Development Services, KSA",
                "lastName": "Fakiha",
                "photoUrl": "https://static.swapcard.com/public/images/41a6c6efacdc4eb49a49393f6a210832.jpeg",
                "organization": "JLL",
                "biography": "Amr Fakiha, Strategy & Growth Director at JLL in Saudi Arabia, brings over 21 years of expertise in real estate development, underpinned by an Architectural foundation. His skill set encompasses the entire real estate lifecycle—from project inception to portfolio management. Amr has successfully led a diverse range of projects, including residential communities, master planning, slum regeneration initiatives, hospitality, healthcare, mixed-use, and special economic zone developments. \n\nDedicated to delivering excellence in real estate assets, Amr specializes in optimization strategies, transformative initiatives, and rigorous governance to maximize investment returns. His work significantly aligns with advancing Saudi Arabia’s Vision 2030 goals and fostering economic growth. \n\nAmr is a Professional Member of the Saudi Council of Engineers and holds an Executive Master in Advanced Management Development Program in Real Estate (AMDP) from Harvard University.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Mark",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM5MTAzMzMwLFVzZXJfMjMyNzk1ODQp",
                "jobTitle": "Regional PMC Director",
                "lastName": "Sperring",
                "photoUrl": "https://static.swapcard.com/public/images/6ff1432405ee415bb39673c95d233565.png",
                "organization": "Compass Project Consulting",
                "biography": "Mark Sperring serves as Regional Project Management Consultancy Director at Compass, bringing over 30 years of senior-level experience across 21 countries. He has successfully led major infrastructure, building programs, and mega projects from initial investment to operational readiness in both public and private sectors. His diverse portfolio spans government, health, education, housing, infrastructure, rail, aviation, hospitality, and more.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Sustainability & Innovation",
            "Investment, Finance & Real Estate"
        ]
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQ5MA==",
        "titleTranslations": [
            {
                "value": "From White Label Operators, Franchising to Traditional Management Agreements  - What is the Future?",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 17:00:00",
        "endsAt": "2025-05-13 17:35:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=E8npuOd5Z54\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            },
            {
                "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Topics"
                },
                "value": "investment",
                "translations": [
                    {
                        "value": "Investment & Development"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Tariq",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTIwMTAyLFVzZXJfMTU2NDEzMTkp",
                "jobTitle": "Vice President, KSA",
                "lastName": "Dowidar",
                "photoUrl": "https://cdn-api.swapcard.com/public/images/45881074548642c7881bc4ae6e0a4784.jpeg",
                "organization": "Aleph Hospitality",
                "biography": "A visionary hotelier with strong financial acumen, Tariq has over 26 years’ experience in hospitality management in Saudi Arabia. With an imAttendeesive track record of strategic leadership, he has successfully led multi-cultural, cross-functional teams in pursuit of excellence, most recently at InterContinental. Tariq is responsible for spearheading Aleph Hospitality in Saudi Arabia, supporting the company’s overall growth strategy.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgyMDAxOA==",
                                    "title": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                                    "beginsAt": "2024-05-01 09:15:00",
                                    "endsAt": "2024-05-01 09:50:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "David",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM3NzYzMDY4LFVzZXJfMTYxNjQ2Nzgp",
                "jobTitle": "Senior Vice President Development",
                "lastName": "Thomson",
                "photoUrl": "https://static.swapcard.com/public/images/f1cef20495ca4b618a5c6a58e24af95e.png",
                "organization": "The First Group Hospitality",
                "biography": "One of the region’s most well-known hospitality industry professionals, David is leveraging his talent and vast experience to help drive the growth of The First Group Hospitality which has an impressive portfolio of 12 hotels and hospitality assets.\n\nSince joining The First Group in 2018, David has celebrated several impressive milestones, he established the company’s Hotel Management Division, including overseeing the launch of the firm’s award-winning The First Collection hotel brand.\n\n\nThe first property to open under the innovative lifestyle brand, The First Collection at Jumeirah Village Circle, opened in September 2021, and since then has gone on to forge a reputation as one of the city’s most popular upscale hotels.\n\n\nIn 2022, the hotel was named one of the 25 Hottest New Hotels for 2022 worldwide by TripAdvisor – the world’s largest independent traveller reviews website. The only hotel in the Middle East and Africa to make the list.\n\n\nDavid was also instrumental in delivering the successful opening of the brand’s second and third hotels in 2022 and 2023 and on the 1st July 2024 David oversaw the transition of the Wyndham Dubai Marina to The First Collection Marina.\n\nDavid has also played a key role in driving The First Group Hotels’ sustainability agenda, which has seen properties operating within the portfolio eliminate single-use plastics, reduce energy, food waste and water usage, and increase recycling. All the hotels in the portfolio are Green Key certified.\n\n\nHe is actively developing the firm’s pipeline focusing on third party hotel management as the region transitions from a focus on Hotel Management Agreements with the major brands to franchise agreements.\n\nPrior to his role at The First Group David spent almost 17 years with the Dubai-based JA Resorts & Hotels whose portfolio spans nine hotels and leisure venues across the UAE as well as luxury resorts in the Maldives and Seychelles. In his last 5 years at the company, he was their Chief Operating Officer.\n\n\nIn addition to his professional achievements, David is actively involved in fundraising for charities such as FFLV India, Dubai Autism, Al Noor Centre for Special Needs, Rashid Centre for the Disabled and the All As One Orphanage in Sierra Leone. David is a graduate of Scotland’s University of Stirling, where he earned a Joint Honours Degree",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Scott",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTIwMjA3LFVzZXJfMjMzNjI1MSk=",
                "jobTitle": "Founder",
                "lastName": "Antel",
                "photoUrl": "https://static.swapcard.com/public/images/f8adc05652d6499bb38ba9f43560f107.png",
                "organization": "Scott's Fz",
                "biography": "Scott Antel is a highly respected emerging markets hotels & hospitality lawyer with 25+ years’ experience advising both owners/developers and, less frequently, international operators in the Middle East, Russia/CIS, Africa, Turkey, Eastern Europe and the Caribbean on hotel & resort, branded residential and mixed-use developments.\n\nA former senior partner in DLA Piper and BCLP, Scott regularly advises clients on all aspects of hotel & resort, branded residence and mixed-use development as well as on related operational matters, including litigation.\n\nHe has acted on hundreds of hotel projects including numerous landmark projects such as Sochi 2014, Blue Amber Zanzibar Resort in Zanzibar, Grand Hotel Europe and Astoria Hotel in St Petersburg, the Ritz Carlton and Mandarin Oriental in Moscow, Four Seasons, Mandarin Oriental and Chedi hotels in Oman, JW Marriott and W Yas Island in the UAE, Sofitel and Hyatt in Cyprus and many others projects in numerous locations, including Moscow, St Petersburg, Sochi, Almaty, Istanbul, Bodrum, London, Muscat, Zanzibar, Dubai, Abu Dhabi, Jeddah, Makkah, Riyadh, Tehran, Muscat, Limassol, Crete, Montenegro, Vietnam and ten African countries.\n\nHe also works in the franchise sector advising hotels, restaurants and retail clients and on the structuring and set up of inbound franchise investment in numerous other sectors.\n\nScott is recommended as a \"Leading Adviser\" and \"go to\" hospitality lawyer by Chambers Europe and Legal 500 legal directories and listed in Best Lawyers. He serves on the Advisory Board of the Russian Hotel Investment Forum and is a regular speaker at the event, as well the Berlin IHIF, UAE AHIC and ALIS (US) hotel conferences. Scott is a regularly published thought leader and frequently quoted on hospitality related legal and commercial topics and a regular speaker at industry events and conferences.\n\nScott was recipient of the Russia/CIS Hotel Investment Forum's 2012 “Lifetime Achievement Award” for his contribution in developing the hotel industry in emerging markets, the only lawyer or consultant to ever receive this prestigious award. In 2011 he was elected a member of the International Society of Hospitality Consultants (ISHC).",
                "withEvent": {
                    "eventProfile": {
                        "type": "Moderator",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                                    "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                                    "beginsAt": "2024-04-30 15:35:00",
                                    "endsAt": "2024-04-30 16:15:00"
                                }
                            ]
                        }
                    }
                }
            },
            {
                "firstName": "Victor",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4MDcxODg4LFVzZXJfMjEzNTExMjAp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Abou Ghanem",
                "photoUrl": "https://static.swapcard.com/public/images/52f3140d9d43407580755a2aefbe53d0.jpeg",
                "organization": "Story Hospitality",
                "biography": null,
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            },
            {
                "firstName": "Eddy",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM4NjQwMDUzLFVzZXJfMTU5NTQzNzIp",
                "jobTitle": "Chief Operating Officer",
                "lastName": "Tannous",
                "photoUrl": "https://static.swapcard.com/public/images/0ea10113e8f64d0795d891c9d1769812.jpeg",
                "organization": "Rotana",
                "biography": "Eddy Tannous is the Chief Operating Officer (COO) of Rotana, one of the leading hotel management companies in the region with hotels across the Middle East, Africa, Eastern Europe and Türkiye. In his current position, Tannous is driving the growth and expansion of Rotana and his responsibilities include the successful opening of our new properties and creating synergy among Rotana properties in all aspects of our operations.\nTannous commenced his journey with Rotana in August 2023, bringing with him an extensive background of over 20 years in effectively overseeing hotel\noperations within large hotel groups. His career path has covered significant\npositions within the Middle East's hospitality sector, collaborating with\nwell-known global brands. Most recently, he held the position of Senior Vice\nPresident, Operations, where he supervised operational performance across\nFairmont's Middle East and Asian properties. Prior to that role, Tannous served\nas Vice President, Operations for the Kingdom of Saudi Arabia at Accor, where he managed the country's entire portfolio, comprising over 40 operating hotels and 40 pipeline projects.\nTannous possesses a proven track record of delivering success in various facets of the hospitality industry, encompassing operations, customer satisfaction, strategic expansion, marketing, and more, for some of the region's most renowned hospitality brands.\nAt Rotana, Tannous will continue to strengthen the Rotana brand's presence in\nglobal markets. He remains committed to advancing the group's global footprint while ensuring robust and consistent financial performance, all with the ultimate goal of creating shareholder value.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": null
                    }
                }
            }
        ],
        "categories": [
            "Investment & Development"
        ],
        "priority": 0
    },
    {
        "id": "UGxhbm5pbmdfMjY0NjA1Mg==",
        "titleTranslations": [
            {
                "value": "Local Member Showcase: Net Positive Pathway in Action",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 17:00:00",
        "endsAt": "2025-05-13 17:20:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=JHqz2neqZBY\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": [],
        "priority": 1
    },
    {
        "id": "UGxhbm5pbmdfMjY0NjA1Mw==",
        "titleTranslations": [
            {
                "value": "Taskforce 2030 & Closing Remarks",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 17:20:00",
        "endsAt": "2025-05-13 17:30:00",
        "descriptionTranslations": [
            {
                "value": "<p><a href=\"https://www.youtube.com/watch?v=-3OzMoLEGts\" target=\"_blank\">Click here to watch online</a></p>",
                "language": "en_US"
            }
        ],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "future-stage",
                "translations": [
                    {
                        "value": "Future Stage"
                    }
                ]
            }
        ],
        "speakers": [
            {
                "firstName": "Glenn",
                "id": "U3BlYWtlcihFdmVudF8xOTkyMjcyLEV2ZW50UGVvcGxlXzM2OTE5NDk3LFVzZXJfMTU3NTczMjQp",
                "jobTitle": "Chief Executive Officer",
                "lastName": "Mandziuk",
                "photoUrl": "https://static.swapcard.com/public/images/b19e8296c97244568fcf237831af441c.jpeg",
                "organization": "World Sustainable Hospitality Alliance",
                "biography": "Glenn Mandziuk is the Chief Executive Officer of the World Sustainable Hospitality Alliance – the leading global network in responsible hospitality. He is an internationally recognised CEO with over 25 years of leadership experience in advancing sustainable practices in tourism, hospitality and economic development, and establishing strategies and programmes that inspire responsible growth. \nWithin his role as CEO of the Alliance, Glenn has led the development of the organisation’s updated Pathway to Net Positive Hospitality, which enables all hotels to work towards having a net positive impact, no matter their starting point. Together with the Alliance’s Head of Business Development, Glenn has substantially expanded the organisation’s network for responsible hospitality, which now represents over 50,000 hotels, equating to 7 million rooms, along with a wide network of over 30 expert partners. What’s more, Glenn has been the pioneer behind multiple high-level Sustainable Hospitality Alliance Summits, which bring together CEO and C-suite leaders from across the Alliance’s membership. Alongside his leadership of the Alliance, Glenn has been chosen to be Co-chair of the Sustainable Markets Initiative Hospitality and Tourism Task Force, alongside Considerate Group Co-founding Partner, Xenia zu Hohenlohe. The Task Force focuses on creating new business models, reducing emissions, and investing in people to support a sustainable hospitality and tourism sector and communities. He has also been appointed as member of the Institute of Tourism and Hospitality Professional (ITHP) Advisory Council, and the International CHRIE Industry Advisory Council (IAC), the first of its kind in the organisation’s 75-year history.\nPrior to becoming CEO of the Sustainable Hospitality Alliance, Glenn was President and Chief Executive Officer of Canada’s Thompson Okanagan Tourism Region (TOTA) with its 4,000 industry stakeholders. Glenn’s leadership resulted in the organisation being recognised as a global champion of excellence and innovation in sustainable destination management and responsible industry development practices. The team received recognition from the United Nations World Tourism Organisation (UNWTO), World Travel and Tourism Council (WTTC), World Travel Awards, and Responsible Tourism Institute’s Biosphere Gold Certification – a first in the Americas. In addition, the UNWTO awarded TOTA Quest Certification for excellence in leadership, execution and governance capacities – only the third such recognition for a destination management organisation bestowed in the world.\nGlenn has 10 years’ experience in the hospitality industry in family-owned and operated hotels and resorts and holds a Master of Environmental Design degree majoring in sustainable tourism planning. He is also a director on the Board of the Global Sustainable Tourism Council and the Responsible Tourism Institute.",
                "withEvent": {
                    "eventProfile": {
                        "type": "Speaker",
                        "withEvent": {
                            "speakerOnPlannings": [
                                {
                                    "id": "UGxhbm5pbmdfMTgwOTM2MA==",
                                    "title": "Sustainable Horizons: Catalyzing Change Through Green Investments",
                                    "beginsAt": "2024-04-30 12:25:00",
                                    "endsAt": "2024-04-30 12:50:00"
                                },
                                {
                                    "id": "UGxhbm5pbmdfMTg4MjUwMg==",
                                    "title": "Data Talks: Why ESG data and benchmarking is key to continuing the Hospitality sector's global growth.",
                                    "beginsAt": "2024-04-29 14:35:00",
                                    "endsAt": "2024-04-29 14:50:00"
                                }
                            ]
                        }
                    }
                }
            }
        ],
        "categories": []
    },
    {
        "id": "UGxhbm5pbmdfMjQ3NjQxNg==",
        "titleTranslations": [
            {
                "value": "Closing Plenary: The Road Ahead for Global Hospitality",
                "language": "en_US"
            }
        ],
        "beginsAt": "2025-05-13 17:35:00",
        "endsAt": "2025-05-13 17:40:00",
        "descriptionTranslations": [],
        "format": "PHYSICAL",
        "fields": [
            {
                "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
                "definition": {
                    "isDefault": true,
                    "name": "Location"
                },
                "value": "summit-stage",
                "translations": [
                    {
                        "value": "Summit Stage"
                    }
                ]
            }
        ],
        "speakers": [],
        "categories": []
    }
]